import React, { useMemo, useState, useEffect, useRef } from "react";
import {
  Button,
  Card,
  CardContent,
  IconButton,
  Popover,
  Tooltip,
  Typography,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import CloseIcon from "@material-ui/icons/Close";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import CheckIcon from "@material-ui/icons/Check";
import UndoIcon from "@material-ui/icons/Undo";
import CancelIcon from "@material-ui/icons/Cancel";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import FilterListIcon from "@material-ui/icons/FilterList";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ScheduleIcon from "@material-ui/icons/Schedule";
import UpdateIcon from "@material-ui/icons/Update";
import PeopleIcon from "@material-ui/icons/People";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import InfoIcon from "@material-ui/icons/Info";
import PersonAddDisabledIcon from "@material-ui/icons/PersonAddDisabled";
import FontAwesomeIconComponent from "../Layouts/FontAwesomeIconComponent";
import { Calendar, Views, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./DashboardCalendar.css";
import swal from "sweetalert";
import AuthApi from "../Services/Authapi";
import ls from "local-storage";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { getCalendarColorSettings, fetchAndSyncCalendarColors, CALENDAR_COLORS_STORAGE_EVENT } from "../../utils/calendarColorSettings";
import DdMmYyyyDateField from "../../utils/DdMmYyyyDateField";
import { promptRejectionRemark } from "./UserCheck/Check";
import { createSwalLoaderNode } from "../Layouts/swalLoader";

const localizer = momentLocalizer(moment);
export const renderTextWithLinks = (text) => {
  if (!text) return null;
  const str = String(text);

  const urlRegex = /((?:https?:\/\/|www\.)[^\s<]+|(?:[a-zA-Z0-9-]+\.)+(?:com|org|net|io|edu|gov|co|in|us|uk|app|dev|me|tech)\/[^\s<]*|(?:meet\.google\.com|zoom\.us|teams\.microsoft\.com)[^\s<]*)/gi;
  const isUrlPattern = /^(?:https?:\/\/|www\.|(?:[a-zA-Z0-9-]+\.)+(?:com|org|net|io|edu|gov|co|in|us|uk|app|dev|me|tech)\/)/i;

  const parts = str.split(urlRegex);

  if (parts.length <= 1) {
    return str;
  }

  return parts.map((part, index) => {
    if (!part) return null;
    if (isUrlPattern.test(part)) {
      let urlStr = part;
      let trailingPunct = "";

      const matchPunct = urlStr.match(/([.,!?;:)]+)$/);
      if (matchPunct) {
        trailingPunct = matchPunct[1];
        urlStr = urlStr.slice(0, -trailingPunct.length);
      }

      const href = /^https?:\/\//i.test(urlStr) ? urlStr : `https://${urlStr}`;

      return (
        <React.Fragment key={`url-${index}`}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#036dda",
              textDecoration: "underline",
              wordBreak: "break-all",
              fontWeight: 500,
              cursor: "pointer"
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {urlStr}
          </a>
          {trailingPunct}
        </React.Fragment>
      );
    }
    return part;
  });
};

const ALL_DAY_CATEGORIES = ["event", "holiday", "leave", "reminder", "calendar", "birthday", "bday"];

const parseTargetUserIds = (event = {}) => {
  const desc = String(event?.description || event?.Description || event?.details || event?.Details || event?.resource?.description || event?.resource?.Description || "");
  const embeddedMatch = desc.match(/\[targets:([^\]]+)\]/i) || desc.match(/\[target_users:([^\]]+)\]/i);
  if (embeddedMatch && embeddedMatch[1]) {
    const ids = embeddedMatch[1].split(",").map((id) => id.trim()).filter(Boolean);
    if (ids.length > 0) return ids;
  }

  const rawTargetUsers =
    event?.target_user_ids ??
    event?.TargetUserIds ??
    event?.targetUserIds ??
    event?.target_users ??
    event?.targetUsers ??
    event?.user_ids ??
    event?.userIds ??
    event?.users ??
    event?.people ??
    event?.assigned_to ??
    event?.assignedTo ??
    event?.assigned_users ??
    event?.assignedUsers ??
    event?.participants ??
    event?.members ??
    event?.resource?.target_user_ids ??
    event?.resource?.TargetUserIds ??
    event?.resource?.targetUserIds ??
    event?.resource?.target_users ??
    event?.resource?.targetUsers ??
    event?.resource?.user_ids ??
    event?.resource?.userIds ??
    event?.resource?.users ??
    event?.resource?.people ??
    event?.resource?.assigned_to ??
    event?.resource?.assignedTo ??
    event?.resource?.assigned_users ??
    event?.resource?.assignedUsers ??
    event?.resource?.participants ??
    event?.resource?.members ??
    [];

  if (typeof rawTargetUsers === "number") {
    return [String(rawTargetUsers)];
  }

  if (Array.isArray(rawTargetUsers)) {
    return rawTargetUsers
      .map((id) => {
        if (typeof id === "object" && id !== null) {
          return String(id.id ?? id.value ?? id.userId ?? id.user_id ?? "");
        }
        return String(id);
      })
      .filter(Boolean);
  }

  if (typeof rawTargetUsers === "string") {
    const trimmed = rawTargetUsers.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed
          .map((id) => {
            if (typeof id === "object" && id !== null) {
              return String(id.id ?? id.value ?? id.userId ?? id.user_id ?? "");
            }
            return String(id);
          })
          .filter(Boolean);
      }
      if (typeof parsed === "number" || typeof parsed === "string") {
        return [String(parsed)];
      }
    } catch (error) {
      // Fallback for non-JSON strings
    }
    return trimmed
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
  }

  return [];
};

const getCleanDescriptionText = (descStr = "") => {
  if (!descStr) return "";
  return String(descStr)
    .replace(/\[targets:[^\]]+\]/gi, "")
    .replace(/\[target_users:[^\]]+\]/gi, "")
    .replace(/\[category:[^\]]+\]/gi, "")
    .replace(/\[updated_by:[^\]]+\]/gi, "")
    .replace(/\[updated_by_name:[^\]]+\]/gi, "")
    .trim();
};

const getEventOwnerId = (event = {}) => (
  event?.user_id ??
  event?.userId ??
  event?.UserId ??
  event?.created_by ??
  event?.createdBy ??
  event?.employee_id ??
  event?.employeeId ??
  event?.author_id ??
  event?.authorId ??
  null
);

const getShowToAll = (event = {}) => {
  const rawValue = event?.showToAll ?? event?.show_to_all ?? event?.ShowToAll ?? event?.show_all;
  if (typeof rawValue === "undefined" || rawValue === null || rawValue === "") return null;
  if (typeof rawValue === "boolean") return rawValue;
  if (typeof rawValue === "number") return rawValue === 1;
  const norm = String(rawValue).trim().toLowerCase();
  if (["1", "true", "yes"].includes(norm)) return true;
  if (["0", "false", "no"].includes(norm)) return false;
  return null;
};

const isMeetingNotAssignedToAdmin = (event = {}, isAdmin = false, currentUserId = null) => {
  if (!isAdmin) return false;
  const originalEvent = event?.resource || event || {};
  const category = String(event?.category || originalEvent.Category || originalEvent.category || "").toLowerCase();
  const rawTitle = String(getEventTitleValue(originalEvent) || event?.title || "").toLowerCase();
  const rawDesc = String(originalEvent.description || originalEvent.Description || "").toLowerCase();

  const isMeeting =
    category === "meeting" ||
    rawTitle.startsWith("meeting") ||
    rawTitle.includes("meeting") ||
    rawTitle.includes("scrum") ||
    rawDesc.includes("[category:meeting]") ||
    rawDesc.includes("category:meeting");

  if (!isMeeting) return false;

  const ownerId = getEventOwnerId(originalEvent);
  if (ownerId !== null && currentUserId !== null && String(ownerId) === String(currentUserId)) {
    return false;
  }

  const showToAll = getShowToAll(originalEvent);
  if (showToAll) {
    return false;
  }

  const targetUserIds = parseTargetUserIds(originalEvent);
  if (currentUserId !== null && targetUserIds.includes(String(currentUserId))) {
    return false;
  }

  return true;
};

const getEventRecencyScore = (event = {}) => {
  const resource = event.resource || event;

  const rawCreatedAt = resource.created_at || resource.createdAt || resource.createdDate || resource.created_date;
  if (rawCreatedAt) {
    const m = moment(rawCreatedAt);
    if (m.isValid()) return m.valueOf();
  }

  const rawUpdatedAt = resource.updated_at || resource.updatedAt || resource.updatedDate;
  if (rawUpdatedAt) {
    const m = moment(rawUpdatedAt);
    if (m.isValid()) return m.valueOf();
  }

  const rawId = resource.id ?? resource.Id ?? resource.calendar_event_id ?? resource.calendarEventId ?? resource.event_id ?? resource.eventId ?? resource.SourceId ?? resource.sourceId ?? event.id ?? "";
  const numId = parseInt(String(rawId).replace(/\D+/g, ""), 10);
  if (!isNaN(numId) && numId > 0) {
    return numId;
  }

  return 0;
};

const getEventAuditMetadata = (event = {}, allUsers = []) => {
  const resource = {
    ...(event?.resource || {}),
    ...event,
  };

  // Creator
  const rawCreatedBy =
    resource.created_by_name ||
    resource.createdByName ||
    resource.creator_name ||
    resource.creatorName ||
    resource.userName ||
    resource.user_name ||
    resource.firstName ||
    resource.first_name ||
    resource.employeeName ||
    resource.employee_name ||
    resource.created_by ||
    resource.createdBy ||
    resource.user_id ||
    resource.userId ||
    resource.employee_id ||
    resource.employeeId;

  let createdByName = "System / Admin";
  if (rawCreatedBy) {
    if (typeof rawCreatedBy === "number" || (typeof rawCreatedBy === "string" && /^\d+$/.test(rawCreatedBy.trim()))) {
      const foundUser = findUserInList(rawCreatedBy, allUsers);
      createdByName = foundUser ? getUserDisplayName(foundUser, rawCreatedBy) : `User ${rawCreatedBy}`;
    } else {
      createdByName = String(rawCreatedBy).trim();
    }
  }

  // Fallback for creator name if System/Admin or missing
  if ((createdByName === "System / Admin" || !rawCreatedBy) && typeof localStorage !== "undefined") {
    try {
      const storedStr = localStorage.getItem("hrms_updated_dashboard_calendar_items");
      if (storedStr) {
        const storedObj = JSON.parse(storedStr);
        const eventId = resource.id || resource.calendar_event_id || event.id;
        const titleKey = String(resource.title || resource.Subject || event.title || "").trim().toLowerCase();

        for (const key in storedObj) {
          const item = storedObj[key];
          if (item && (item.created_by_name || item.createdByName)) {
            if ((eventId && key.includes(String(eventId))) || (titleKey && titleKey.length > 2 && key.toLowerCase().includes(titleKey))) {
              createdByName = item.created_by_name || item.createdByName;
              break;
            }
          }
        }
      }
    } catch (e) {
      // ignore
    }
  }

  const rawCreatedAt =
    resource.created_at ||
    resource.createdAt ||
    resource.createdDate ||
    resource.created_date ||
    resource.created_on ||
    resource.createdOn ||
    resource.entry_date ||
    resource.entryDate ||
    resource.added_on ||
    resource.addedOn ||
    resource.added_at ||
    resource.addedAt ||
    resource.create_at ||
    resource.createAt ||
    resource.date_created ||
    resource.dateCreated ||
    resource.CreatedDate ||
    resource.CreateDate;

  let createdAtFormatted = null;
  if (rawCreatedAt && String(rawCreatedAt).trim() !== "N/A" && String(rawCreatedAt).trim() !== "null" && String(rawCreatedAt).trim() !== "undefined") {
    const m = moment(rawCreatedAt);
    if (m.isValid()) {
      createdAtFormatted = m.format(hasExplicitTime(rawCreatedAt) ? "MMM DD, YYYY hh:mm A" : "MMM DD, YYYY");
    } else {
      createdAtFormatted = String(rawCreatedAt);
    }
  }

  if (!createdAtFormatted) {
    try {
      const storedStr = localStorage.getItem("hrms_updated_dashboard_calendar_items");
      if (storedStr) {
        const storedObj = JSON.parse(storedStr);
        const eventId = resource.id || resource.calendar_event_id || event.id;
        const titleKey = String(resource.title || resource.Subject || event.title || "").trim().toLowerCase();

        for (const key in storedObj) {
          const item = storedObj[key];
          if (item && (item.created_at || item.createdAt)) {
            if ((eventId && key.includes(String(eventId))) || (titleKey && titleKey.length > 2 && key.toLowerCase().includes(titleKey))) {
              const localCreated = item.created_at || item.createdAt;
              const m = moment(localCreated);
              if (m.isValid()) {
                createdAtFormatted = m.format("MMM DD, YYYY hh:mm A");
                break;
              }
            }
          }
        }
      }
    } catch (e) {
      // ignore
    }
  }

  if (!createdAtFormatted) {
    // DO NOT use event.start or resource.StartTime or resource.date (which is the meeting date!).
    // Creation date fallback must be the actual creation date when added (today).
    createdAtFormatted = moment().format("MMM DD, YYYY");
  }

  // Updater
  const rawUpdatedBy =
    resource.updated_by_name ||
    resource.updatedByName ||
    resource.updater_name ||
    resource.updaterName ||
    resource.modified_by_name ||
    resource.modifiedByName ||
    resource.updated_by ||
    resource.updatedBy ||
    resource.modified_by ||
    resource.modifiedBy ||
    resource.update_by ||
    resource.UpdateBy ||
    resource.update_by_name ||
    resource.UpdateByName;

  let updatedByName = null;
  if (rawUpdatedBy && String(rawUpdatedBy).trim() !== "Not Updated" && String(rawUpdatedBy).trim() !== "" && String(rawUpdatedBy).trim() !== "null" && String(rawUpdatedBy).trim() !== "undefined") {
    if (typeof rawUpdatedBy === "number" || (typeof rawUpdatedBy === "string" && /^\d+$/.test(rawUpdatedBy.trim()))) {
      const foundUser = findUserInList(rawUpdatedBy, allUsers);
      updatedByName = foundUser ? getUserDisplayName(foundUser, rawUpdatedBy) : `User ${rawUpdatedBy}`;
    } else {
      updatedByName = String(rawUpdatedBy).trim();
    }
  }

  const rawUpdatedAt =
    resource.updated_at ||
    resource.updatedAt ||
    resource.updatedDate ||
    resource.updated_date ||
    resource.modified_at ||
    resource.modifiedAt ||
    resource.modified_date ||
    resource.modifiedDate ||
    resource.modified_on ||
    resource.modifiedOn ||
    resource.updated_on ||
    resource.updatedOn ||
    resource.update_at ||
    resource.UpdateAt;

  let updatedAtFormatted = null;
  if (rawUpdatedAt && String(rawUpdatedAt).trim() !== "Not Updated" && String(rawUpdatedAt).trim() !== "" && String(rawUpdatedAt).trim() !== "null" && String(rawUpdatedAt).trim() !== "undefined") {
    const m = moment(rawUpdatedAt);
    if (m.isValid()) {
      updatedAtFormatted = m.format("MMM DD, YYYY hh:mm A");
    } else {
      updatedAtFormatted = String(rawUpdatedAt);
    }
  }

  // Extract embedded updater metadata tags from description if present
  const fullDescriptionStr = String(
    resource.description ||
    resource.Description ||
    resource.details ||
    event?.description ||
    ""
  );

  let embeddedUpdatedByName = null;
  let embeddedUpdatedById = null;
  if (fullDescriptionStr) {
    const nameMatch = fullDescriptionStr.match(/\[updated_by_name:([^\]]+)\]/i);
    if (nameMatch && nameMatch[1]) {
      embeddedUpdatedByName = nameMatch[1].trim();
    }
    const idMatch = fullDescriptionStr.match(/\[updated_by:([^\]]+)\]/i);
    if (idMatch && idMatch[1]) {
      embeddedUpdatedById = idMatch[1].trim();
    }
  }

  if (embeddedUpdatedByName) {
    updatedByName = embeddedUpdatedByName;
  } else if (embeddedUpdatedById) {
    const foundUser = findUserInList(embeddedUpdatedById, allUsers);
    if (foundUser) {
      updatedByName = getUserDisplayName(foundUser, embeddedUpdatedById);
    }
  }

  // Determine if the item has actually been updated after creation
  let isActuallyUpdated = false;
  if (resource.is_updated || resource.isUpdated || embeddedUpdatedByName || embeddedUpdatedById) {
    isActuallyUpdated = true;
  } else if (rawUpdatedBy && String(rawUpdatedBy).trim() !== "Not Updated" && String(rawUpdatedBy).trim() !== "0" && String(rawUpdatedBy).trim() !== "null" && String(rawUpdatedBy).trim() !== "undefined") {
    if (updatedByName && createdByName && updatedByName !== createdByName) {
      isActuallyUpdated = true;
    } else if (rawCreatedAt && rawUpdatedAt) {
      const mCreated = moment(rawCreatedAt);
      const mUpdated = moment(rawUpdatedAt);
      if (mCreated.isValid() && mUpdated.isValid() && mUpdated.diff(mCreated, 'seconds') > 60) {
        isActuallyUpdated = true;
      }
    }
  } else if (rawCreatedAt && rawUpdatedAt) {
    const mCreated = moment(rawCreatedAt);
    const mUpdated = moment(rawUpdatedAt);
    if (mCreated.isValid() && mUpdated.isValid() && mUpdated.diff(mCreated, 'seconds') > 60) {
      isActuallyUpdated = true;
    }
  }

  const isUpdated = isActuallyUpdated;

  if (isUpdated) {
    if (!updatedByName || updatedByName === createdByName) {
      const updatedById = resource.updated_by || resource.updatedBy || resource.modified_by || resource.modifiedBy;
      if (updatedById) {
        const foundUser = findUserInList(updatedById, allUsers);
        if (foundUser) {
          updatedByName = getUserDisplayName(foundUser, updatedById);
        }
      }

      if (!updatedByName || updatedByName === createdByName) {
        try {
          const storedStr = typeof localStorage !== "undefined" ? localStorage.getItem("hrms_updated_dashboard_calendar_items") : null;
          if (storedStr) {
            const storedObj = JSON.parse(storedStr);
            const eventId = resource.id || resource.calendar_event_id || event?.id || resource.SourceId;
            const titleKey = String(resource.title || resource.Subject || event?.title || "").trim().toLowerCase();

            for (const key in storedObj) {
              const item = storedObj[key];
              if (item && (item.updated_by_name || item.updatedByName || item.updater_name)) {
                const itemUpdater = item.updated_by_name || item.updatedByName || item.updater_name;
                if ((eventId && key.includes(String(eventId))) || (titleKey && titleKey.length > 2 && key.toLowerCase().includes(titleKey))) {
                  updatedByName = itemUpdater;
                  break;
                }
              }
            }
          }
        } catch (e) {
          // ignore
        }
      }

      if (!updatedByName) {
        const adminUser = (allUsers || []).find((u) => {
          const r = String(u.role || u.user_role || u.role_name || u.roles || "").toLowerCase();
          const name = String(u.firstName || u.first_name || u.name || "").toLowerCase();
          return r.includes("admin") || name.includes("chandresh");
        });

        if (adminUser) {
          updatedByName = getUserDisplayName(adminUser, adminUser.id);
        } else {
          updatedByName = "Chandresh Maheshwari";
        }
      }
    }
    if (!updatedAtFormatted) updatedAtFormatted = createdAtFormatted;
  }

  return {
    createdBy: createdByName,
    createdAt: createdAtFormatted,
    updatedBy: updatedByName,
    updatedAt: updatedAtFormatted,
    isUpdated,
  };
};

const createEmptyAddPopoverState = () => ({
  anchorPosition: null,
  start: null,
  end: null,
  formattedDate: "",
  mode: "create",
  eventId: null,
  eventMeta: null,
});

const createEmptyEventDetailsState = () => ({
  anchorPosition: null,
  event: null,
});

const hasExplicitTime = (value) => {
  if (!value) {
    return false;
  }

  const parsed = moment(value);
  return parsed.isValid() && (
    parsed.hours() !== 0 ||
    parsed.minutes() !== 0 ||
    parsed.seconds() !== 0 ||
    parsed.milliseconds() !== 0
  );
};

const getRawAllDayFlag = (evt = {}) => {
  if (!evt) return undefined;
  const val = evt.IsAllDay ?? evt.isAllDay ?? evt.is_all_day;
  if (val === undefined || val === null || val === "") return undefined;
  if (typeof val === "boolean") return val;
  if (typeof val === "number") return val === 1;
  const str = String(val).trim().toLowerCase();
  if (["1", "true", "yes"].includes(str)) return true;
  if (["0", "false", "no"].includes(str)) return false;
  return undefined;
};

const parseCalendarDateValue = (value, treatAsAllDayDate = false) => {
  if (!value) {
    return moment.invalid();
  }

  if (moment.isMoment(value)) {
    return value.clone();
  }

  if (value instanceof Date) {
    return moment(value);
  }

  if (typeof value === "string") {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      return moment.invalid();
    }

    const isoDateMatch = trimmedValue.match(/^(\d{4}-\d{2}-\d{2})/);
    if (treatAsAllDayDate && isoDateMatch) {
      return moment(isoDateMatch[1], "YYYY-MM-DD", true);
    }

    const ddmmyyyyMatch = trimmedValue.match(/^(\d{2})[-/](\d{2})[-/](\d{4})/);
    if (treatAsAllDayDate && ddmmyyyyMatch) {
      return moment(`${ddmmyyyyMatch[3]}-${ddmmyyyyMatch[2]}-${ddmmyyyyMatch[1]}`, "YYYY-MM-DD", true);
    }

    return moment(value);
  }
};

const getLeaveEventNoOfDays = (event = {}) => {
  const resource = event.resource || event;
  const startValue = resource?.leave_start_date || resource?.startDate || resource?.StartTime || event?.start;
  const endValue = resource?.leave_end_date || resource?.endDate || resource?.EndTime || event?.end || startValue;
  const firstHalfType = String(resource?.firstleavetype || "").toLowerCase();
  const secondHalfType = String(resource?.secondleavetype || "").toLowerCase();
  const isHalfDay = (
    (firstHalfType === "first-half" && secondHalfType === "first-half") ||
    (firstHalfType === "second-half" && secondHalfType === "second-half")
  );

  const startMoment = parseCalendarDateValue(startValue, true);
  const endMoment = parseCalendarDateValue(endValue, true);

  let mondayOrFridayCount = 0;
  if (startMoment.isValid() && endMoment.isValid()) {
    let curr = startMoment.clone().startOf("day");
    const last = endMoment.clone().startOf("day");
    while (curr.isSameOrBefore(last, "day")) {
      const dayOfWeek = curr.isoWeekday();
      if (dayOfWeek === 1 || dayOfWeek === 5) {
        mondayOrFridayCount++;
      }
      curr.add(1, "day");
    }
  }

  const directValue =
    resource?.NoOfDays ??
    resource?.no_of_days ??
    resource?.noOfDays ??
    event?.NoOfDays ??
    event?.no_of_days ??
    event?.noOfDays;

  if (directValue !== undefined && directValue !== null && directValue !== "") {
    const numDirect = parseFloat(directValue);
    if (!isNaN(numDirect)) {
      if (mondayOrFridayCount > 0) {
        if (numDirect === 1 && !isHalfDay) {
          return 1.5;
        }
        if (numDirect === 0.5 || isHalfDay) {
          return Math.max(numDirect + 0.5, 1);
        }
      }
      return numDirect;
    }
    return directValue;
  }

  if (startMoment.isValid() && endMoment.isValid()) {
    const baseDays = isHalfDay ? 0.5 : Math.max(1, endMoment.startOf("day").diff(startMoment.startOf("day"), "days") + 1);
    return baseDays + (mondayOrFridayCount * 0.5);
  }
  return null;
};
const getEventTitleValue = (event = {}) => {
  const specificName =
    event.upcomingEventName ||
    event.upcoming_event_name ||
    event.eventName ||
    event.event_name ||
    event.meetingName ||
    event.meeting_name ||
    event.name ||
    event.Name ||
    event.Subject ||
    event.subject;

  if (specificName && String(specificName).trim()) {
    return String(specificName).trim();
  }

  const rawTitle = event.title || event.Title || "";
  return String(rawTitle).replace(/^(title|reminder|calendar|event|meeting|leave|holiday|birthday|bday)\s*[-:]\s*/i, "").trim();
};

const getCurrentUserData = () => {
  try {
    const user = ls.get("user") || {};
    const id = user.id ?? user.Id ?? user.user_id ?? user.userId;
    if (id) {
      const name = (
        user.firstName
          ? `${user.firstName} ${user.lastName || ''}`
          : (user.name || user.username || user.email || `User ${id}`)
      ).trim();
      return { value: id, label: name };
    }
  } catch (e) {
    // ignore
  }
  return null;
};

const getCurrentUserId = () => {
  try {
    const user = ls.get("user");
    return user?.id ?? user?.Id ?? user?.user_id ?? user?.userId ?? null;
  } catch (e) {
    return null;
  }
};

const getStoredMeetingTargetUsers = (rawEvent = {}) => {
  try {
    const explicitId = rawEvent.calendar_event_id ?? rawEvent.calendarEventId ?? rawEvent.event_id ?? rawEvent.eventId ?? rawEvent.Id ?? rawEvent.id;
    const cleanNumericId = explicitId ? String(explicitId).replace(/^meeting-/i, "") : null;
    const rawTitle = String(getEventTitleValue(rawEvent) || rawEvent.title || "").trim().toLowerCase().replace(/^(meeting|title|reminder|calendar|event|holiday|leave)\s*[-:]\s*/i, "");
    const start = String(rawEvent.StartTime || rawEvent.startTime || rawEvent.startDate || rawEvent.start || rawEvent.date || "").trim().split(" ")[0];

    const keysToTry = [];
    if (explicitId) keysToTry.push(`ems_meeting_target_users_id_${explicitId}`);
    if (cleanNumericId) keysToTry.push(`ems_meeting_target_users_id_${cleanNumericId}`);
    if (rawTitle && start) keysToTry.push(`ems_meeting_target_users_key_${rawTitle}_${start}`);
    if (rawTitle) keysToTry.push(`ems_meeting_target_users_title_${rawTitle}`);

    for (const key of keysToTry) {
      let stored = ls.get(key);
      if (!stored || !Array.isArray(stored) || stored.length === 0) {
        try {
          const rawLocal = localStorage.getItem(key);
          if (rawLocal) stored = JSON.parse(rawLocal);
        } catch (e) {}
      }
      if (!stored || !Array.isArray(stored) || stored.length === 0) {
        try {
          const rawSess = sessionStorage.getItem(key);
          if (rawSess) stored = JSON.parse(rawSess);
        } catch (e) {}
      }
      if (Array.isArray(stored) && stored.length > 0) {
        return stored;
      }
    }
  } catch (e) {
    // ignore
  }
  return null;
};

const saveStoredMeetingTargetUsers = (rawEvent = {}, targetUsersList = []) => {
  try {
    const explicitId = rawEvent.calendar_event_id ?? rawEvent.calendarEventId ?? rawEvent.event_id ?? rawEvent.eventId ?? rawEvent.Id ?? rawEvent.id;
    const cleanNumericId = explicitId ? String(explicitId).replace(/^meeting-/i, "") : null;
    const rawTitle = String(getEventTitleValue(rawEvent) || rawEvent.title || "").trim().toLowerCase().replace(/^(meeting|title|reminder|calendar|event|holiday|leave)\s*[-:]\s*/i, "");
    const start = String(rawEvent.StartTime || rawEvent.startTime || rawEvent.startDate || rawEvent.start || rawEvent.date || "").trim().split(" ")[0];

    if (Array.isArray(targetUsersList) && targetUsersList.length > 0) {
      const keysToSave = [];
      if (explicitId) keysToSave.push(`ems_meeting_target_users_id_${explicitId}`);
      if (cleanNumericId) keysToSave.push(`ems_meeting_target_users_id_${cleanNumericId}`);
      if (rawTitle && start) keysToSave.push(`ems_meeting_target_users_key_${rawTitle}_${start}`);
      if (rawTitle) keysToSave.push(`ems_meeting_target_users_title_${rawTitle}`);

      const jsonStr = JSON.stringify(targetUsersList);
      keysToSave.forEach((key) => {
        try { ls.set(key, targetUsersList); } catch (e) {}
        try { localStorage.setItem(key, jsonStr); } catch (e) {}
        try { sessionStorage.setItem(key, jsonStr); } catch (e) {}
      });
    }
  } catch (e) {
    // ignore
  }
};

const findUserInList = (uId, userList = []) => {
  if (typeof uId === "undefined" || uId === null || uId === "" || !Array.isArray(userList)) return null;
  return userList.find((u) => {
    if (!u) return false;
    const candidateId = u.id ?? u.Id ?? u.userId ?? u.user_id ?? u.employee_id ?? u.value;
    return String(candidateId) === String(uId);
  });
};

const getUserDisplayName = (userObj, fallbackId = "") => {
  if (!userObj) return fallbackId ? `User ${fallbackId}` : "";
  if (typeof userObj === "string") return userObj.trim();
  if (userObj.label && !userObj.label.startsWith("User ")) return userObj.label.trim();
  const fullName = [userObj.firstName || userObj.first_name, userObj.lastName || userObj.last_name].filter(Boolean).join(" ").trim();
  if (fullName) return fullName;
  const simpleName = userObj.name || userObj.userName || userObj.username || userObj.employeeName || userObj.employee_name || userObj.email;
  if (simpleName) return String(simpleName).trim();
  return fallbackId ? `User ${fallbackId}` : "";
};

const resolveTargetUsersForEdit = (rawEvent = {}, allUsers = [], providedUserId = null) => {
  const currentUserId = providedUserId || getCurrentUserId();

  const effectiveAllUsers = (allUsers && allUsers.length > 0)
    ? allUsers
    : (() => {
        const currentUser = getCurrentUserData();
        return currentUser ? [{ id: currentUser.value, firstName: currentUser.label }] : [];
      })();

  const formatUserOption = (pId, defaultObj = null) => {
    const found = findUserInList(pId, effectiveAllUsers);
    const targetObj = found || defaultObj;
    return {
      value: targetObj ? (targetObj.id ?? targetObj.Id ?? targetObj.userId ?? targetObj.user_id ?? targetObj.value ?? pId) : pId,
      label: getUserDisplayName(targetObj, pId),
    };
  };

  const parsedIds = parseTargetUserIds(rawEvent);

  if (parsedIds.length > 0) {
    if (allUsers && allUsers.length > 1 && parsedIds.length >= allUsers.length) {
      return allUsers.map((u) => ({
        value: u.id ?? u.Id ?? u.userId ?? u.user_id,
        label: getUserDisplayName(u, u.id),
      }));
    }

    const matched = parsedIds.map((pId) => formatUserOption(pId));
    if (matched.length > 0) {
      return matched;
    }
  }

  const rawTargetUsers =
    rawEvent?.target_user_ids ??
    rawEvent?.TargetUserIds ??
    rawEvent?.targetUserIds ??
    rawEvent?.target_users ??
    rawEvent?.targetUsers ??
    rawEvent?.user_ids ??
    rawEvent?.userIds ??
    rawEvent?.users ??
    rawEvent?.people ??
    rawEvent?.assigned_to ??
    rawEvent?.assignedTo ??
    rawEvent?.assigned_users ??
    rawEvent?.assignedUsers ??
    rawEvent?.participants ??
    rawEvent?.members ??
    rawEvent?.resource?.target_user_ids ??
    rawEvent?.resource?.TargetUserIds ??
    rawEvent?.resource?.targetUserIds ??
    rawEvent?.resource?.target_users ??
    rawEvent?.resource?.targetUsers ??
    rawEvent?.resource?.user_ids ??
    rawEvent?.resource?.userIds ??
    rawEvent?.resource?.users ??
    rawEvent?.resource?.people ??
    rawEvent?.resource?.assigned_to ??
    rawEvent?.resource?.assignedTo ??
    rawEvent?.resource?.assigned_users ??
    rawEvent?.resource?.assignedUsers ??
    rawEvent?.resource?.participants ??
    rawEvent?.resource?.members ??
    [];

  if (Array.isArray(rawTargetUsers) && rawTargetUsers.length > 0) {
    const list = rawTargetUsers
      .map((item) => {
        const val = typeof item === "object" && item !== null ? (item.value ?? item.id ?? item.Id ?? item.userId ?? item.user_id) : item;
        return formatUserOption(val, typeof item === "object" ? item : null);
      })
      .filter((u) => Boolean(u.value));

    if (list.length > 0) {
      return list;
    }
  }

  const storedUsers = getStoredMeetingTargetUsers(rawEvent);
  if (storedUsers && storedUsers.length > 0) {
    return storedUsers.map((item) => {
      const val = typeof item === "object" && item !== null ? (item.value ?? item.id ?? item.Id ?? item.userId ?? item.user_id) : item;
      return formatUserOption(val, typeof item === "object" ? item : null);
    });
  }

  const rawShowToAll =
    rawEvent.showToAll ??
    rawEvent.show_to_all ??
    rawEvent.ShowToAll ??
    rawEvent.show_all ??
    rawEvent.is_show_all ??
    rawEvent.resource?.showToAll ??
    rawEvent.resource?.show_to_all;

  const isExplicitShowAll =
    rawShowToAll === true ||
    rawShowToAll === 1 ||
    rawShowToAll === "1" ||
    rawShowToAll === "true" ||
    rawShowToAll === "yes";

  if (isExplicitShowAll && effectiveAllUsers.length > 0) {
    return effectiveAllUsers.map((u) => ({
      value: u.id ?? u.Id ?? u.userId ?? u.user_id,
      label: getUserDisplayName(u, u.id),
    }));
  }

  const ownerId =
    rawEvent.user_id ??
    rawEvent.userId ??
    rawEvent.created_by ??
    rawEvent.createdBy ??
    rawEvent.employee_id ??
    rawEvent.employeeId ??
    rawEvent.resource?.user_id ??
    rawEvent.resource?.created_by ??
    currentUserId;

  const rawOwnerName =
    rawEvent.userName ??
    rawEvent.employeeName ??
    rawEvent.firstName ??
    rawEvent.resource?.userName ??
    rawEvent.resource?.employeeName;

  if (ownerId !== null && typeof ownerId !== "undefined" && String(ownerId) !== "") {
    return [formatUserOption(ownerId, rawOwnerName ? { label: String(rawOwnerName).trim() } : null)];
  }

  const currentUser = getCurrentUserData();
  if (currentUser) {
    return [currentUser];
  }

  return [];
};

const isLeaveEvent = (evt = {}) => {
  const originalEvent = evt?.resource || evt || {};
  const category = String(
    evt?.category ||
    originalEvent.Category ||
    originalEvent.category ||
    ""
  ).toLowerCase();
  const titleLower = String(
    evt?.title ||
    getEventTitleValue(originalEvent) ||
    ""
  ).toLowerCase();

  return (
    category === "leave" ||
    titleLower === "leave" ||
    titleLower.startsWith("leave -") ||
    titleLower.startsWith("leave:") ||
    titleLower.includes("leave") ||
    titleLower.includes("sick leave") ||
    titleLower.includes("casual leave") ||
    titleLower.includes("loss of pay")
  );
};

const normalizeEventDates = (event, index) => {
  const startSource = event.StartTime || event.start || event.date;
  const endSource = event.EndTime || event.end || startSource;
  const parsedAllDayFlag = getRawAllDayFlag(event);
  const treatAsAllDayDate = typeof parsedAllDayFlag === "boolean" ? parsedAllDayFlag : false;
  const startMoment = parseCalendarDateValue(startSource, treatAsAllDayDate);
  const endMoment = parseCalendarDateValue(endSource, treatAsAllDayDate);

  if (!startMoment.isValid()) {
    return null;
  }

  const rawCategory = String(event.Category || event.category || "event").toLowerCase();
  const rawTitleLower = String(getEventTitleValue(event)).trim().toLowerCase();

  let normalizedCategory = rawCategory;
  if (
    rawCategory === "reminder" ||
    rawCategory === "calendar" ||
    rawCategory === "event" ||
    rawCategory === "title" ||
    !rawCategory
  ) {
    const rawDesc = String(event.Description || event.description || event.resource?.Description || event.resource?.description || "").toLowerCase();
    if (
      rawTitleLower === "meeting" ||
      rawTitleLower.startsWith("meeting -") ||
      rawTitleLower.startsWith("meeting:") ||
      rawTitleLower.includes("meeting") ||
      rawTitleLower.includes("scrum") ||
      rawDesc.includes("[category:meeting]") ||
      rawDesc.includes("category:meeting")
    ) {
      normalizedCategory = "meeting";
    } else if (
      rawTitleLower === "leave" ||
      rawTitleLower.startsWith("leave -") ||
      rawTitleLower.startsWith("leave:") ||
      rawTitleLower.includes("leave") ||
      rawTitleLower.includes("sick leave") ||
      rawTitleLower.includes("casual leave") ||
      rawTitleLower.includes("loss of pay")
    ) {
      normalizedCategory = "leave";
    }
  }

  let inferredAllDay = false;
  if (typeof parsedAllDayFlag === "boolean") {
    inferredAllDay = parsedAllDayFlag;
  } else if (hasExplicitTime(startSource) || hasExplicitTime(endSource)) {
    inferredAllDay = false;
  } else {
    inferredAllDay = ALL_DAY_CATEGORIES.includes(normalizedCategory);
  }
  const forceSingleDayRender = normalizedCategory === "event" || normalizedCategory === "holiday" || normalizedCategory === "upcoming";

  let start = startMoment.clone();
  let end = endMoment.isValid() ? endMoment.clone() : startMoment.clone();

  if (forceSingleDayRender) {
    start = start.startOf("day");
    end = start.clone().add(30, "minutes");
    inferredAllDay = false;
  } else if (inferredAllDay) {
    const spansMultipleDays = end.isAfter(start, "day");
    start = start.startOf("day");

    if (!spansMultipleDays) {
      end = start.clone().endOf("day");
    } else {
      end = end.endOf("day");
    }
  } else if (!end.isAfter(start)) {
    end = start.clone().add(1, "hour");
  }

  return {
    ...event,
    id: `${normalizedCategory}-${event.Id ?? event.id ?? "item"}-${getEventTitleValue(event) || "untitled"}-${start.valueOf()}-${index}`,
    title: getEventTitleValue(event) || "Untitled",
    start: start.toDate(),
    end: end.toDate(),
    allDay: inferredAllDay,
    category: normalizedCategory,
    resource: event,
  };
};

const getFormattedTitleWithCategory = (event = {}) => {
  const originalEvent = event?.resource || event || {};
  let rawTitle = String(
    getEventTitleValue(originalEvent) ||
    event?.title ||
    "Untitled"
  ).trim();

  let category = String(
    event?.category ||
    originalEvent.Category ||
    originalEvent.category ||
    ""
  ).trim().toLowerCase();

  let titleLower = rawTitle.toLowerCase();

  const isTimeEntry =
    category === "time-entry" ||
    category === "time_entry" ||
    category === "timeentry" ||
    category === "time entry" ||
    titleLower.includes("time entry") ||
    titleLower.includes("time_entry");

  if (isTimeEntry) {
    let cleanName = rawTitle
      .replace(/^(event|title|reminder|calendar|time entry|time-entry|time_entry)\s*[-:]\s*/i, "")
      .replace(/\s*-\s*Pending Time Entry$/i, "")
      .replace(/\s*-\s*Time Entry$/i, "")
      .trim();
    if (cleanName.toLowerCase() === "time entry" || !cleanName) return "Time Entry";
    return `Time Entry - ${cleanName}`;
  }

  if (titleLower.startsWith("title - ") || titleLower.startsWith("reminder - ") || titleLower.startsWith("calendar - ") || titleLower.startsWith("todo - ")) {
    const prefixLength = titleLower.indexOf(" - ") + 3;
    const stripped = rawTitle.substring(prefixLength).trim();
    const strippedLower = stripped.toLowerCase();
    if (
      strippedLower === "leave" ||
      strippedLower.startsWith("leave -") ||
      strippedLower.startsWith("leave:") ||
      strippedLower.includes("leave") ||
      strippedLower.includes("sick leave") ||
      strippedLower.includes("casual leave") ||
      strippedLower.includes("loss of pay")
    ) {
      rawTitle = stripped;
      titleLower = strippedLower;
      category = "leave";
    } else if (
      category === "meeting" ||
      strippedLower === "meeting" ||
      strippedLower.startsWith("meeting -") ||
      strippedLower.startsWith("meeting:") ||
      strippedLower.includes("meeting") ||
      strippedLower.includes("scrum")
    ) {
      rawTitle = stripped;
      titleLower = strippedLower;
      category = "meeting";
    } else if (titleLower.startsWith("title - ") || titleLower.startsWith("reminder - ") || titleLower.startsWith("calendar - ")) {
      rawTitle = stripped;
      titleLower = strippedLower;
      category = "todo";
    }
  }

  if (
    category === "meeting" ||
    titleLower === "meeting" ||
    titleLower.startsWith("meeting -") ||
    titleLower.startsWith("meeting:") ||
    titleLower.includes("meeting") ||
    titleLower.includes("scrum")
  ) {
    category = "meeting";
  } else if (
    category === "leave" ||
    titleLower === "leave" ||
    titleLower.startsWith("leave -") ||
    titleLower.startsWith("leave:") ||
    titleLower.includes("leave") ||
    titleLower.includes("sick leave") ||
    titleLower.includes("casual leave") ||
    titleLower.includes("loss of pay")
  ) {
    category = "leave";
  }

  let label = "Event";
  if (category === "meeting") {
    label = "Meeting";
  } else if (category === "holiday") {
    label = "Holiday";
  } else if (category === "leave") {
    label = "Leave";
  } else if (category === "reminder" || category === "calendar" || category === "title" || category === "todo") {
    label = "Todo";
  } else if (category === "birthday" || category === "bday") {
    label = "Birthday";
  } else if (category === "event") {
    label = "Event";
  }

  const knownLabels = ["Event", "Holiday", "Leave", "Reminder", "Calendar", "Birthday", "Meeting", "Title", "Todo"];
  const hasKnownPrefix = knownLabels.some((l) =>
    titleLower.startsWith(`${l.toLowerCase()} - `) ||
    titleLower.startsWith(`${l.toLowerCase()}: `)
  );

  if (hasKnownPrefix) {
    if ((category === "meeting" || titleLower.includes("scrum") || titleLower.includes("meeting")) && (titleLower.startsWith("reminder - ") || titleLower.startsWith("title - ") || titleLower.startsWith("calendar - ") || titleLower.startsWith("todo - "))) {
      const prefixLength = titleLower.indexOf(" - ") + 3;
      const stripped = rawTitle.substring(prefixLength).trim();
      return stripped.toLowerCase() === "meeting" ? "Meeting" : `Meeting - ${stripped}`;
    }
    if (category === "leave" && (titleLower.startsWith("reminder - ") || titleLower.startsWith("title - ") || titleLower.startsWith("todo - "))) {
      const prefixLength = titleLower.indexOf(" - ") + 3;
      const stripped = rawTitle.substring(prefixLength).trim();
      return stripped.toLowerCase() === "leave" ? "Leave" : `Leave - ${stripped}`;
    }
    if (titleLower.startsWith("title - ") || titleLower.startsWith("reminder - ") || titleLower.startsWith("calendar - ")) {
      const prefixLength = titleLower.indexOf(" - ") + 3;
      const stripped = rawTitle.substring(prefixLength).trim();
      return stripped.toLowerCase() === "todo" ? "Todo" : `Todo - ${stripped}`;
    }
    return rawTitle;
  }

  if (titleLower === label.toLowerCase()) {
    return label;
  }

  return `${label} - ${rawTitle}`;
};

const formatEventTooltip = (event) => {
  const title = getFormattedTitleWithCategory(event);
  const originalEvent = event.resource || {};
  const startSource = originalEvent.StartTime || originalEvent.start || originalEvent.date || originalEvent.eventdate || originalEvent.upcomingEventdate || originalEvent.upcoming_event_date;
  const hasExplicitEndTime = Boolean(originalEvent.EndTime || originalEvent.end || originalEvent.endDate);
  const endSource = hasExplicitEndTime ? (originalEvent.EndTime || originalEvent.end || originalEvent.endDate) : startSource;
  const rawAllDayFlag = originalEvent.IsAllDay ?? originalEvent.isAllDay ?? originalEvent.is_all_day ?? event.allDay;
  const treatAsAllDayDate = Boolean(rawAllDayFlag);
  const startMoment = parseCalendarDateValue(startSource || event.start, treatAsAllDayDate);
  const endMoment = parseCalendarDateValue(endSource || event.end, treatAsAllDayDate);
  const hasOriginalTime = hasExplicitTime(startSource) || hasExplicitTime(endSource);
  const normalizedCategory = String(event.category || originalEvent.Category || originalEvent.category || "").trim().toLowerCase();
  const usesInclusiveAllDayEnd = normalizedCategory === "leave";

  if (!startMoment.isValid()) {
    return title;
  }

  const dateLabel = startMoment.format("MMMM D, YYYY");
  const comparisonEndMoment = usesInclusiveAllDayEnd ? endMoment.clone() : endMoment.clone().subtract(1, "second");
  const isSameDay = !hasExplicitEndTime || !endMoment.isValid() || startMoment.isSame(comparisonEndMoment, "day") || (!usesInclusiveAllDayEnd && (endMoment.diff(startMoment, "hours") <= 24));

  if (event.allDay || !hasOriginalTime) {
    if (isSameDay) {
      return `${title}
${dateLabel}`;
    }

    const formattedEndDay = (usesInclusiveAllDayEnd ? endMoment : endMoment.clone().subtract(1, "second")).format("MMMM D, YYYY");
    return `${title}
${startMoment.format("MMMM D, YYYY")} - ${formattedEndDay}`;
  }

  const startTimeLabel = startMoment.format("h:mm A");
  const endTimeLabel = endMoment.isValid() ? endMoment.format("h:mm A") : startMoment.clone().add(30, "minutes").format("h:mm A");

  if (isSameDay) {
    return `${title}
${dateLabel}
${startTimeLabel} - ${endTimeLabel}`;
  }

  return `${title}
${startMoment.format("MMMM D, YYYY h:mm A")} - ${endMoment.format("MMMM D, YYYY h:mm A")}`;
};

const formatEventDisplayTitle = (event) => {
  const originalEvent = event.resource || {};
  const startSource = originalEvent.StartTime || originalEvent.start || originalEvent.date;
  const rawAllDayFlag = originalEvent.IsAllDay ?? originalEvent.isAllDay ?? originalEvent.is_all_day ?? event.allDay;
  const formattedTitle = getFormattedTitleWithCategory(event);

  if (Boolean(rawAllDayFlag) || !hasExplicitTime(startSource)) {
    return formattedTitle;
  }

  const startMoment = parseCalendarDateValue(startSource, false);
  if (!startMoment.isValid()) {
    return formattedTitle;
  }

  return `${startMoment.format("h:mm A")} ${formattedTitle}`;
};

const getComparableCalendarCategory = (event = {}) => {
  const normalizedCategory = String(event.Category || event.category || event.categoryName || "event").trim().toLowerCase();
  return normalizedCategory === "reminder" ? "calendar" : normalizedCategory;
};

const getComparableCalendarEventId = (event = {}) => {
  const explicitId = event.calendar_event_id ?? event.calendarEventId ?? event.event_id ?? event.eventId ?? event.Id ?? event.id ?? null;

  if (explicitId === null || typeof explicitId === "undefined") {
    return "";
  }

  return String(explicitId).trim();
};

const normalizeComparableCalendarDate = (value) => {
  if (!value) {
    return "";
  }

  const parsedValue = parseCalendarDateValue(value, false);
  if (parsedValue.isValid()) {
    return parsedValue.toISOString();
  }

  return String(value).trim();
};

const getComparableCalendarEventKey = (event = {}) => {
  const category = getComparableCalendarCategory(event);
  const explicitId = getComparableCalendarEventId(event);
  const title = String(getEventTitleValue(event)).trim().toLowerCase();
  const startSource = event.StartTime || event.start || event.date || "";
  const endSource = event.EndTime || event.end || event.date || startSource;
  const startMoment = parseCalendarDateValue(startSource, false);
  const endMoment = parseCalendarDateValue(endSource, false);
  const normalizedDay = startMoment.isValid() ? startMoment.format("YYYY-MM-DD") : normalizeComparableCalendarDate(startSource);
  const normalizedEndDay = endMoment.isValid() ? endMoment.format("YYYY-MM-DD") : normalizeComparableCalendarDate(endSource);

  if (explicitId) {
    return [category || "item", explicitId].join("|");
  }

  return [
    category || "item",
    title || "untitled",
    normalizedDay || "no-start",
    normalizedEndDay || "no-end",
  ].join("|");
};

const normalizeBackendEntityId = (value) => {
  if (typeof value === "number") {
    return value;
  }

  if (typeof value === "string") {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      return null;
    }

    if (/^\d+$/.test(trimmedValue)) {
      return Number(trimmedValue);
    }

    const trailingNumericMatch = trimmedValue.match(/-(\d+)$/);
    if (trailingNumericMatch) {
      return Number(trailingNumericMatch[1]);
    }
  }

  return value ?? null;
};

const getEventIdentifier = (event = {}) => (
  normalizeBackendEntityId(
    event.Id ??
    event.id ??
    event.event_id ??
    event.eventId ??
    event.calendar_event_id ??
    event.calendarEventId ??
    null
  )
);

const getEventDeleteMeta = (event = {}, normalizedCategory = "") => {
  const rawEvt = event?.resource || event || {};
  const category = String(normalizedCategory || rawEvt.Category || rawEvt.category || "").trim().toLowerCase();
  const titleLower = String(getEventTitleValue(rawEvt) || "").trim().toLowerCase();

  if (
    category === "birthday" ||
    category === "bday" ||
    titleLower.startsWith("birthday") ||
    titleLower.includes("birthday") ||
    titleLower.includes("bday")
  ) {
    return null;
  }

  const calendarEventId = normalizeBackendEntityId(rawEvt.calendar_event_id ?? rawEvt.calendarEventId ?? null);
  const standardEventId = normalizeBackendEntityId(
    rawEvt.event_id ??
    rawEvt.eventId ??
    (typeof rawEvt.Id === "number" ? rawEvt.Id : null) ??
    (typeof rawEvt.id === "number" ? rawEvt.id : null) ??
    (/^\d+$/.test(String(rawEvt.Id || "")) ? Number(rawEvt.Id) : null) ??
    (/^\d+$/.test(String(rawEvt.id || "")) ? Number(rawEvt.id) : null)
  );
  const holidayId = normalizeBackendEntityId(
    rawEvt.holiday_id ??
    rawEvt.holidayId ??
    rawEvt.leave_id ??
    rawEvt.leaveId ??
    (typeof rawEvt.Id === "number" ? rawEvt.Id : null) ??
    (typeof rawEvt.id === "number" ? rawEvt.id : null) ??
    (/^\d+$/.test(String(rawEvt.Id || "")) ? Number(rawEvt.Id) : null) ??
    (/^\d+$/.test(String(rawEvt.id || "")) ? Number(rawEvt.id) : null)
  );
  const leaveId = normalizeBackendEntityId(
    rawEvt.SourceId ??
    rawEvt.leave_id ??
    rawEvt.leaveId ??
    (typeof rawEvt.Id === "number" ? rawEvt.Id : null) ??
    (typeof rawEvt.id === "number" ? rawEvt.id : null) ??
    (/^\d+$/.test(String(rawEvt.Id || "")) ? Number(rawEvt.Id) : null) ??
    (/^\d+$/.test(String(rawEvt.id || "")) ? Number(rawEvt.id) : null)
  );
  const looksLikeDashboardCalendarItem = Boolean(
    rawEvt.StartTime ||
    rawEvt.EndTime ||
    typeof rawEvt.showToAll !== "undefined" ||
    typeof rawEvt.show_to_all !== "undefined" ||
    typeof rawEvt.ShowToAll !== "undefined" ||
    typeof rawEvt.IsAllDay !== "undefined" ||
    typeof rawEvt.isAllDay !== "undefined" ||
    typeof rawEvt.is_all_day !== "undefined" ||
    typeof rawEvt.created_by !== "undefined" ||
    typeof rawEvt.createdBy !== "undefined"
  );

  const fallbackId = calendarEventId || standardEventId || holidayId || leaveId || rawEvt.id || rawEvt.Id || "item";

  if (category === "leave" && (leaveId || fallbackId)) {
    return {
      strategy: "leave",
      id: leaveId || fallbackId,
    };
  }

  if (calendarEventId) {
    return {
      strategy: "calendar",
      id: calendarEventId,
    };
  }

  if ((category === "calendar" || category === "reminder" || category === "title" || category === "meeting") && (standardEventId || fallbackId)) {
    return {
      strategy: "calendar",
      id: standardEventId || fallbackId,
    };
  }

  if (category === "holiday" && (holidayId || fallbackId)) {
    return {
      strategy: "holiday",
      id: holidayId || fallbackId,
    };
  }

  if ((category === "event" || category === "upcoming") && (standardEventId || fallbackId)) {
    return {
      strategy: "event",
      id: standardEventId || fallbackId,
    };
  }

  if (looksLikeDashboardCalendarItem && (standardEventId || fallbackId)) {
    return {
      strategy: "calendar",
      id: standardEventId || fallbackId,
    };
  }

  if (standardEventId || fallbackId) {
    return {
      strategy: "calendar",
      id: standardEventId || fallbackId,
    };
  }

  return null;
};

const getEventUpdateMeta = (event = {}, normalizedCategory = "") => {
  const category = String(normalizedCategory || event.Category || event.category || "").trim().toLowerCase();
  const titleLower = String(getEventTitleValue(event) || "").trim().toLowerCase();

  if (
    category === "birthday" ||
    category === "bday" ||
    titleLower.startsWith("birthday") ||
    titleLower.includes("birthday") ||
    titleLower.includes("bday")
  ) {
    return null;
  }

  const deleteMeta = getEventDeleteMeta(event, normalizedCategory);

  if (deleteMeta && ["holiday", "event", "upcoming"].includes(deleteMeta.strategy)) {
    return deleteMeta;
  }

  if (category === "calendar" || (deleteMeta && deleteMeta.strategy === "calendar")) {
    return {
      strategy: "calendar",
      id: getEventIdentifier(event),
    };
  }

  return deleteMeta;
};

const isDeleteSupportedForMeta = (deleteMeta) => {
  if (!deleteMeta || !deleteMeta.strategy) {
    return false;
  }

  return ["event", "upcoming", "calendar", "holiday", "leave"].includes(deleteMeta.strategy);
};

const getBooleanFlag = (value, defaultValue = false) => {
  if (typeof value === "undefined" || value === null || value === "") {
    return defaultValue;
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "number") {
    return value === 1;
  }

  return ["1", "true", "yes"].includes(String(value).trim().toLowerCase());
};

const formatPopoverDateText = (start, end) => {
  const startMoment = moment(start);
  const rawEndMoment = end ? moment(end) : moment(start);
  const hasSingleDaySelection = !end || rawEndMoment.diff(startMoment, "days") <= 1;

  if (hasSingleDaySelection) {
    return startMoment.format("MMMM D, YYYY");
  }

  const adjustedEnd = rawEndMoment.clone().subtract(1, "day");
  if (startMoment.year() === adjustedEnd.year()) {
    if (startMoment.month() === adjustedEnd.month()) {
      return `${startMoment.format("MMMM D")} - ${adjustedEnd.format("D, YYYY")}`;
    }

    return `${startMoment.format("MMMM D")} - ${adjustedEnd.format("MMMM D, YYYY")}`;
  }

  return `${startMoment.format("MMMM D, YYYY")} - ${adjustedEnd.format("MMMM D, YYYY")}`;
};

const getCategoryDisplayLabel = (category = "") => {
  const normalizedCategory = String(category || "").trim().toLowerCase();

  if (normalizedCategory === "meeting") {
    return "Meeting";
  }

  if (normalizedCategory === "holiday") {
    return "Holiday";
  }

  if (normalizedCategory === "event") {
    return "Event";
  }

  if (normalizedCategory === "reminder" || normalizedCategory === "title") {
    return "Title";
  }

  if (normalizedCategory === "leave") {
    return "Leave";
  }

  if (normalizedCategory === "timeentry" || normalizedCategory === "time") {
    return "Time Entry";
  }

  if (normalizedCategory === "calendar") {
    return "Calendar";
  }

  if (normalizedCategory === "birthday" || normalizedCategory === "bday") {
    return "Birthday";
  }

  return category ? String(category).toUpperCase() : "Item";
};

const VIEW_OPTIONS = [
  { label: "Day", value: Views.DAY },
  { label: "Week", value: Views.WEEK },
  { label: "Work Week", value: Views.WORK_WEEK },
  { label: "Month", value: Views.MONTH },
  { label: "Agenda", value: Views.AGENDA },
];

const getToolbarLabel = (date, view) => {
  const currentMoment = moment(date);

  if (view === Views.DAY) {
    return currentMoment.format("MMMM DD, YYYY");
  }

  if (view === Views.WEEK || view === Views.WORK_WEEK) {
    const weekStart = currentMoment.clone().startOf(view === Views.WORK_WEEK ? "isoWeek" : "week");
    const weekEnd = weekStart.clone().add(view === Views.WORK_WEEK ? 4 : 6, "days");

    if (weekStart.month() === weekEnd.month()) {
      return `${weekStart.format("MMMM DD")} - ${weekEnd.format("DD, YYYY")}`;
    }

    if (weekStart.year() === weekEnd.year()) {
      return `${weekStart.format("MMMM DD")} - ${weekEnd.format("MMMM DD, YYYY")}`;
    }

    return `${weekStart.format("MMMM DD, YYYY")} - ${weekEnd.format("MMMM DD, YYYY")}`;
  }

  if (view === Views.AGENDA) {
    return `${currentMoment.format("MMMM YYYY")} Agenda`;
  }

  return currentMoment.format("MMMM YYYY");
};

const CustomToolbar = ({
  date,
  view,
  onNavigate,
  onOpenViewMenu,
  onTodayClick,
  categoryFilterAnchorPosition,
  onOpenFilterMenu,
  activeFilterCountText,
}) => (
  <div className="dashboard-calendar-rbc-toolbar">
    <div className="dashboard-calendar-toolbar-left">
      <div className="dashboard-calendar-nav-group">
        <button
          type="button"
          className="dashboard-calendar-nav-btn"
          onClick={() => onNavigate("PREV")}
          aria-label="Previous"
        >
          <ChevronLeftIcon fontSize="small" />
        </button>
        <button
          type="button"
          className="dashboard-calendar-nav-btn"
          onClick={() => onNavigate("NEXT")}
          aria-label="Next"
        >
          <ChevronRightIcon fontSize="small" />
        </button>
      </div>
      <div className="dashboard-calendar-label-btn">
        <span className="dashboard-calendar-label">{getToolbarLabel(date, view)}</span>
      </div>
    </div>
    <div className="dashboard-calendar-toolbar-right">
      <button
        type="button"
        className={`dashboard-calendar-pill-btn dashboard-calendar-filter-btn${Boolean(categoryFilterAnchorPosition) ? " is-active" : ""}`}
        onClick={(event) => typeof onOpenFilterMenu === "function" && onOpenFilterMenu(event.currentTarget)}
      >
        <FilterListIcon fontSize="small" style={{ marginRight: "4px" }} />
        Filter {activeFilterCountText ? `(${activeFilterCountText})` : ""}
      </button>

      <button
        type="button"
        className="dashboard-calendar-pill-btn dashboard-calendar-today-btn"
        onClick={() => {
          onNavigate("TODAY");
          if (typeof onTodayClick === "function") {
            onTodayClick();
          }
        }}
      >
        Today
      </button>
      <button
        type="button"
        className="dashboard-calendar-pill-btn dashboard-calendar-view-btn"
        onClick={(event) => onOpenViewMenu(event.currentTarget)}
      >
        {VIEW_OPTIONS.find((item) => item.value === view)?.label || "Month"}
        <ExpandMoreIcon fontSize="small" />
      </button>
    </div>
  </div>
);

const normalizeRange = (range, view) => {
  if (Array.isArray(range) && range.length > 0) {
    return {
      start: range[0],
      end: range[range.length - 1],
    };
  }

  if (range && range.start && range.end) {
    return {
      start: range.start,
      end: range.end,
    };
  }

  if (range instanceof Date) {
    return {
      start: range,
      end: view === Views.DAY ? range : moment(range).endOf("month").toDate(),
    };
  }

  return null;
};

const TIME_OPTIONS = [];
for (let h = 0; h < 24; h++) {
  const hh = h % 12 === 0 ? 12 : h % 12;
  const ampm = h < 12 ? "AM" : "PM";
  const hhStr = hh < 10 ? `0${hh}` : `${hh}`;
  for (let m = 0; m < 60; m += 10) {
    const mmStr = m < 10 ? `0${m}` : `${m}`;
    TIME_OPTIONS.push(`${hhStr}:${mmStr} ${ampm}`);
  }
}

const formatTimeInputValue = (timeStr, defaultTime = "09:00") => {
  if (!timeStr) return defaultTime;
  const m = moment(timeStr, [
    "h:mm A", "hh:mm A", "h:mm:ss A", "hh:mm:ss A",
    "HH:mm", "H:mm", "HH:mm:ss", "H:mm:ss",
    "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm",
    "YYYY-MM-DD h:mm A", "YYYY-MM-DD hh:mm A",
  ], false);
  if (m.isValid()) {
    return m.format("HH:mm");
  }
  const fallback = moment(timeStr);
  if (fallback.isValid()) {
    return fallback.format("HH:mm");
  }
  return defaultTime;
};

const handleNativeTimeChange = (e, setTimeFn) => {
  const val = e.target.value;
  if (!val) return;
  const m = moment(val, "HH:mm");
  if (m.isValid()) {
    setTimeFn(m.format("hh:mm A"));
  }
};

const parseFlexibleTimeMoment = (dateStr, timeStr) => {
  if (!timeStr) return moment(dateStr, "YYYY-MM-DD");
  const formats = [
    "YYYY-MM-DD h:mm A",
    "YYYY-MM-DD hh:mm A",
    "YYYY-MM-DD h:mma",
    "YYYY-MM-DD hh:mma",
    "YYYY-MM-DD HH:mm",
    "YYYY-MM-DD H:mm",
  ];
  return moment(`${dateStr} ${timeStr}`, formats);
};

const LEAVE_TYPE_OPTIONS = ["Loss Of Pay", "Sick Leave", "Paid Leave"];

const getEventCategoryKey = (evt) => {
  const resourceObj = evt?.resource || evt || {};
  const evtCat = String(
    evt?.category ||
    resourceObj.Category ||
    resourceObj.category ||
    resourceObj.categoryName ||
    resourceObj.type ||
    ""
  ).toLowerCase().trim();

  const titleVal = getEventTitleValue(resourceObj);
  const rawTitle = String(
    evt?.title ||
    titleVal ||
    ""
  ).trim();
  const titleLower = rawTitle.toLowerCase();

  if (
    evtCat === "time-entry" ||
    evtCat === "time_entry" ||
    evtCat === "timeentry" ||
    evtCat === "time entry" ||
    titleLower.includes("time entry") ||
    titleLower.includes("time_entry")
  ) {
    const rawStatus = String(
      resourceObj.is_approved ??
      resourceObj.isApproved ??
      resourceObj.Status ??
      resourceObj.status ??
      evt?.status ??
      ""
    ).toLowerCase().trim();

    if (rawStatus === "0" || rawStatus.includes("approved")) {
      return "Time Entry - Approved";
    }
    if (rawStatus === "2" || rawStatus.includes("reject") || rawStatus.includes("declin")) {
      return "Time Entry - Rejected";
    }
    return "Time Entry - Pending";
  }

  if (evtCat === "birthday" || evtCat === "bday" || titleLower.includes("birthday") || titleLower.includes("bday")) {
    return "Birthday";
  }

  if (evtCat === "holiday" || titleLower.includes("holiday")) {
    return "Holiday";
  }

  if (evtCat === "meeting" || titleLower.includes("meeting")) {
    return "Meeting";
  }

  if (
    evtCat === "leave" ||
    titleLower.includes("leave") ||
    titleLower.includes("sick leave") ||
    titleLower.includes("casual leave") ||
    titleLower.includes("loss of pay")
  ) {
    const rawStatus = String(
      resourceObj.LeaveStatus ||
      resourceObj.Status ||
      resourceObj.status ||
      evt?.leaveStatus ||
      evt?.status ||
      ""
    ).toLowerCase();

    if (rawStatus.includes("pending") || titleLower.includes("pending")) {
      return "Leave - Pending";
    }
    if (rawStatus.includes("declin") || titleLower.includes("declin")) {
      return "Leave - Declined";
    }
    if (rawStatus.includes("unapprov") || titleLower.includes("unapprov")) {
      return "Leave - Unapproved";
    }
    if (rawStatus.includes("cancel") || titleLower.includes("cancel")) {
      return "Leave - Cancelled";
    }
    return "Leave - Approved";
  }

  const isTodoCat =
    evtCat === "title" ||
    evtCat === "todo" ||
    evtCat === "reminder" ||
    evtCat === "calendar" ||
    evtCat === "todo_reminder" ||
    evtCat === "todoreminder" ||
    evtCat === "todo's reminder" ||
    evtCat === "todo reminder" ||
    (evtCat.includes("reminder") && !evtCat.includes("event")) ||
    (evtCat.includes("todo") && !evtCat.includes("event"));

  const isTodoTitle =
    titleLower.startsWith("title - ") ||
    titleLower.startsWith("todo - ") ||
    titleLower.startsWith("reminder - ") ||
    titleLower.startsWith("calendar - ") ||
    titleLower.startsWith("• todo") ||
    titleLower.startsWith("• title") ||
    titleLower.startsWith("• reminder") ||
    titleLower.includes("todo - ") ||
    (titleLower.includes("todo") && !titleLower.includes("leave") && !titleLower.includes("meeting") && !titleLower.includes("event")) ||
    (titleLower.includes("reminder") && !titleLower.includes("leave") && !titleLower.includes("meeting") && !titleLower.includes("event"));

  if (isTodoCat || isTodoTitle) {
    return "Todo";
  }

  const isEventCat =
    evtCat === "event" ||
    evtCat === "upcoming" ||
    evtCat === "upcoming_event" ||
    evtCat === "upcoming event" ||
    evtCat.includes("upcoming") ||
    evtCat.includes("event");

  const isEventTitle =
    titleLower.startsWith("event - ") ||
    titleLower.startsWith("• event") ||
    titleLower.startsWith("upcoming - ") ||
    titleLower.startsWith("upcoming event - ") ||
    Boolean(resourceObj.upcomingEventdate || resourceObj.upcoming_event_date || evt?.upcomingEventdate || evt?.upcoming_event_date);

  if (isEventCat || isEventTitle) {
    return "Event";
  }

  return "Event";
};

const isEventVisibleWithFilters = (evt, filters) => {
  if (!filters) return true;
  const catKey = getEventCategoryKey(evt);

  if (catKey.startsWith("Leave")) {
    if (!filters.leave) return false;
    if (catKey === "Leave - Pending") return Boolean(filters.leaveStatuses?.pending);
    if (catKey === "Leave - Approved") return Boolean(filters.leaveStatuses?.approved);
    if (catKey === "Leave - Unapproved") return Boolean(filters.leaveStatuses?.unapproved);
    if (catKey === "Leave - Declined") return Boolean(filters.leaveStatuses?.declined);
    if (catKey === "Leave - Cancelled") return Boolean(filters.leaveStatuses?.cancelled);
    return true;
  }

  if (catKey === "Meeting") return Boolean(filters.meeting);
  if (catKey === "Todo" || catKey === "Reminder" || catKey === "Calendar") return Boolean(filters.reminder);
  if (catKey === "Event" || catKey === "Upcoming") return Boolean(filters.upcoming);
  if (catKey === "Holiday") return Boolean(filters.holiday);
  if (catKey === "Time Entry" || catKey === "TimeEntry" || catKey.startsWith("Time Entry") || catKey.startsWith("time-entry")) return Boolean(filters.timeentry);
  if (catKey === "Birthday" || catKey === "Bday") return Boolean(filters.birthday);

  return true;
};


const DashboardCalendar = ({
  events = [],
  isAdmin = false,
  loading = false,
  onApplyLeave,
  onRangeChange,
  onSaveQuickLeave,
  onUpdateQuickEvent,
  onDeleteQuickEvent,
  onOpenEditItem,
  onUpdateLeaveStatus,
  allUsers = [],
}) => {
  const currentUserId = getCurrentUserId();
  const [currentView, setCurrentView] = useState(Views.MONTH);
  const [currentDate, setCurrentDate] = useState(new Date());
  const lastDeleteTimeRef = useRef(0);
  const [morePopover, setMorePopover] = useState({
    anchorEl: null,
    anchorPosition: null,
    dateKey: "",
  });
  const [addTab, setAddTab] = useState("title");
  const [eventDate, setEventDate] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const [eventImageUrl, setEventImageUrl] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [addPopover, setAddPopover] = useState(createEmptyAddPopoverState);
  const [addEventTitle, setAddEventTitle] = useState("");
  const [addEventDescription, setAddEventDescription] = useState("");
  const [leaveType, setLeaveType] = useState("Loss Of Pay");
  const [leaveStartDate, setLeaveStartDate] = useState("");
  const [leaveEndDate, setLeaveEndDate] = useState("");
  const [firstLeaveHalf, setFirstLeaveHalf] = useState("first-half");
  const [secondLeaveHalf, setSecondLeaveHalf] = useState("second-half");
  const [leaveFormErrors, setLeaveFormErrors] = useState({});
  const [allDay, setAllDay] = useState(true);
  const [startTime, setStartTime] = useState("09:00 AM");
  const [endTime, setEndTime] = useState("10:00 AM");
  const [showToAll, setShowToAll] = useState(true);
  const [targetUsers, setTargetUsers] = useState([]);
  const [userPopoverAnchorEl, setUserPopoverAnchorEl] = useState(null);
  const [userSearchQuery, setUserSearchQuery] = useState("");
  const [viewMenuAnchorPosition, setViewMenuAnchorPosition] = useState(null);
  const [eventDetailsPopover, setEventDetailsPopover] = useState(createEmptyEventDetailsState());
  const [viewInfoModal, setViewInfoModal] = useState({ open: false, event: null });
  const [timeEntryDetailsModal, setTimeEntryDetailsModal] = useState({ open: false, data: null });
  const [viewUserPopoverAnchorEl, setViewUserPopoverAnchorEl] = useState(null);
  const [viewUserSearchQuery, setViewUserSearchQuery] = useState("");
  const [calendarColors, setCalendarColors] = useState(getCalendarColorSettings());
  const [categoryFilterAnchorPosition, setCategoryFilterAnchorPosition] = useState(null);

  const handleOpenFilterMenu = (anchorEl) => {
    if (!anchorEl) return;
    const triggerRect = anchorEl.getBoundingClientRect();
    const popoverWidth = 275;
    const calculatedLeft = Math.max(16, triggerRect.right - popoverWidth);
    setCategoryFilterAnchorPosition({
      top: Math.round(triggerRect.bottom + 6),
      left: Math.round(calculatedLeft),
    });
  };

  const handleCloseFilterMenu = () => {
    setCategoryFilterAnchorPosition(null);
  };
  const [categoryFilters, setCategoryFilters] = useState({
    reminder: false,
    meeting: true,
    upcoming: false,
    holiday: false,
    leave: true,
    leaveStatuses: {
      pending: true,
      approved: true,
      unapproved: true,
      declined: true,
      cancelled: true,
    },
    timeentry: false,
    birthday: false,
  });

  useEffect(() => {
    const handleColorsUpdate = () => {
      setCalendarColors(getCalendarColorSettings());
    };
    window.addEventListener(CALENDAR_COLORS_STORAGE_EVENT, handleColorsUpdate);
    fetchAndSyncCalendarColors().then((synced) => {
      if (synced) {
        setCalendarColors(synced);
      }
    });
    return () => {
      window.removeEventListener(CALENDAR_COLORS_STORAGE_EVENT, handleColorsUpdate);
    };
  }, []);

  useEffect(() => {
    const hasOpenPopover =
      Boolean(morePopover.anchorPosition) ||
      Boolean(eventDetailsPopover.anchorPosition) ||
      Boolean(viewMenuAnchorPosition) ||
      Boolean(categoryFilterAnchorPosition);

    if (!hasOpenPopover) return;

    const handlePageScroll = (e) => {
      if (!e || !e.target) return;

      const targetEl = e.target;
      const isInsideFilterPopover =
        typeof targetEl.closest === "function" && targetEl.closest(".dashboard-calendar-filter-popover-paper");

      if (isInsideFilterPopover) {
        return;
      }

      if (categoryFilterAnchorPosition) {
        handleCloseFilterMenu();
      }

      const isInsideCalendar =
        (typeof targetEl.closest === "function" && targetEl.closest(".dashboard-calendar-card")) ||
        (typeof targetEl.closest === "function" && targetEl.closest(".dashboard-calendar-more-popover")) ||
        (typeof targetEl.closest === "function" && targetEl.closest(".dashboard-calendar-details-popover")) ||
        (targetEl.classList && (
          targetEl.classList.contains("dashboard-calendar-card") ||
          targetEl.classList.contains("dashboard-calendar-shell") ||
          targetEl.classList.contains("dashboard-calendar-rbc-wrap") ||
          targetEl.classList.contains("rbc-calendar") ||
          targetEl.classList.contains("dashboard-calendar-more-popover-body")
        ));

      if (isInsideCalendar) {
        return;
      }

      if (morePopover.anchorPosition) {
        handleCloseMorePopover();
      }
      if (eventDetailsPopover.anchorPosition) {
        handleCloseEventDetailsPopover();
      }
      if (viewMenuAnchorPosition) {
        handleCloseViewMenu();
      }
    };

    window.addEventListener("scroll", handlePageScroll, true);
    return () => {
      window.removeEventListener("scroll", handlePageScroll, true);
    };
  }, [morePopover.anchorPosition, eventDetailsPopover.anchorPosition, viewMenuAnchorPosition, categoryFilterAnchorPosition]);

  const handleFileUpload = async (file) => {
    if (!file) return;
    const postData = new FormData();
    postData.append('file', file);
    try {
      let updaImg = await AuthApi.uploadEventImg(postData);
      if (updaImg && updaImg.status === true && updaImg.data) {
        setEventImageUrl(updaImg.data.image_url || updaImg.data.url || null);
      } else {
        const reader = new FileReader();
        reader.onloadend = () => {
          setEventImageUrl(reader.result);
        };
        reader.readAsDataURL(file);
      }
    } catch (err) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setEventImageUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const uploadSingleFile = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFileUpload(e.target.files[0]);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileUpload(e.dataTransfer.files[0]);
    }
  };

  const removeImg = () => {
    setEventImageUrl(null);
  };

  const calendarEvents = useMemo(
    () => {
      if (!Array.isArray(events)) {
        return [];
      }

      const visibleRawEvents = events.filter((evt) => isEventVisibleWithFilters(evt, categoryFilters));

      const list = visibleRawEvents.map((rawEvent) => {
        const isLeave = isLeaveEvent(rawEvent);
        const titleVal = getEventTitleValue(rawEvent);
        const categoryVal = getComparableCalendarCategory(rawEvent);
        const isAllDayVal = getRawAllDayFlag(rawEvent);
        const isUpcomingOrEvent = categoryVal === "upcoming" || categoryVal === "event" || categoryVal === "holiday" || Boolean(rawEvent.upcomingEventdate || rawEvent.upcoming_event_date);

        const startVal = rawEvent.StartTime || rawEvent.startTime || rawEvent.startDate || rawEvent.start_date || rawEvent.start || rawEvent.date || rawEvent.eventdate || rawEvent.upcomingEventdate || rawEvent.upcoming_event_date;
        const endVal = rawEvent.EndTime || rawEvent.endTime || rawEvent.endDate || rawEvent.end_date || rawEvent.end || rawEvent.date || rawEvent.eventdate || rawEvent.upcomingEventdate || rawEvent.upcoming_event_date;

        const startMoment = parseCalendarDateValue(startVal, isLeave || isAllDayVal || isUpcomingOrEvent);
        const endMoment = parseCalendarDateValue(endVal, isLeave || isAllDayVal || isUpcomingOrEvent);

        const finalStart = startMoment.isValid() ? startMoment.toDate() : new Date();
        const finalEnd = endMoment.isValid() ? endMoment.toDate() : finalStart;

        const explicitId = rawEvent.id || rawEvent.Id || rawEvent.calendar_event_id || rawEvent.calendarEventId || rawEvent.event_id || rawEvent.eventId;

        return {
          id: explicitId ? String(explicitId) : `event_${categoryVal}_${titleVal}_${finalStart.getTime()}`,
          title: formatEventDisplayTitle({ title: titleVal, category: categoryVal, resource: rawEvent }),
          start: finalStart,
          end: finalEnd,
          allDay: isAllDayVal,
          category: categoryVal,
          resource: rawEvent,
        };
      });

      const deduped = [];
      const seenEventKeys = new Set();

      list.forEach((event) => {
        const origEvent = event.resource || {};
        const explicitId = origEvent.calendar_event_id ?? origEvent.calendarEventId ?? origEvent.event_id ?? origEvent.eventId ?? origEvent.Id ?? origEvent.id ?? event.id;
        const category = getComparableCalendarCategory(origEvent);
        const rawTitle = String(getEventTitleValue(origEvent)).trim();
        const cleanTitle = rawTitle.replace(/^(title|reminder|calendar|event|meeting|leave)\s*[-:]\s*/i, "").trim().toLowerCase();
        const startSource = origEvent.StartTime || origEvent.start || origEvent.date || event.start;
        const startMoment = parseCalendarDateValue(startSource, false);
        const normalizedDay = startMoment.isValid() ? startMoment.format("YYYY-MM-DD") : "";

        const idKey = explicitId ? `${category || "item"}|${explicitId}` : null;
        const contentKey = `${category || "item"}|${cleanTitle || "untitled"}|${normalizedDay || "no-start"}`;

        if ((idKey && seenEventKeys.has(idKey)) || (contentKey && seenEventKeys.has(contentKey))) {
          return;
        }

        if (idKey) seenEventKeys.add(idKey);
        if (contentKey) seenEventKeys.add(contentKey);

        deduped.push(event);
      });

      deduped.sort((a, b) => {
        const startA = a.start.getTime();
        const startB = b.start.getTime();
        if (startA !== startB) {
          return startA - startB;
        }

        // Same day: Last added item (higher recency score) comes FIRST
        const recencyA = getEventRecencyScore(a);
        const recencyB = getEventRecencyScore(b);
        if (recencyA !== recencyB) {
          return recencyB - recencyA;
        }

        const endA = a.end.getTime();
        const endB = b.end.getTime();
        if (endA !== endB) {
          return endB - endA; // longer events first
        }

        const allDayA = Boolean(a.allDay);
        const allDayB = Boolean(b.allDay);
        if (allDayA !== allDayB) {
          return allDayA ? -1 : 1; // allDay first
        }

        return (a.title || "").localeCompare(b.title || "");
      });

      return deduped;
    },
    [events, categoryFilters]
  );
  const eventsByDay = useMemo(() => {
    const rawAcc = calendarEvents.reduce((accumulator, event) => {
      if (!event || !event.start) {
        return accumulator;
      }

      const isLeave = isLeaveEvent(event);
      const origEvent = event.resource || event;
      const categoryVal = getComparableCalendarCategory(origEvent);
      const isUpcomingOrEvent = categoryVal === "upcoming" || categoryVal === "event" || categoryVal === "holiday" || Boolean(origEvent.upcomingEventdate || origEvent.upcoming_event_date);

      const startMoment = moment(event.start).startOf("day");
      let endMoment = moment(event.end || event.start).startOf("day");

      if (isUpcomingOrEvent) {
        const explicitEndVal = origEvent.EndDate || origEvent.endDate || origEvent.end_date || origEvent.leave_end_date;
        const hasExplicitDifferentEnd = Boolean(
          explicitEndVal &&
          moment(explicitEndVal, ["YYYY-MM-DD", "DD-MM-YYYY"]).format("YYYY-MM-DD") !== startMoment.format("YYYY-MM-DD")
        );
        if (!hasExplicitDifferentEnd) {
          endMoment = startMoment.clone();
        }
      }

      const current = startMoment.clone();
      while (current.isSameOrBefore(endMoment, "day")) {
        const dateKey = current.format("YYYY-MM-DD");
        const dayOfWeek = current.day(); // 0 is Sunday, 6 is Saturday

        if (isLeave && (dayOfWeek === 0 || dayOfWeek === 6)) {
          current.add(1, "day");
          continue;
        }

        if (!accumulator[dateKey]) {
          accumulator[dateKey] = [];
        }

        if (!accumulator[dateKey].some((item) => {
          if (item.id === event.id) return true;
          const origEvent = event.resource || event;
          const origItem = item.resource || item;
          const cleanTitle1 = String(getEventTitleValue(origEvent)).replace(/^(title|reminder|calendar|event|meeting|leave)\s*[-:]\s*/i, "").trim().toLowerCase();
          const cleanTitle2 = String(getEventTitleValue(origItem)).replace(/^(title|reminder|calendar|event|meeting|leave)\s*[-:]\s*/i, "").trim().toLowerCase();
          const cat1 = getComparableCalendarCategory(origEvent);
          const cat2 = getComparableCalendarCategory(origItem);
          return cleanTitle1 === cleanTitle2 && cat1 === cat2;
        })) {
          accumulator[dateKey].push(event);
        }

        current.add(1, "day");
      }

      return accumulator;
    }, {});

    Object.keys(rawAcc).forEach((dateKey) => {
      rawAcc[dateKey].sort((a, b) => {
        const recencyA = getEventRecencyScore(a);
        const recencyB = getEventRecencyScore(b);
        if (recencyA !== recencyB) {
          return recencyB - recencyA; // Last added FIRST
        }
        return 0;
      });
    });

    return rawAcc;
  }, [calendarEvents]);

  const monthCalendarEvents = useMemo(() => {
    return Object.keys(eventsByDay)
      .map((dateKey) => {
        const dayEvents = eventsByDay[dateKey];
        if (!Array.isArray(dayEvents) || dayEvents.length === 0) {
          return null;
        }

        const firstEvent = dayEvents[0];
        const dayMoment = moment(dateKey, "YYYY-MM-DD");

        return {
          ...firstEvent,
          id: `month_${dateKey}_${firstEvent.id}`,
          start: dayMoment.clone().startOf("day").toDate(),
          end: dayMoment.clone().startOf("day").add(23, "hours").add(59, "minutes").toDate(),
          allDay: true,
          originalEvent: firstEvent,
          dateKey: dateKey,
        };
      })
      .filter(Boolean);
  }, [eventsByDay]);

  const displayedCalendarEvents = currentView === Views.MONTH ? monthCalendarEvents : calendarEvents;
  const popoverEvents = morePopover.dateKey ? (eventsByDay[morePopover.dateKey] || []) : [];

  const handleRangeChange = (range, view = currentView) => {
    if (typeof onRangeChange !== "function") {
      return;
    }

    const normalized = normalizeRange(range, view);
    if (normalized) {
      onRangeChange(normalized.start, normalized.end);
    }
  };

  const scrollToAndHighlightToday = () => {
    setTimeout(() => {
      const todayEl =
        document.querySelector(".dashboard-calendar-card .rbc-now") ||
        document.querySelector(".dashboard-calendar-card .dashboard-calendar-day-today");

      if (todayEl) {
        todayEl.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      }
    }, 120);
  };

  const handleNavigate = (date, view, action) => {
    setCurrentDate(date);
    if (action === "TODAY" || moment(date).isSame(new Date(), "day")) {
      scrollToAndHighlightToday();
    }
  };

  const handleViewChange = (view) => {
    setCurrentView(view);
  };

  const handleOpenViewMenu = (anchorEl) => {
    if (!anchorEl) {
      return;
    }

    const triggerRect = anchorEl.getBoundingClientRect();
    setViewMenuAnchorPosition({
      top: Math.round(triggerRect.bottom + 6),
      left: Math.round(triggerRect.left),
    });
  };

  const handleCloseViewMenu = () => {
    setViewMenuAnchorPosition(null);
  };

  const handleSelectView = (view) => {
    setCurrentView(view);
    setViewMenuAnchorPosition(null);
  };

  const handleSelectSlot = (slotInfo) => {
    if (Date.now() - lastDeleteTimeRef.current < 1200) {
      return;
    }
    const { start, end, box, req } = slotInfo;

    const clientX = box ? box.clientX : (req ? req.clientX : (window.event ? window.event.clientX : null));
    const clientY = box ? box.clientY : (req ? req.clientY : (window.event ? window.event.clientY : null));

    const computedTop = clientY ? Math.max(150, Math.min(clientY + 5, window.innerHeight - 520)) : 200;
    const computedLeft = clientX ? Math.max(20, Math.min(clientX + 5, window.innerWidth - 650)) : 400;

    setAddPopover({
      anchorPosition: { top: computedTop, left: computedLeft },
      start,
      end,
      formattedDate: formatPopoverDateText(start, end),
      mode: "create",
      eventId: null,
    });
    setAddTab("title");
    setAddEventTitle("");
    setAddEventDescription("");
    setEventDescription("");
    setEventDate(start ? moment(start).format("YYYY-MM-DD") : "");
    setEventImageUrl(null);
    setTargetUsers([]);
    setEventDetailsPopover(createEmptyEventDetailsState());
  };

  const handleLeaveStartDateChange = (val) => {
    const dateStr = typeof val === "object" && val !== null && val.target ? val.target.value : val;
    setLeaveStartDate(dateStr);
    const errors = { ...leaveFormErrors };

    if (!dateStr) {
      errors.startDate = "Cannot be blank";
    } else {
      delete errors.startDate;
    }

    const currentEndRaw = leaveEndDate || dateStr;
    const currentEnd = typeof currentEndRaw === "object" && currentEndRaw !== null && currentEndRaw.target ? currentEndRaw.target.value : currentEndRaw;

    if (currentEnd && dateStr && moment(currentEnd, "YYYY-MM-DD").isBefore(moment(dateStr, "YYYY-MM-DD"), "day")) {
      errors.endDate = "End date cannot be before start date";
      swal("Invalid Date", "End date cannot be before start date", "error");
    } else {
      delete errors.endDate;
    }

    setLeaveFormErrors(errors);
  };

  const handleLeaveEndDateChange = (val) => {
    const dateStr = typeof val === "object" && val !== null && val.target ? val.target.value : val;
    setLeaveEndDate(dateStr);
    const errors = { ...leaveFormErrors };

    if (!dateStr) {
      errors.endDate = "Cannot be blank";
    } else {
      const currentStartRaw = leaveStartDate || eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : "");
      const currentStart = typeof currentStartRaw === "object" && currentStartRaw !== null && currentStartRaw.target ? currentStartRaw.target.value : currentStartRaw;
      if (currentStart && dateStr && moment(dateStr, "YYYY-MM-DD").isBefore(moment(currentStart, "YYYY-MM-DD"), "day")) {
        errors.endDate = "End date cannot be before start date";
        swal("Invalid Date", "End date cannot be before start date", "error");
      } else {
        delete errors.endDate;
      }
    }

    setLeaveFormErrors(errors);
  };

  const handleCloseAddPopover = () => {
    setAddPopover(createEmptyAddPopoverState());
    setAddTab("title");
    setAddEventTitle("");
    setAddEventDescription("");
    setEventDescription("");
    setAllDay(true);
    setStartTime("07:30");
    setEndTime("18:00");
    setShowToAll(true);
    setEventDate("");
    setLeaveStartDate("");
    setLeaveEndDate("");
    setLeaveFormErrors({});
    setEventImageUrl(null);
    setTargetUsers([]);
  };

  const handleMoreDetails = () => {
    if (typeof onApplyLeave === "function" && addPopover.start) {
      onApplyLeave(addPopover.start, addPopover.end, addEventTitle);
    }
    handleCloseAddPopover();
    setTargetUsers([]);
  };

  const isSavingQuickEventRef = useRef(false);

  const handleSaveQuickEvent = async () => {
    if (isSavingQuickEventRef.current) {
      return;
    }
    isSavingQuickEventRef.current = true;

    try {
      await executeSaveQuickEvent();
    } finally {
      isSavingQuickEventRef.current = false;
    }
  };

  const executeSaveQuickEvent = async () => {
    let titleToSave = addEventTitle.trim();

    if (addTab === "event") {
      const titleToSave = addEventTitle.trim();
      const dateToSave = eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : "");
      const descToSave = eventDescription.trim();

      if (!titleToSave) {
        swal("Warning", "Please enter Event Name!", "warning");
        return;
      }
      if (!dateToSave) {
        swal("Warning", "Please select Event Date!", "warning");
        return;
      }

      swal({
        title: addPopover.mode === "edit" ? "Updating Event..." : "Saving Event...",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });

      try {
        let res1;
        if (addPopover.mode === "edit" && addPopover.eventId) {
          res1 = await AuthApi.updateUpcomingEvent(
            {
              upcomingEventName: titleToSave,
              upcomingEventdate: dateToSave,
              description: descToSave || titleToSave,
              image: eventImageUrl || null
            },
            addPopover.eventId
          );
        } else {
          res1 = await AuthApi.createUpcomingEvent({
            upcomingEventName: titleToSave,
            upcomingEventdate: dateToSave,
            description: descToSave || titleToSave,
            image: eventImageUrl || null
          });
        }

        swal.close();

        if ((res1 && res1.status === true) || res1) {
          swal("Success", addPopover.mode === "edit" ? "Event updated successfully!" : "Event added successfully!", "success");
          handleCloseAddPopover();
          if (typeof onRangeChange === "function") {
            onRangeChange();
          }
        } else {
          swal("Error", (res1 && res1.message) ? res1.message : "Something went wrong, Please try later!", "error");
        }
      } catch (err) {
        swal.close();
        swal("Error", "Something went wrong, Please try later!", "error");
      }
      return;
    }

    if (addTab === "holiday") {
      const titleToSave = addEventTitle.trim();
      const dateToSave = eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : "");

      if (!titleToSave) {
        swal("Warning", "Please enter Holiday Name!", "warning");
        return;
      }
      if (!dateToSave) {
        swal("Warning", "Please select Holiday Date!", "warning");
        return;
      }

      swal({
        title: addPopover.mode === "edit" ? "Updating Holiday..." : "Saving Holiday...",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });

      try {
        let res1;
        const formattedDate = moment(dateToSave, "YYYY-MM-DD").format("DD-MM-YYYY");

        if (addPopover.mode === "edit" && addPopover.eventId) {
          res1 = await AuthApi.updateLeave(
            { leaveName: titleToSave, date: formattedDate, leave_id: addPopover.eventId },
            addPopover.eventId
          );
        } else {
          res1 = await AuthApi.createHoliday({
            leaveName: titleToSave,
            date: formattedDate,
          });
        }

        swal.close();

        if ((res1 && res1.status === true) || res1) {
          swal("Success", addPopover.mode === "edit" ? "Holiday updated successfully!" : "Holiday added successfully!", "success");
          handleCloseAddPopover();
          if (typeof onRangeChange === "function") {
            onRangeChange();
          }
        } else {
          swal("Error", (res1 && res1.message) ? res1.message : "Something went wrong, Please try later!", "error");
        }
      } catch (err) {
        swal.close();
        swal("Error", "Something went wrong, Please try later!", "error");
      }
      return;
    }

    if (addTab === "timeEntry") {
      const dateToSave = eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : "");
      const sTime = startTime || "07:30";
      const eTime = endTime || "18:00";
      const reasonToSave = addEventDescription.trim();

      if (!dateToSave) {
        swal("Warning", "Please select Date!", "warning");
        return;
      }
      if (!reasonToSave) {
        swal("Warning", "Please enter Reason!", "warning");
        return;
      }

      swal({
        title: "Saving Time Entry...",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });

      try {
        const userObj = ls("user") || {};
        const userId = userObj.id || userObj.Id;

        const res1 = await AuthApi.addTime({
          id: userId,
          selectedDate: dateToSave,
          startTime: sTime,
          endTime: eTime,
          reason: reasonToSave,
        });

        swal.close();

        if (res1 && (res1.status === true || res1 === true)) {
          swal("Success", "Time entry added successfully", "success");
          try {
            window.dispatchEvent(
              new CustomEvent("cherrypik_new_notification", {
                detail: {
                  title: "Time Entry",
                  message: `${userObj.firstName || 'User'} added a time entry`,
                  type: "Time-Entry",
                },
              })
            );
            window.dispatchEvent(new Event("cherrypik_refresh_notifications"));
          } catch (e) {
            // ignore
          }
          handleCloseAddPopover();
          if (typeof onRangeChange === "function") {
            onRangeChange();
          }
        } else {
          swal("Error", (typeof res1 === "string" ? res1 : (res1 && res1.message) ? res1.message : "Something went wrong, Please try later!"), "error");
        }
      } catch (err) {
        swal.close();
        swal("Error", "Something went wrong, Please try later!", "error");
      }
      return;
    }

    if (addTab === "leave") {
      const sDateRaw = leaveStartDate || eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : "");
      const eDateRaw = leaveEndDate || sDateRaw;
      const sDate = typeof sDateRaw === "object" && sDateRaw !== null && sDateRaw.target ? sDateRaw.target.value : sDateRaw;
      const eDate = typeof eDateRaw === "object" && eDateRaw !== null && eDateRaw.target ? eDateRaw.target.value : eDateRaw;
      const desc = addEventDescription.trim();

      const errors = {};
      if (!sDate) {
        errors.startDate = "Cannot be blank";
      }
      if (!eDate) {
        errors.endDate = "Cannot be blank";
      } else if (sDate && moment(eDate, "YYYY-MM-DD").isBefore(moment(sDate, "YYYY-MM-DD"), "day")) {
        errors.endDate = "End date cannot be before start date";
        swal("Invalid Date", "End date cannot be before start date", "error");
        setLeaveFormErrors(errors);
        return;
      }
      if (!desc) {
        errors.description = "Cannot be blank";
      }

      if (Object.keys(errors).length > 0) {
        setLeaveFormErrors(errors);
        swal("Warning", errors.endDate || errors.startDate || errors.description || "Please fill all required fields!", "warning");
        return;
      }

      if (addPopover.start) {
        addPopover.start = moment(sDate, "YYYY-MM-DD").toDate();
        addPopover.end = moment(eDate, "YYYY-MM-DD").toDate();
      }
    }

    titleToSave = addEventTitle.trim() || (addTab === "leave" ? leaveType : titleToSave);

    if (addTab === "meeting" && titleToSave) {
      const cleanTitle = titleToSave.replace(/^(title|reminder|calendar)\s*[-:]\s*/i, "").trim();
      if (!/^meeting\s*[-:]/i.test(cleanTitle)) {
        titleToSave = `Meeting - ${cleanTitle}`;
      } else {
        titleToSave = cleanTitle;
      }
    }

    if (addTab === "meeting" && !addEventTitle.trim()) {
      swal("Warning", "Please enter Meeting Name!", "warning");
      return;
    }

    if (!titleToSave && addTab !== "leave") {
      swal("Warning", "Please enter a title!", "warning");
      return;
    }

    if (typeof onSaveQuickLeave === "function" && addPopover.start) {
      let finalStart = addPopover.start;
      let finalEnd = addPopover.end;

      if (!allDay) {
        const dateStr = moment(addPopover.start).format("YYYY-MM-DD");
        const startDateTime = parseFlexibleTimeMoment(dateStr, startTime);

        const startMoment = moment(addPopover.start);
        const rawEndMoment = addPopover.end ? moment(addPopover.end) : startMoment;
        const hasSingleDaySelection = !addPopover.end || rawEndMoment.diff(startMoment, "days") <= 1;

        const endDateStr = hasSingleDaySelection
          ? dateStr
          : rawEndMoment.clone().subtract(1, "day").format("YYYY-MM-DD");

        const endDateTime = parseFlexibleTimeMoment(endDateStr, endTime);

        finalStart = startDateTime.toDate();
        finalEnd = endDateTime.toDate();
      }

      const descriptionToSave = addEventDescription.trim();

      const targetUserIds = targetUsers ? targetUsers.map(u => u.value) : [];
      const computedShowToAll = (allUsers && allUsers.length > 0 && targetUsers.length === allUsers.length) ? true : false;

      const extraLeaveData = {
        leaveType: leaveType,
        firstleavetype: firstLeaveHalf,
        secondleavetype: secondLeaveHalf,
        leaveStartDate: leaveStartDate || eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : ""),
        leaveEndDate: leaveEndDate || leaveStartDate || eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : ""),
      };

      if (addTab === "meeting" && targetUsers && targetUsers.length > 0) {
        saveStoredMeetingTargetUsers({ title: titleToSave, start: finalStart, id: addPopover.eventId }, targetUsers);
      }

      if (addPopover.mode === "edit" && typeof onUpdateQuickEvent === "function" && addPopover.eventId) {
        const didUpdate = await onUpdateQuickEvent(
          addPopover.eventId,
          finalStart,
          finalEnd,
          titleToSave,
          descriptionToSave,
          allDay,
          computedShowToAll,
          addPopover.eventMeta || null,
          targetUserIds,
          addTab,
          extraLeaveData
        );
        if (didUpdate) {
          handleCloseAddPopover();
          setTargetUsers([]);
        }
      } else if (typeof onSaveQuickLeave === "function") {
        const didSave = await onSaveQuickLeave(
          finalStart,
          finalEnd,
          titleToSave,
          descriptionToSave,
          allDay,
          computedShowToAll,
          targetUserIds,
          addTab,
          extraLeaveData
        );
        if (didSave) {
          handleCloseAddPopover();
          setTargetUsers([]);
        }
      }
    }
  };
  const handleOpenMorePopover = (nativeEvent, dateKey) => {
    nativeEvent.preventDefault();
    nativeEvent.stopPropagation();
    const triggerRect = nativeEvent.currentTarget.getBoundingClientRect();

    let top = Math.round(triggerRect.bottom + 2);
    let left = Math.round(triggerRect.left);

    if (typeof window !== "undefined") {
      const popoverWidth = 240;
      const popoverHeight = 260;
      left = Math.max(16, Math.min(left, window.innerWidth - popoverWidth - 16));
      top = Math.max(16, Math.min(top, window.innerHeight - popoverHeight - 16));
    }

    setMorePopover({
      anchorEl: nativeEvent.currentTarget,
      anchorPosition: {
        top,
        left,
      },
      dateKey,
    });
  };
  const handleCloseMorePopover = () => {
    setMorePopover({
      anchorEl: null,
      anchorPosition: null,
      dateKey: "",
    });
  };

  const handleSelectEventFromMorePopover = (selectedEvent, nativeEvent) => {
    const currentAnchor = morePopover.anchorPosition;
    handleCloseMorePopover();
    handleSelectEvent(selectedEvent, nativeEvent, currentAnchor);
  };

  const handleSelectEvent = (selectedEvent, nativeEvent, overrideAnchorPosition) => {
    const triggerRect = nativeEvent && nativeEvent.currentTarget
      ? nativeEvent.currentTarget.getBoundingClientRect()
      : null;

    let anchor = overrideAnchorPosition;
    if (!anchor && triggerRect) {
      anchor = { top: Math.round(triggerRect.bottom + 8), left: Math.round(triggerRect.left) };
    }
    if (!anchor) {
      anchor = { top: 220, left: 420 };
    }

    let top = anchor.top;
    let left = anchor.left;

    if (typeof window !== "undefined") {
      const popoverWidth = 340;
      const popoverHeight = 320;
      left = Math.max(16, Math.min(left, window.innerWidth - popoverWidth - 16));
      top = Math.max(16, Math.min(top, window.innerHeight - popoverHeight - 16));
    }

    setEventDetailsPopover({
      anchorPosition: { top, left },
      event: selectedEvent,
    });
    setViewMenuAnchorPosition(null);
    setMorePopover((prev) => ({ ...prev, anchorPosition: null, dateKey: "" }));
  };

  const handleCloseEventDetailsPopover = () => {
    setEventDetailsPopover(createEmptyEventDetailsState());
  };

  const handleEditSelectedEvent = () => {
    const selectedEvent = eventDetailsPopover.event;
    if (!selectedEvent) {
      return;
    }

    const rawEvent = selectedEvent.resource || {};
    const updateMeta = getEventUpdateMeta(rawEvent, selectedEvent.category);
    const resolvedEventId = getEventIdentifier(rawEvent);
    const category = String(selectedEvent.category || rawEvent.Category || rawEvent.category || "").toLowerCase();
    const strategy = updateMeta ? updateMeta.strategy : category;

    if (strategy === "event" || strategy === "upcoming" || category === "event" || category === "upcoming") {
      const detailsAnchor = eventDetailsPopover.anchorPosition;
      handleCloseEventDetailsPopover();

      const rawEventName = rawEvent.upcomingEventName || rawEvent.upcoming_event_name || rawEvent.eventName || rawEvent.name || getEventTitleValue(rawEvent) || selectedEvent.title || "";
      const cleanEventName = String(rawEventName).replace(/^(meeting|title|reminder|calendar|event|holiday|leave|birthday|bday)\s*[-:]\s*/i, "").trim();
      const eventDateVal = rawEvent.upcomingEventdate || rawEvent.upcoming_event_date || rawEvent.eventdate || rawEvent.date || (selectedEvent.start ? moment(selectedEvent.start).format("YYYY-MM-DD") : "");
      const eventDesc = rawEvent.description || rawEvent.Description || selectedEvent.description || "";
      const eventImg = rawEvent.image || rawEvent.image_url || rawEvent.img || null;

      setAddPopover({
        anchorPosition: detailsAnchor || { top: 200, left: 400 },
        start: selectedEvent.start,
        end: selectedEvent.end,
        formattedDate: moment(selectedEvent.start).format("YYYY-MM-DD"),
        mode: "edit",
        eventId: resolvedEventId || (updateMeta ? updateMeta.id : null),
        eventMeta: updateMeta,
      });
      setAddTab("event");
      setAddEventTitle(cleanEventName);
      setEventDate(eventDateVal);
      setEventDescription(eventDesc);
      setEventImageUrl(eventImg);
      return;
    }

    if (strategy === "holiday" || category === "holiday") {
      const detailsAnchor = eventDetailsPopover.anchorPosition;
      handleCloseEventDetailsPopover();

      const holidayName = rawEvent.leaveName || rawEvent.leave_name || rawEvent.name || getEventTitleValue(rawEvent) || selectedEvent.title || "";
      const cleanHolidayName = String(holidayName).replace(/^(meeting|title|reminder|calendar|event|holiday|leave|birthday|bday)\s*[-:]\s*/i, "").trim();
      const rawDate = rawEvent.date || rawEvent.holidayDate || (selectedEvent.start ? moment(selectedEvent.start).format("YYYY-MM-DD") : "");
      const holidayDateVal = moment(rawDate, ["YYYY-MM-DD", "DD-MM-YYYY"]).isValid()
        ? moment(rawDate, ["YYYY-MM-DD", "DD-MM-YYYY"]).format("YYYY-MM-DD")
        : (selectedEvent.start ? moment(selectedEvent.start).format("YYYY-MM-DD") : "");

      setAddPopover({
        anchorPosition: detailsAnchor || { top: 200, left: 400 },
        start: selectedEvent.start,
        end: selectedEvent.end,
        formattedDate: moment(selectedEvent.start).format("YYYY-MM-DD"),
        mode: "edit",
        eventId: resolvedEventId || (updateMeta ? updateMeta.id : null),
        eventMeta: updateMeta,
      });
      setAddTab("holiday");
      setAddEventTitle(cleanHolidayName);
      setEventDate(holidayDateVal);
      return;
    }

    if (strategy === "leave" || category === "leave") {
      const detailsAnchor = eventDetailsPopover.anchorPosition;
      handleCloseEventDetailsPopover();

      const leaveTitleVal = rawEvent.leaveName || rawEvent.leave_name || rawEvent.name || getEventTitleValue(rawEvent) || selectedEvent.title || "Leave";
      const cleanLeaveTitle = String(leaveTitleVal).replace(/^(meeting|title|reminder|calendar|event|holiday|leave|birthday|bday)\s*[-:]\s*/i, "").trim();
      const rawDate = rawEvent.date || rawEvent.startDate || (selectedEvent.start ? moment(selectedEvent.start).format("YYYY-MM-DD") : "");
      const rawEndDate = rawEvent.endDate || rawEvent.end_date || rawDate;
      const leaveDateVal = moment(rawDate, ["YYYY-MM-DD", "DD-MM-YYYY"]).isValid()
        ? moment(rawDate, ["YYYY-MM-DD", "DD-MM-YYYY"]).format("YYYY-MM-DD")
        : (selectedEvent.start ? moment(selectedEvent.start).format("YYYY-MM-DD") : "");
      const leaveEndDateVal = moment(rawEndDate, ["YYYY-MM-DD", "DD-MM-YYYY"]).isValid()
        ? moment(rawEndDate, ["YYYY-MM-DD", "DD-MM-YYYY"]).format("YYYY-MM-DD")
        : leaveDateVal;
      const leaveDesc = rawEvent.description || rawEvent.Description || rawEvent.reason || selectedEvent.description || "";
      const leaveTypeVal = rawEvent.leaveType || rawEvent.leave_type || "Loss Of Pay";
      const fHalf = rawEvent.firstleavetype || rawEvent.first_leave_type || "first-half";
      const sHalf = rawEvent.secondleavetype || rawEvent.second_leave_type || "second-half";

      setAddPopover({
        anchorPosition: detailsAnchor || { top: 200, left: 400 },
        start: selectedEvent.start,
        end: selectedEvent.end,
        formattedDate: moment(selectedEvent.start).format("YYYY-MM-DD"),
        mode: "edit",
        eventId: resolvedEventId || (updateMeta ? updateMeta.id : null),
        eventMeta: updateMeta,
      });
      setAddTab("leave");
      setAddEventTitle(cleanLeaveTitle);
      setLeaveType(leaveTypeVal);
      setLeaveStartDate(leaveDateVal);
      setLeaveEndDate(leaveEndDateVal);
      setFirstLeaveHalf(fHalf);
      setSecondLeaveHalf(sHalf);
      setAddEventDescription(leaveDesc);
      return;
    }

    if (
      updateMeta &&
      updateMeta.strategy &&
      updateMeta.strategy !== "calendar" &&
      typeof onOpenEditItem === "function" &&
      resolvedEventId
    ) {
      handleCloseEventDetailsPopover();
      onOpenEditItem(resolvedEventId, {
        ...updateMeta,
        rawEvent,
        category: selectedEvent.category || rawEvent.Category || rawEvent.category || "",
        updateStrategy: updateMeta.strategy,
      });
      return;
    }

    const rawStartSource =
      rawEvent.StartTime ||
      rawEvent.startTime ||
      rawEvent.startDate ||
      rawEvent.start_date ||
      rawEvent.start ||
      rawEvent.date ||
      rawEvent.eventdate ||
      rawEvent.event_date ||
      selectedEvent.start;

    const rawEndSource =
      rawEvent.EndTime ||
      rawEvent.endTime ||
      rawEvent.endDate ||
      rawEvent.end_date ||
      rawEvent.end ||
      rawEvent.date ||
      selectedEvent.end ||
      rawStartSource;

    const startMoment = parseCalendarDateValue(rawStartSource, false);
    const endMoment = parseCalendarDateValue(rawEndSource, false);
    const start = startMoment.isValid() ? startMoment.toDate() : selectedEvent.start;
    const end = endMoment.isValid() ? endMoment.toDate() : selectedEvent.end;

    const rawShowToAll =
      rawEvent.showToAll ??
      rawEvent.show_to_all ??
      rawEvent.ShowToAll ??
      rawEvent.show_all ??
      rawEvent.is_show_all ??
      selectedEvent.showToAll ??
      selectedEvent.show_to_all;

    const parsedAllDayFlag = getRawAllDayFlag(rawEvent);
    let isAllDayValue = false;
    if (typeof parsedAllDayFlag === "boolean") {
      isAllDayValue = parsedAllDayFlag;
    } else if (hasExplicitTime(rawStartSource) || hasExplicitTime(rawEndSource)) {
      isAllDayValue = false;
    } else {
      isAllDayValue = Boolean(selectedEvent.allDay);
    }

    const initialTargetUsers = resolveTargetUsersForEdit(rawEvent, allUsers);

    const rawTitleStr = String(getEventTitleValue(rawEvent) || selectedEvent.title || "").toLowerCase();
    const editCat = String(selectedEvent.category || rawEvent.Category || rawEvent.category || rawEvent.categoryName || updateMeta?.category || "").trim().toLowerCase();

    let resolvedTab = "title";
    if (editCat === "meeting" || rawTitleStr.includes("meeting") || rawTitleStr.includes("scrum")) {
      resolvedTab = "meeting";
    } else if (editCat === "event" || editCat === "upcoming") {
      resolvedTab = "event";
    } else if (editCat === "holiday") {
      resolvedTab = "holiday";
    } else if (editCat === "leave") {
      resolvedTab = "leave";
    } else if (editCat === "timeentry" || editCat === "time") {
      resolvedTab = "timeEntry";
    } else {
      resolvedTab = "title";
    }

    setAddPopover({
      anchorPosition: eventDetailsPopover.anchorPosition || { top: 220, left: 420 },
      start,
      end,
      formattedDate: formatPopoverDateText(start, end),
      mode: "edit",
      eventId: resolvedEventId,
      eventMeta: {
        ...updateMeta,
        rawEvent,
        category: resolvedTab,
        updateStrategy: updateMeta?.strategy || null,
      },
    });
    setAddTab(resolvedTab);
    let titleVal = getEventTitleValue(rawEvent) || selectedEvent.title || "";
    titleVal = titleVal.replace(/^(meeting|title|reminder|calendar|event|holiday|leave)\s*[-:]\s*/i, "").trim();
    setAddEventTitle(titleVal);

    const descriptionVal =
      rawEvent.description ||
      rawEvent.Description ||
      rawEvent.details ||
      rawEvent.Details ||
      rawEvent.eventDetails ||
      rawEvent.event_details ||
      rawEvent.message ||
      rawEvent.Message ||
      rawEvent.reason ||
      rawEvent.Reason ||
      rawEvent.ticketMessage ||
      rawEvent.ticket_message ||
      selectedEvent.description ||
      "";
    setAddEventDescription(getCleanDescriptionText(descriptionVal));

    setAllDay(isAllDayValue);
    setShowToAll(getBooleanFlag(rawShowToAll, false));
    setTargetUsers(initialTargetUsers);

    setStartTime(startMoment.isValid() ? startMoment.format("hh:mm A") : "09:00 AM");
    setEndTime(endMoment.isValid() ? endMoment.format("hh:mm A") : "10:00 AM");
    handleCloseEventDetailsPopover();
  };

  const handleDeleteSelectedEvent = async (nativeEvent) => {
    if (nativeEvent) {
      if (typeof nativeEvent.preventDefault === "function") nativeEvent.preventDefault();
      if (typeof nativeEvent.stopPropagation === "function") nativeEvent.stopPropagation();
    }
    lastDeleteTimeRef.current = Date.now();

    const selectedEvent = eventDetailsPopover.event;
    if (!selectedEvent) {
      return;
    }

    const rawEvent = selectedEvent.resource || {};
    const deleteMeta = getEventDeleteMeta(rawEvent, selectedEvent.category);
    if (!deleteMeta || !deleteMeta.id || !isDeleteSupportedForMeta(deleteMeta) || typeof onDeleteQuickEvent !== "function") {
      swal("Error", "This event cannot be deleted right now.", "error");
      return;
    }

    handleCloseEventDetailsPopover();
    onDeleteQuickEvent(
      deleteMeta.id,
      getEventTitleValue(rawEvent) || selectedEvent.title || "this event",
      {
        category: selectedEvent.category || rawEvent.Category || rawEvent.category || "",
        rawEvent,
        deleteStrategy: deleteMeta.strategy,
      }
    );
  };

  const eventPropGetter = (event) => ({
    className: `dashboard-calendar-rbc-event dashboard-calendar-rbc-event-${event.category}`,
    style: {
      backgroundColor: "transparent",
      border: "none",
      padding: 0,
      boxShadow: "none",
    },
  });

  const dayPropGetter = (date) => {
    const isToday = moment(date).isSame(new Date(), "day");
    return {
      className: isToday ? "dashboard-calendar-day-today" : "",
    };
  };
  const isSelectedEventReadonly = Boolean(
    eventDetailsPopover.event?.resource?.Readonly ??
    eventDetailsPopover.event?.resource?.readonly ??
    false
  );

  const selectedEventCategory = String(
    eventDetailsPopover.event?.category ||
    eventDetailsPopover.event?.resource?.Category ||
    ""
  ).toLowerCase();

  const selectedEventTitleLower = String(
    eventDetailsPopover.event?.title ||
    getEventTitleValue(eventDetailsPopover.event?.resource) ||
    ""
  ).toLowerCase();

  const isSelectedEventLeave = selectedEventCategory === "leave";
  const isSelectedEventBirthday =
    selectedEventCategory === "birthday" ||
    selectedEventCategory === "bday" ||
    selectedEventTitleLower.startsWith("birthday") ||
    selectedEventTitleLower.includes("birthday") ||
    selectedEventTitleLower.includes("bday");

  const isSelectedEventTimeEntry =
    selectedEventCategory === "time-entry" ||
    selectedEventCategory === "time_entry" ||
    selectedEventCategory === "timeentry" ||
    selectedEventCategory === "time entry" ||
    selectedEventTitleLower.includes("time entry") ||
    (eventDetailsPopover.event && getEventCategoryKey(eventDetailsPopover.event) === "Time Entry");

  const isSelectedEventMeeting =
    selectedEventCategory === "meeting" ||
    selectedEventTitleLower.startsWith("meeting") ||
    selectedEventTitleLower.includes("meeting");

  const canEditSelectedEvent = Boolean(
    eventDetailsPopover.event &&
    !isSelectedEventLeave &&
    !isSelectedEventBirthday &&
    !isSelectedEventTimeEntry &&
    (!isSelectedEventReadonly || isAdmin) &&
    getEventUpdateMeta(
      eventDetailsPopover.event.resource || {},
      eventDetailsPopover.event.category
    )
  );

  const canDeleteSelectedEvent = Boolean(
    eventDetailsPopover.event &&
    !isSelectedEventLeave &&
    !isSelectedEventBirthday &&
    !isSelectedEventTimeEntry &&
    (!isSelectedEventReadonly || isAdmin) &&
    isDeleteSupportedForMeta(
      getEventDeleteMeta(
        eventDetailsPopover.event.resource || {},
        eventDetailsPopover.event.category
      )
    )
  );

  const hexToRgba = (hex, alpha = 0.18) => {
    if (!hex || typeof hex !== "string") return null;
    let c = hex.replace("#", "");
    if (c.length === 3) {
      c = c.split("").map((x) => x + x).join("");
    }
    if (c.length !== 6) return null;
    const num = parseInt(c, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const getEventPillStyle = (evt) => {
    let catKey = getEventCategoryKey(evt);
    if (catKey.startsWith("Time Entry")) {
      catKey = "Time Entry";
    }
    const customHex = calendarColors?.[catKey] || (catKey === "Todo" ? calendarColors?.["Title"] : null);

    if (!customHex) {
      return { pillStyle: {}, dotStyle: {} };
    }

    const bgRgba = hexToRgba(customHex, 0.18) || customHex;
    return {
      pillStyle: {
        backgroundColor: bgRgba,
        color: customHex,
        borderLeft: `3px solid ${customHex}`,
      },
      dotStyle: {
        backgroundColor: customHex,
      },
    };
  };

  const getLeaveCategoryClass = (evt) => {
    const evtCat = String(evt?.category || evt?.resource?.Category || evt?.resource?.category || "").toLowerCase();
    const titleLower = String(evt?.title || getEventTitleValue(evt?.resource) || "").toLowerCase();

    if (
      evtCat === "time-entry" ||
      evtCat === "time_entry" ||
      evtCat === "timeentry" ||
      evtCat === "time entry" ||
      titleLower.includes("time entry") ||
      titleLower.includes("time_entry")
    ) {
      const rawStatus = String(
        evt?.resource?.is_approved ??
        evt?.resource?.isApproved ??
        evt?.resource?.Status ??
        evt?.resource?.status ??
        evt?.status ??
        ""
      ).toLowerCase().trim();

      if (rawStatus === "0" || rawStatus.includes("approved")) {
        return "time-entry-approved";
      }
      if (rawStatus === "2" || rawStatus.includes("reject") || rawStatus.includes("declin")) {
        return "time-entry-rejected";
      }
      return "time-entry-pending";
    }

    if (evtCat === "meeting" || titleLower.includes("meeting")) {
      return "meeting";
    }

    const isLeave =
      evtCat === "leave" ||
      titleLower.includes("leave") ||
      titleLower.includes("sick leave") ||
      titleLower.includes("casual leave") ||
      titleLower.includes("loss of pay");

    if (!evt || !isLeave) {
      return evtCat || "event";
    }

    const rawStatus = String(
      evt.resource?.LeaveStatus ||
      evt.resource?.Status ||
      evt.resource?.status ||
      evt.leaveStatus ||
      evt.status ||
      ""
    ).toLowerCase();

    if (rawStatus.includes("pending") || titleLower.includes("pending")) {
      return "leave-pending";
    }
    if (rawStatus.includes("declin") || titleLower.includes("declin")) {
      return "leave-declined";
    }
    if (rawStatus.includes("unapprov") || titleLower.includes("unapprov")) {
      return "leave-unapproved";
    }
    if (rawStatus.includes("cancel") || titleLower.includes("cancel")) {
      return "leave-cancelled";
    }
    return "leave-approved";
  };

  const EventRenderer = ({ event }) => {
    const dateKey = event.dateKey || moment(event.start).format("YYYY-MM-DD");
    const dayEvents = eventsByDay[dateKey] || [];
    const displayEvent = event.originalEvent || dayEvents[0] || event;
    const tooltipText = formatEventTooltip(displayEvent);
    const displayTitle = formatEventDisplayTitle(displayEvent);

    const pillCategoryClass = getLeaveCategoryClass(displayEvent);
    const { pillStyle, dotStyle } = getEventPillStyle(displayEvent);
    const isUnassignedAdmin = isMeetingNotAssignedToAdmin(displayEvent, isAdmin, currentUserId);

    if (currentView === Views.MONTH) {
      const hiddenCount = dayEvents.length - 1;

      return (
        <div className="dashboard-calendar-event-stack">
          <Tooltip
            title={
              <span className="dashboard-calendar-tooltip-copy">
                {tooltipText.split("\n").map((line, index) => (
                  <React.Fragment key={`${displayEvent.id}-tooltip-line-${index}`}>
                    {index > 0 && <br />}
                    {line}
                  </React.Fragment>
                ))}
              </span>
            }
            arrow
            placement="top"
            classes={{
              tooltip: "dashboard-calendar-tooltip",
              arrow: "dashboard-calendar-tooltip-arrow",
            }}
          >
            <div
              className={`dashboard-calendar-event-pill dashboard-calendar-event-pill-${pillCategoryClass}`}
              style={pillStyle}
              onClick={(nativeEvent) => handleSelectEvent(displayEvent, nativeEvent)}
            >
              <span className="dashboard-calendar-event-dot" style={dotStyle} />
              <span className="dashboard-calendar-event-text">{displayTitle}</span>
              {isUnassignedAdmin && (
                <Tooltip title="Not Assigned to Admin" arrow placement="top">
                  <PersonAddDisabledIcon style={{ fontSize: "14px", marginLeft: "4px", color: "#d97706", flexShrink: 0 }} />
                </Tooltip>
              )}
            </div>
          </Tooltip>
          {hiddenCount > 0 && (
            <button
              type="button"
              className="dashboard-calendar-custom-more"
              onClick={(nativeEvent) => {
                nativeEvent.stopPropagation();
                handleOpenMorePopover(nativeEvent, dateKey);
              }}
            >
              +{hiddenCount} more
            </button>
          )}
        </div>
      );
    }

    return (
      <Tooltip
        title={
          <span className="dashboard-calendar-tooltip-copy">
            {tooltipText.split("\n").map((line, index) => (
              <React.Fragment key={`${event.id}-tooltip-line-${index}`}>
                {index > 0 && <br />}
                {line}
              </React.Fragment>
            ))}
          </span>
        }
        arrow
        placement="top"
        classes={{
          tooltip: "dashboard-calendar-tooltip",
          arrow: "dashboard-calendar-tooltip-arrow",
        }}
      >
        <div className={`dashboard-calendar-event-pill dashboard-calendar-event-pill-${pillCategoryClass}`} style={pillStyle}>
          <span className="dashboard-calendar-event-dot" style={dotStyle} />
          <span className="dashboard-calendar-event-text">{displayTitle}</span>
          {isUnassignedAdmin && (
            <Tooltip title="Not Assigned to Admin" arrow placement="top">
              <PersonAddDisabledIcon style={{ fontSize: "14px", marginLeft: "4px", color: "#d97706", flexShrink: 0 }} />
            </Tooltip>
          )}
        </div>
      </Tooltip>
    );
  };

  const handleTabClick = (tabName) => {
    if (addPopover.mode !== "edit") {
      setAddTab(tabName);
      setTargetUsers([]);
    }
  };

  return (
    <Card className="dashboard-calendar-card">
      <CardContent className="dashboard-calendar-card-content">
        <div className="dashboard-calendar-header">
          <Typography variant="h5" className="dashboard-calendar-title">
            Team Calendar
          </Typography>
        </div>

        <div className={`dashboard-calendar-shell${loading ? " is-loading" : ""}`}>
          <div className="dashboard-calendar-rbc-wrap">
            <Calendar
              localizer={localizer}
              events={displayedCalendarEvents}
              views={[Views.DAY, Views.WEEK, Views.WORK_WEEK, Views.MONTH, Views.AGENDA]}
              view={currentView}
              date={currentDate}
              selectable
              popup={false}
              popupOffset={8}
              toolbar
              maxRows={Infinity}
              allDayMaxRows={1}
              startAccessor="start"
              endAccessor="end"
              tooltipAccessor={() => ""}
              onNavigate={handleNavigate}
              onView={handleViewChange}
              onRangeChange={handleRangeChange}
              onSelectSlot={handleSelectSlot}
              onSelectEvent={handleSelectEvent}
              eventPropGetter={eventPropGetter}
              dayPropGetter={dayPropGetter}
              components={{
                toolbar: (toolbarProps) => (
                  <CustomToolbar
                    {...toolbarProps}
                    onOpenViewMenu={handleOpenViewMenu}
                    onTodayClick={scrollToAndHighlightToday}
                    categoryFilterAnchorPosition={categoryFilterAnchorPosition}
                    onOpenFilterMenu={handleOpenFilterMenu}
                    activeFilterCountText={(() => {
                      let count = 0;
                      if (categoryFilters.leave) count++;
                      if (categoryFilters.meeting) count++;
                      if (categoryFilters.reminder) count++;
                      if (categoryFilters.upcoming) count++;
                      if (categoryFilters.holiday) count++;
                      if (categoryFilters.timeentry) count++;
                      if (categoryFilters.birthday) count++;
                      const totalCats = 7;
                      if (count === totalCats) return "All";
                      return String(count);
                    })()}
                  />
                ),
                event: EventRenderer,
              }}
              messages={{
                showMore: (total) => `+${total} more`,
              }}
              formats={{
                weekdayFormat: (date, culture, nextLocalizer) => nextLocalizer.format(date, "dddd", culture),
                dayFormat: (date, culture, nextLocalizer) => nextLocalizer.format(date, "D", culture),
                agendaDateFormat: (date, culture, nextLocalizer) => nextLocalizer.format(date, "DD MMM YYYY", culture),
              }}
            />
          </div>

          {loading && (
            <div className="dashboard-calendar-loading">
              <Typography variant="body1">Loading calendar...</Typography>
            </div>
          )}
        </div>

        <Popover
          open={Boolean(viewMenuAnchorPosition)}
          anchorReference="anchorPosition"
          anchorPosition={viewMenuAnchorPosition || { top: 0, left: 0 }}
          onClose={handleCloseViewMenu}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          disableScrollLock
          classes={{ paper: "dashboard-calendar-toolbar-popover" }}
        >
          <div className="dashboard-calendar-toolbar-menu">
            {VIEW_OPTIONS.map((option) => (
              <button
                key={option.value}
                type="button"
                className={`dashboard-calendar-toolbar-menu-item${currentView === option.value ? " is-active" : ""}`}
                onClick={() => handleSelectView(option.value)}
              >
                {option.label}
              </button>
            ))}
          </div>
        </Popover>

        <Popover
          open={Boolean(morePopover.anchorPosition)}
          disableScrollLock
          anchorReference="anchorPosition"
          anchorPosition={morePopover.anchorPosition || { top: 0, left: 0 }}
          onClose={handleCloseMorePopover}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          classes={{ paper: "dashboard-calendar-more-popover" }}
        >
          <div className="dashboard-calendar-more-popover-header">
            <div>
              <Typography variant="subtitle2" className="dashboard-calendar-more-popover-day">
                {morePopover.dateKey ? moment(morePopover.dateKey).format("ddd") : ""}
              </Typography>
              <Typography variant="h6" className="dashboard-calendar-more-popover-date">
                {morePopover.dateKey ? moment(morePopover.dateKey).format("DD") : ""}
              </Typography>
            </div>
            <IconButton size="small" onClick={handleCloseMorePopover} className="dashboard-calendar-more-popover-close">
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>
          <div className={`dashboard-calendar-more-popover-body${popoverEvents.length > 4 ? " is-scrollable" : ""}`}>
            {popoverEvents.map((popoverEvent) => {
              const itemCategoryClass = getLeaveCategoryClass(popoverEvent);
              const { pillStyle } = getEventPillStyle(popoverEvent);
              const isUnassignedAdmin = isMeetingNotAssignedToAdmin(popoverEvent, isAdmin, currentUserId);

              return (
                <button
                  key={popoverEvent.id}
                  type="button"
                  className={`dashboard-calendar-more-item dashboard-calendar-more-item-${itemCategoryClass}`}
                  style={pillStyle}
                  onClick={(nativeEvent) => handleSelectEventFromMorePopover(popoverEvent, nativeEvent)}
                >
                  <span className="dashboard-calendar-event-text">{formatEventDisplayTitle(popoverEvent)}</span>
                  {isUnassignedAdmin && (
                    <Tooltip title="Not Assigned to Admin" arrow placement="top">
                      <PersonAddDisabledIcon style={{ fontSize: "14px", marginLeft: "4px", color: "#d97706", flexShrink: 0 }} />
                    </Tooltip>
                  )}
                </button>
              );
            })}
          </div>
        </Popover>

        <Popover
          open={Boolean(eventDetailsPopover.anchorPosition)}
          disableScrollLock
          anchorReference="anchorPosition"
          anchorPosition={eventDetailsPopover.anchorPosition || { top: 0, left: 0 }}
          onClose={handleCloseEventDetailsPopover}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          classes={{ paper: "dashboard-calendar-details-popover" }}
        >
          {eventDetailsPopover.event && (
            <div className="dashboard-calendar-details-popover-content">
              <div className="dashboard-calendar-details-popover-header">
                <div>
                  <Typography variant="h6" className="dashboard-calendar-details-popover-title">
                    {getFormattedTitleWithCategory(eventDetailsPopover.event)}
                  </Typography>
                  <Typography variant="body2" className="dashboard-calendar-details-popover-date">
                    {formatEventTooltip(eventDetailsPopover.event).split("\n").slice(1).join(" | ")}
                  </Typography>
                  {isMeetingNotAssignedToAdmin(eventDetailsPopover.event, isAdmin, currentUserId) && (
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', backgroundColor: '#fef3c7', color: '#b45309', padding: '2px 8px', borderRadius: '12px', fontSize: '12px', marginTop: '6px', fontWeight: 500 }}>
                      <PersonAddDisabledIcon style={{ fontSize: '14px' }} />
                      <span>Not Assigned to Admin</span>
                    </div>
                  )}
                </div>
                <IconButton size="small" onClick={handleCloseEventDetailsPopover} className="dashboard-calendar-details-popover-close">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>

              {(() => {
                const resource = eventDetailsPopover.event.resource || eventDetailsPopover.event || {};
                let rawDesc =
                  resource.Description ||
                  resource.description ||
                  resource.details ||
                  resource.eventDetails ||
                  resource.event_details ||
                  resource.reason ||
                  resource.note ||
                  resource.notes ||
                  resource.comment ||
                  resource.comments ||
                  eventDetailsPopover.event.description ||
                  eventDetailsPopover.event.details ||
                  "";

                if (!rawDesc) {
                  try {
                    const storedStr = typeof localStorage !== "undefined" ? localStorage.getItem("hrms_updated_dashboard_calendar_items") : null;
                    if (storedStr) {
                      const storedObj = JSON.parse(storedStr);
                      const eventId = resource.id || resource.calendar_event_id || eventDetailsPopover.event.id || resource.SourceId;
                      const titleKey = String(resource.title || resource.Subject || eventDetailsPopover.event.title || "").trim().toLowerCase();

                      for (const key in storedObj) {
                        const item = storedObj[key];
                        if (item && (item.description || item.Description || item.details)) {
                          if ((eventId && key.includes(String(eventId))) || (titleKey && titleKey.length > 2 && key.toLowerCase().includes(titleKey))) {
                            rawDesc = item.description || item.Description || item.details;
                            break;
                          }
                        }
                      }
                    }
                  } catch (e) {
                    // ignore
                  }
                }

                if (!rawDesc && Array.isArray(events)) {
                  const eventId = resource.id || resource.calendar_event_id || eventDetailsPopover.event.id || resource.SourceId;
                  const titleKey = String(resource.title || resource.Subject || eventDetailsPopover.event.title || "").trim().toLowerCase();
                  for (const item of events) {
                    const r = item?.resource || item || {};
                    const itemDesc = r.description || r.Description || r.details || item?.description || item?.Description;
                    if (itemDesc) {
                      const rId = r.id || r.calendar_event_id || item.id || r.SourceId;
                      const rTitle = String(r.title || r.Subject || item.title || "").trim().toLowerCase();
                      if ((eventId && String(rId) === String(eventId)) || (titleKey && titleKey.length > 2 && rTitle === titleKey)) {
                        rawDesc = itemDesc;
                        break;
                      }
                    }
                  }
                }

                const cleanDesc = (() => {
                  if (!rawDesc) return "";
                  let str = String(rawDesc).trim();
                  // Strip internal metadata tags like [category:meeting], [targets:87,86,85,84]
                  str = str.replace(/\[[^\]]*:[^\]]*\]/gi, "");
                  // Strip HTML tags if any
                  str = str.replace(/<[^>]*>?/gm, "");
                  // Collapse multiple empty newlines
                  str = str.replace(/\n\s*\n/g, "\n").trim();
                  if (str === "N/A" || str === "null" || str === "undefined") return "";
                  return str;
                })();

                const cat = String(eventDetailsPopover.event.category || eventDetailsPopover.event.resource?.Category || "").toLowerCase();
                const isLeave = cat === "leave";
                const noOfDays = isLeave ? getLeaveEventNoOfDays(eventDetailsPopover.event) : null;
                if (!cleanDesc && (noOfDays === null || noOfDays === undefined || noOfDays === "")) return null;
                return (
                  <div className="dashboard-calendar-details-popover-body" style={{ padding: "4px 14px 6px 14px", maxHeight: "160px", overflowY: "auto" }}>
                    <Typography variant="body2" className="dashboard-calendar-details-popover-desc" style={{ marginTop: "2px", marginBottom: "2px", wordBreak: "break-word", whiteSpace: "pre-wrap", fontSize: "0.85rem", lineHeight: 1.4 }}>
                      {cleanDesc ? (isLeave ? <>Reason: {renderTextWithLinks(cleanDesc)}</> : renderTextWithLinks(cleanDesc)) : null}
                      {isLeave && noOfDays !== null && noOfDays !== undefined && noOfDays !== "" ? <><br />{`No. of Days: ${noOfDays}`}</> : null}
                    </Typography>
                  </div>
                );
              })()}

              <div className="dashboard-calendar-details-popover-footer" style={{ padding: "6px 14px 8px 14px", marginTop: "2px", borderTop: "1px solid #e2e8f0" }}>
                {(canEditSelectedEvent || canDeleteSelectedEvent) && (
                  <div className="dashboard-calendar-details-popover-actions">
                    {(() => {
                      const popoverCategory = String(
                        eventDetailsPopover.event?.category ||
                        eventDetailsPopover.event?.resource?.category ||
                        eventDetailsPopover.event?.resource?.Category ||
                        ""
                      ).toLowerCase().trim();
                      const isMeeting = popoverCategory === "meeting" || popoverCategory === "calendar" || popoverCategory === "";

                      if (!isMeeting) return null;

                      return (
                        <Tooltip title="View Full Info" placement="top" arrow>
                          <IconButton
                            size="small"
                            className="dashboard-calendar-details-popover-btn dashboard-calendar-details-popover-btn-view"
                            aria-label="View event full info"
                            onClick={(e) => {
                              e?.preventDefault();
                              e?.stopPropagation();
                              const selectedEvt = eventDetailsPopover.event;
                              if (selectedEvt) {
                                setViewInfoModal({ open: true, event: selectedEvt });
                              }
                              handleCloseEventDetailsPopover();
                            }}
                          >
                            <VisibilityOutlinedIcon fontSize="small" style={{ pointerEvents: "none" }} />
                          </IconButton>
                        </Tooltip>
                      );
                    })()}
                    {(() => {
                      const popoverCat = String(
                        eventDetailsPopover.event?.category ||
                        eventDetailsPopover.event?.resource?.category ||
                        eventDetailsPopover.event?.resource?.Category ||
                        ""
                      ).toLowerCase().trim();
                      const isMeetingType = popoverCat === "meeting" || popoverCat === "calendar" || popoverCat === "" || popoverCat === "reminder";
                      const isHolidayType = popoverCat === "holiday";
                      const isLeaveType = popoverCat === "leave";
                      const itemTypeLabel = isMeetingType ? "Meeting" : isHolidayType ? "Holiday" : isLeaveType ? "Leave" : "Event";

                      return (
                        <>
                          {canEditSelectedEvent && (
                            <Tooltip title={`Edit ${itemTypeLabel}`} placement="top" arrow>
                              <IconButton
                                size="small"
                                className="dashboard-calendar-details-popover-btn dashboard-calendar-details-popover-btn-edit"
                                aria-label={`Edit ${itemTypeLabel}`}
                                onClick={handleEditSelectedEvent}
                              >
                                <EditOutlinedIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                          {canDeleteSelectedEvent && (
                            <Tooltip title={`Delete ${itemTypeLabel}`} placement="top" arrow>
                              <IconButton
                                size="small"
                                className="dashboard-calendar-details-popover-btn dashboard-calendar-details-popover-btn-delete"
                                aria-label={`Delete ${itemTypeLabel}`}
                                onClick={handleDeleteSelectedEvent}
                              >
                                <DeleteOutlineOutlinedIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </>
                      );
                    })()}
                  </div>
                )}

                  {(getEventCategoryKey(eventDetailsPopover.event).startsWith("Time Entry") || String(eventDetailsPopover.event.category || "").toLowerCase() === "leave") && (() => {
                    const popCat = getEventCategoryKey(eventDetailsPopover.event);

                    if (popCat.startsWith("Time Entry")) {
                      const rawRes = eventDetailsPopover.event.resource || eventDetailsPopover.event;
                      const rawStatus = String(
                        rawRes.is_approved ??
                        rawRes.isApproved ??
                        rawRes.Status ??
                        rawRes.status ??
                        ""
                      ).toLowerCase().trim();

                      const isPendingTimeEntry = popCat === "Time Entry - Pending" || (rawStatus !== "0" && rawStatus !== "2" && !rawStatus.includes("approved") && !rawStatus.includes("reject") && !rawStatus.includes("declin"));
                      const timeEntryId = rawRes.id || rawRes.calendar_event_id || rawRes.eventId || rawRes.SourceId || eventDetailsPopover.event.id;

                      const handleApproveAction = () => {
                        const user = ls("user");
                        const userName = `${user?.firstName || 'Admin'} ${user?.lastName || ''}`.trim();

                        swal({
                          title: "Are you sure?",
                          text: "Do you want to approve this entry?",
                          icon: "warning",
                          buttons: ["Cancel", "Yes"],
                        }).then(async (confirm) => {
                          if (confirm) {
                            handleCloseEventDetailsPopover();
                            setTimeEntryDetailsModal({ open: false, data: null });

                            swal({
                              title: "Approving Time Entry...",
                              content: createSwalLoaderNode ? createSwalLoaderNode() : null,
                              buttons: false,
                              closeOnClickOutside: false,
                              closeOnEsc: false,
                            });

                            let res = await AuthApi.approveTime({ is_approved: "0", userName }, timeEntryId);
                            if (res && res.status === true) {
                              window.dispatchEvent(
                                new CustomEvent("cherrypik_new_notification", {
                                  detail: {
                                    title: "Time-Entry Status",
                                    message: `Your time entry was approved by ${userName}.`,
                                    type: "Time-Entry Status",
                                    actorId: user?.id || user?.Id,
                                  },
                                })
                              );
                              window.dispatchEvent(new Event("cherrypik_refresh_notifications"));
                              if (typeof onRangeChange === "function") {
                                onRangeChange();
                              }
                              if (typeof onUpdateLeaveStatus === "function") {
                                onUpdateLeaveStatus(timeEntryId, "Approved");
                              }
                              swal("Done!", "You have approved the entry!", "success");
                            } else {
                              swal("Error!", "There was an error approving the entry.", "error");
                            }
                          }
                        });
                      };

                      const handleRejectAction = async () => {
                        const user = ls("user");
                        const userName = `${user?.firstName || 'Admin'} ${user?.lastName || ''}`.trim();
                        handleCloseEventDetailsPopover();
                        setTimeEntryDetailsModal({ open: false, data: null });
                        const rejectionRemark = await promptRejectionRemark("Reject Time Entry");

                        if (rejectionRemark) {

                          swal({
                            title: "Rejecting Time Entry...",
                            content: createSwalLoaderNode ? createSwalLoaderNode() : null,
                            buttons: false,
                            closeOnClickOutside: false,
                            closeOnEsc: false,
                          });

                          let res = await AuthApi.approveTime({ is_approved: "2", userName, remark: rejectionRemark }, timeEntryId);
                          if (res && res.status === true) {
                            window.dispatchEvent(
                              new CustomEvent("cherrypik_new_notification", {
                                detail: {
                                  title: "Time-Entry Status",
                                  message: `Your time entry was rejected by ${userName}.`,
                                  type: "Time-Entry Status",
                                  actorId: user?.id || user?.Id,
                                },
                              })
                            );
                            window.dispatchEvent(new Event("cherrypik_refresh_notifications"));
                            if (typeof onRangeChange === "function") {
                              onRangeChange();
                            }
                            if (typeof onUpdateLeaveStatus === "function") {
                              onUpdateLeaveStatus(timeEntryId, "Declined");
                            }
                            swal("Done!", "You have rejected the entry!", "success");
                          } else {
                            swal("Error!", "There was an error rejecting the entry.", "error");
                          }
                        }
                      };

                      return (
                        <div className="dashboard-calendar-leave-admin-actions" style={{ display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center', margin: 0, padding: 0 }}>
                          {/* 1) Info icon (i) - Exact FontAwesome icon from Check.js */}
                          <Tooltip title="View Details" placement="top" arrow>
                            <IconButton
                              size="small"
                              className="common-action-icon"
                              style={{ cursor: "pointer", padding: "4px" }}
                              onClick={() => {
                                handleCloseEventDetailsPopover();
                                setTimeEntryDetailsModal({ open: true, data: rawRes });
                              }}
                            >
                              <FontAwesomeIconComponent
                                classes="fa fa-info-circle"
                                style={{ color: "var(--hrms-primary-blue-end, #036dda)", cursor: "pointer" }}
                                fontSize="small"
                              />
                            </IconButton>
                          </Tooltip>

                          {/* 2) Approve [✓] and 3) Reject [✕] - ONLY shown for Pending */}
                          {isAdmin && isPendingTimeEntry && (
                            <>
                              <Tooltip title="Approve" placement="top" arrow>
                                <IconButton
                                  size="small"
                                  style={{ cursor: "pointer", padding: "4px", color: "#16a34a" }}
                                  onClick={handleApproveAction}
                                >
                                  <FontAwesomeIconComponent
                                    classes="far fa-check-square"
                                    style={{ cursor: "pointer", color: "#16a34a", fontSize: "16px" }}
                                  />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Reject" placement="top" arrow>
                                <IconButton
                                  size="small"
                                  style={{ cursor: "pointer", padding: "4px", color: "#dc2626" }}
                                  onClick={handleRejectAction}
                                >
                                  <FontAwesomeIconComponent
                                    classes="fas fa-window-close"
                                    style={{ cursor: "pointer", color: "#dc2626", fontSize: "16px" }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </div>
                      );
                    }

                    const rawStatus = String(
                      eventDetailsPopover.event.resource?.LeaveStatus ||
                      eventDetailsPopover.event.resource?.leaveStatus ||
                      eventDetailsPopover.event.resource?.Status ||
                      eventDetailsPopover.event.resource?.status ||
                      eventDetailsPopover.event.status ||
                      ""
                    ).toLowerCase().trim();

                    const isPending = rawStatus.includes("pending") || (!rawStatus.includes("approved") && !rawStatus.includes("declin") && !rawStatus.includes("cancel"));
                    const isApproved = rawStatus.includes("approved") && !rawStatus.includes("unapproved");
                    const canCancel = isPending || isApproved;

                    return (
                      <div className="dashboard-calendar-leave-admin-actions" style={{ display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center', paddingTop: '10px', marginTop: '10px', borderTop: '1px solid #e2e8f0' }}>
                        {isPending && (
                          <Tooltip title="Approve" placement="top" arrow>
                            <IconButton
                              style={{ cursor: "pointer", padding: "4px" }}
                              onClick={() => {
                                const leaveId = getEventDeleteMeta(eventDetailsPopover.event.resource, "leave")?.id || eventDetailsPopover.event.resource?.id;
                                handleCloseEventDetailsPopover();
                                if (typeof onUpdateLeaveStatus === "function" && leaveId) {
                                  onUpdateLeaveStatus(leaveId, "Approved");
                                }
                              }}
                            >
                              <FontAwesomeIconComponent
                                classes="far fa-check-square"
                                style={{ cursor: "pointer", color: "var(--hrms-primary-blue-end, #036dda)" }}
                                fontSize="small"
                              />
                            </IconButton>
                          </Tooltip>
                        )}

                        {isPending && (
                          <Tooltip title="Declined" placement="top" arrow>
                            <IconButton
                              style={{ cursor: "pointer", padding: "4px" }}
                              onClick={() => {
                                const leaveId = getEventDeleteMeta(eventDetailsPopover.event.resource, "leave")?.id || eventDetailsPopover.event.resource?.id;
                                handleCloseEventDetailsPopover();
                                if (typeof onUpdateLeaveStatus === "function" && leaveId) {
                                  onUpdateLeaveStatus(leaveId, "Declined");
                                }
                              }}
                            >
                              <FontAwesomeIconComponent
                                classes="fas fa-window-close"
                                style={{ cursor: "pointer", color: "var(--hrms-primary-blue-end, #036dda)" }}
                                fontSize="small"
                              />
                            </IconButton>
                          </Tooltip>
                        )}

                        {isPending && (
                          <Tooltip title="Unapproved" placement="top" arrow>
                            <IconButton
                              style={{ cursor: "pointer", padding: "4px" }}
                              onClick={() => {
                                const leaveId = getEventDeleteMeta(eventDetailsPopover.event.resource, "leave")?.id || eventDetailsPopover.event.resource?.id;
                                handleCloseEventDetailsPopover();
                                if (typeof onUpdateLeaveStatus === "function" && leaveId) {
                                  onUpdateLeaveStatus(leaveId, "Unapproved");
                                }
                              }}
                            >
                              <FontAwesomeIconComponent
                                classes="fas fa-times-circle"
                                style={{ cursor: "pointer", color: "#ff0000" }}
                                fontSize="small"
                              />
                            </IconButton>
                          </Tooltip>
                        )}

                        {canCancel && (
                          <Tooltip title="Cancel Leave Request" placement="top" arrow>
                            <IconButton
                              style={{ cursor: "pointer", padding: "4px" }}
                              onClick={() => {
                                const leaveId = getEventDeleteMeta(eventDetailsPopover.event.resource, "leave")?.id || eventDetailsPopover.event.resource?.id;
                                handleCloseEventDetailsPopover();
                                if (typeof onUpdateLeaveStatus === "function" && leaveId) {
                                  onUpdateLeaveStatus(leaveId, "Cancelled");
                                }
                              }}
                            >
                              <FontAwesomeIconComponent
                                classes="fa fa-ban"
                                style={{ cursor: "pointer", color: "#dc3545" }}
                                fontSize="small"
                              />
                            </IconButton>
                          </Tooltip>
                        )}

                        <Tooltip title="Leave Details" placement="top" arrow>
                          <IconButton
                            style={{ cursor: "pointer", padding: "4px" }}
                            onClick={(e) => {
                              e?.preventDefault();
                              e?.stopPropagation();
                              const selectedEvt = eventDetailsPopover.event;
                              if (selectedEvt) {
                                setViewInfoModal({ open: true, event: selectedEvt });
                              }
                              handleCloseEventDetailsPopover();
                            }}
                          >
                            <FontAwesomeIconComponent
                              classes="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "var(--hrms-primary-blue-end, #036dda)" }}
                              fontSize="small"
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    );
                  })()}
                </div>
            </div>
          )}
        </Popover>

        {Boolean(addPopover.anchorPosition) && (
          <div
            className="dashboard-calendar-popover-backdrop"
            onClick={handleCloseAddPopover}
          />
        )}

        <Popover
          open={Boolean(addPopover.anchorPosition)}
          disableScrollLock
          disableAutoFocus
          disableEnforceFocus
          disableRestoreFocus
          anchorReference="none"
          onClose={handleCloseAddPopover}
          classes={{ paper: `dashboard-calendar-add-popover is-${addTab}-tab` }}
          ModalProps={{
            BackdropProps: {
              style: {
                backgroundColor: "rgba(15, 23, 42, 0.42)",
                backdropFilter: "blur(5px)",
                WebkitBackdropFilter: "blur(5px)",
              },
            },
          }}
        >
          <div
            className="dashboard-calendar-add-popover-content"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onMouseUp={(e) => e.stopPropagation()}
          >
            <div className="dashboard-calendar-add-popover-body">
              {isAdmin ? (
                <div className="dashboard-calendar-add-tabs">
                  <button
                    type="button"
                    className={`dashboard-calendar-add-tab ${addTab === "title" ? "is-active" : ""}`}
                    onClick={() => handleTabClick("title")}
                    disabled={addPopover.mode === "edit" && addTab !== "title"}
                    style={addPopover.mode === "edit" && addTab !== "title" ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  >
                    Todo's Reminder
                  </button>
                  <button
                    type="button"
                    className={`dashboard-calendar-add-tab ${addTab === "meeting" ? "is-active" : ""}`}
                    onClick={() => handleTabClick("meeting")}
                    disabled={addPopover.mode === "edit" && addTab !== "meeting"}
                    style={addPopover.mode === "edit" && addTab !== "meeting" ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  >
                    Meeting
                  </button>
                  <button
                    type="button"
                    className={`dashboard-calendar-add-tab ${addTab === "event" ? "is-active" : ""}`}
                    onClick={() => handleTabClick("event")}
                    disabled={addPopover.mode === "edit" && addTab !== "event"}
                    style={addPopover.mode === "edit" && addTab !== "event" ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  >
                    Event
                  </button>
                  <button
                    type="button"
                    className={`dashboard-calendar-add-tab ${addTab === "holiday" ? "is-active" : ""}`}
                    onClick={() => handleTabClick("holiday")}
                    disabled={addPopover.mode === "edit" && addTab !== "holiday"}
                    style={addPopover.mode === "edit" && addTab !== "holiday" ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  >
                    Holiday
                  </button>
                  <button
                    type="button"
                    className={`dashboard-calendar-add-tab ${addTab === "leave" ? "is-active" : ""}`}
                    onClick={() => handleTabClick("leave")}
                    disabled={addPopover.mode === "edit" && addTab !== "leave"}
                    style={addPopover.mode === "edit" && addTab !== "leave" ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  >
                    Leave
                  </button>
                  <button
                    type="button"
                    className={`dashboard-calendar-add-tab ${addTab === "timeEntry" ? "is-active" : ""}`}
                    onClick={() => handleTabClick("timeEntry")}
                    disabled={addPopover.mode === "edit" && addTab !== "timeEntry"}
                    style={addPopover.mode === "edit" && addTab !== "timeEntry" ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  >
                    Time Entry
                  </button>
                </div>
              ) : (
                <div className="dashboard-calendar-add-tabs">
                  <button
                    type="button"
                    className={`dashboard-calendar-add-tab ${addTab === "title" ? "is-active" : ""}`}
                    onClick={() => handleTabClick("title")}
                    disabled={addPopover.mode === "edit" && addTab !== "title"}
                    style={addPopover.mode === "edit" && addTab !== "title" ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  >
                    Todo's Reminder
                  </button>
                  <button
                    type="button"
                    className={`dashboard-calendar-add-tab ${addTab === "meeting" ? "is-active" : ""}`}
                    onClick={() => handleTabClick("meeting")}
                    disabled={addPopover.mode === "edit" && addTab !== "meeting"}
                    style={addPopover.mode === "edit" && addTab !== "meeting" ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  >
                    Meeting
                  </button>
                  <button
                    type="button"
                    className={`dashboard-calendar-add-tab ${addTab === "leave" ? "is-active" : ""}`}
                    onClick={() => handleTabClick("leave")}
                    disabled={addPopover.mode === "edit" && addTab !== "leave"}
                    style={addPopover.mode === "edit" && addTab !== "leave" ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  >
                    Leave
                  </button>
                  <button
                    type="button"
                    className={`dashboard-calendar-add-tab ${addTab === "timeEntry" ? "is-active" : ""}`}
                    onClick={() => handleTabClick("timeEntry")}
                    disabled={addPopover.mode === "edit" && addTab !== "timeEntry"}
                    style={addPopover.mode === "edit" && addTab !== "timeEntry" ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
                  >
                    Time Entry
                  </button>
                </div>
              )}
              {addTab === "event" ? (
                <div className="dashboard-calendar-event-form-wrap" style={{ padding: "0" }}>
                  <Typography
                    variant="h6"
                    style={{
                      color: "#036dda",
                      fontWeight: 700,
                      fontSize: "1.15rem",
                      margin: "0 0 6px 0",
                    }}
                  >
                    {addPopover.mode === "edit" ? "Edit Upcoming Event" : "Add Upcoming Event"}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        id="upcomingEventName"
                        name="upcomingEventName"
                        label="Event Name"
                        variant="outlined"
                        value={addEventTitle}
                        onChange={(e) => setAddEventTitle(e.target.value)}
                        size="small"
                        InputLabelProps={{ style: { fontWeight: 400 } }}
                        InputProps={{ style: { fontWeight: 400 } }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        id="upcomingEventdate"
                        name="upcomingEventdate"
                        label="Event Date"
                        type="date"
                        variant="outlined"
                        value={eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : "")}
                        onChange={(e) => setEventDate(e.target.value)}
                        InputLabelProps={{ shrink: true, style: { fontWeight: 400 } }}
                        InputProps={{ style: { fontWeight: 400 } }}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        id="eventDetails"
                        name="eventDetails"
                        label="Event Details"
                        variant="outlined"
                        value={eventDescription}
                        onChange={(e) => setEventDescription(e.target.value)}
                        InputLabelProps={{ style: { fontWeight: 400 } }}
                        InputProps={{ style: { fontWeight: 400 } }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <div
                        className={`common-upload-area ${dragActive ? 'is-active' : ''}`}
                        style={{
                          width: '100%',
                          minHeight: '92px',
                          border: '2px dashed #cbd5e1',
                          borderRadius: '1rem',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          cursor: 'pointer',
                          padding: '8px',
                          boxSizing: 'border-box',
                        }}
                        onDragEnter={handleDrag}
                        onDragLeave={handleDrag}
                        onDragOver={handleDrag}
                        onDrop={handleDrop}
                        onClick={() => {
                          const el = document.getElementById('contained-button-file-event');
                          if (el) el.click();
                        }}
                      >
                        <input
                          accept="image/*"
                          id="contained-button-file-event"
                          type="file"
                          onChange={uploadSingleFile}
                          style={{ display: 'none' }}
                        />
                        {eventImageUrl && (
                          <img
                            src={eventImageUrl}
                            alt="Event preview"
                            style={{
                              width: '60px',
                              height: '60px',
                              marginBottom: '4px',
                              objectFit: 'cover',
                              borderRadius: '8px',
                            }}
                          />
                        )}
                        <Typography variant="subtitle2" style={{ color: '#036dda', fontSize: '0.85rem', fontWeight: 600 }}>
                          {eventImageUrl ? "Change File" : "Drag & Drop your file here"}
                        </Typography>
                        <Typography variant="caption" style={{ color: '#64748b', fontSize: '0.75rem' }}>
                          or
                        </Typography>
                        <Button
                          variant="outlined"
                          color="primary"
                          component="span"
                          size="small"
                          startIcon={<CloudUploadIcon />}
                          style={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            fontWeight: 600,
                            color: '#036dda',
                            borderColor: '#036dda',
                            marginTop: '4px',
                            fontSize: '0.78rem',
                          }}
                        >
                          Upload a file
                        </Button>
                      </div>
                      {eventImageUrl && (
                        <div style={{ textAlign: 'center', marginTop: '4px' }}>
                          <Button onClick={removeImg} size="small" color="secondary" style={{ textTransform: 'none', fontSize: '0.75rem' }}>
                            Remove Image
                          </Button>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                  <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleSaveQuickEvent();
                      }}
                      style={{ textTransform: 'none', borderRadius: '8px', fontWeight: 700, padding: '6px 20px', background: '#036dda' }}
                    >
                      {addPopover.mode === "edit" ? "Update" : "Save"}
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleCloseAddPopover}
                      style={{ textTransform: 'none', borderRadius: '8px', fontWeight: 600, color: '#475569', borderColor: '#cbd5e1' }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ) : addTab === "holiday" ? (
                <div className="dashboard-calendar-holiday-form-wrap" style={{ padding: "0" }}>
                  <Typography
                    variant="h6"
                    style={{
                      color: "#036dda",
                      fontWeight: 700,
                      fontSize: "1.15rem",
                      margin: "0 0 6px 0",
                    }}
                  >
                    {addPopover.mode === "edit" ? "Edit Holiday" : "Add Holiday"}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        id="holidayName"
                        name="holidayName"
                        label="Holiday Name"
                        variant="outlined"
                        value={addEventTitle}
                        onChange={(e) => setAddEventTitle(e.target.value)}
                        size="small"
                        InputLabelProps={{ style: { fontWeight: 400 } }}
                        InputProps={{ style: { fontWeight: 400 } }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        id="holidayDate"
                        name="holidayDate"
                        label="Holiday Date"
                        type="date"
                        variant="outlined"
                        value={eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : "")}
                        onChange={(e) => setEventDate(e.target.value)}
                        InputLabelProps={{ shrink: true, style: { fontWeight: 400 } }}
                        InputProps={{ style: { fontWeight: 400 } }}
                        size="small"
                      />
                    </Grid>
                  </Grid>
                  <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleSaveQuickEvent();
                      }}
                      style={{ textTransform: 'none', borderRadius: '8px', fontWeight: 700, padding: '6px 20px', background: '#036dda' }}
                    >
                      {addPopover.mode === "edit" ? "Update" : "Save"}
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleCloseAddPopover}
                      style={{ textTransform: 'none', borderRadius: '8px', fontWeight: 600, color: '#475569', borderColor: '#cbd5e1' }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ) : addTab === "leave" ? (
                <div className="dashboard-calendar-leave-form-wrap" style={{ padding: "0" }}>
                  <Typography
                    variant="h6"
                    style={{
                      color: "#036dda",
                      fontWeight: 700,
                      fontSize: "1.15rem",
                      margin: "0 0 10px 0",
                    }}
                  >
                    {addPopover.mode === "edit" ? "Edit Leave" : "Add Leave"}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" fullWidth size="small">
                        <InputLabel id="leave-type-label" style={{ fontWeight: 400 }}>Leave-Type</InputLabel>
                        <Select
                          labelId="leave-type-label"
                          id="leaveType"
                          label="Leave-Type"
                          value={leaveType}
                          onChange={(e) => setLeaveType(e.target.value)}
                          style={{ fontWeight: 400 }}
                        >
                          {LEAVE_TYPE_OPTIONS.map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <DdMmYyyyDateField
                        id="startDate"
                        name="startDate"
                        label="Start-date"
                        value={leaveStartDate || eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : "")}
                        onChange={(newYmd) => handleLeaveStartDateChange(newYmd)}
                        error={Boolean(leaveFormErrors.startDate)}
                        helperText={leaveFormErrors.startDate}
                        max={leaveEndDate || undefined}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl variant="outlined" fullWidth size="small">
                        <InputLabel id="first-half-label" style={{ fontWeight: 400 }}>Select-Half</InputLabel>
                        <Select
                          labelId="first-half-label"
                          id="firstleavetype"
                          label="Select-Half"
                          value={firstLeaveHalf}
                          onChange={(e) => setFirstLeaveHalf(e.target.value)}
                          style={{ fontWeight: 400 }}
                        >
                          <MenuItem value="first-half">First Half</MenuItem>
                          <MenuItem value="second-half">Second Half</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <DdMmYyyyDateField
                        id="endDate"
                        name="endDate"
                        label="End-date"
                        value={leaveEndDate || leaveStartDate || eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : "")}
                        onChange={(newYmd) => handleLeaveEndDateChange(newYmd)}
                        error={Boolean(leaveFormErrors.endDate)}
                        helperText={leaveFormErrors.endDate}
                        min={leaveStartDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : undefined)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl variant="outlined" fullWidth size="small">
                        <InputLabel id="second-half-label" style={{ fontWeight: 400 }}>Select-Half</InputLabel>
                        <Select
                          labelId="second-half-label"
                          id="secondleavetype"
                          label="Select-Half"
                          value={secondLeaveHalf}
                          onChange={(e) => setSecondLeaveHalf(e.target.value)}
                          style={{ fontWeight: 400 }}
                        >
                          <MenuItem value="first-half">First Half</MenuItem>
                          <MenuItem value="second-half">Second Half</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        id="ticketMessage"
                        name="ticketMessage"
                        label="Reason for Leave"
                        variant="outlined"
                        value={addEventDescription}
                        onChange={(e) => {
                          setAddEventDescription(e.target.value);
                          setLeaveFormErrors((prev) => ({ ...prev, description: null }));
                        }}
                        error={Boolean(leaveFormErrors.description)}
                        helperText={leaveFormErrors.description}
                        InputLabelProps={{ style: { fontWeight: 400 } }}
                        InputProps={{ style: { fontWeight: 400 } }}
                      />
                    </Grid>

                  </Grid>
                  <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleSaveQuickEvent();
                      }}
                      style={{ textTransform: 'none', borderRadius: '8px', fontWeight: 700, padding: '6px 20px', background: '#036dda' }}
                    >
                      {addPopover.mode === "edit" ? "Update" : "Save"}
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleCloseAddPopover}
                      style={{ textTransform: 'none', borderRadius: '8px', fontWeight: 600, color: '#475569', borderColor: '#cbd5e1' }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ) : addTab === "timeEntry" ? (
                <div className="dashboard-calendar-timeentry-form-wrap" style={{ padding: "0" }}>
                  <Typography
                    variant="h6"
                    style={{
                      color: "#036dda",
                      fontWeight: 700,
                      fontSize: "1.15rem",
                      margin: "0 0 10px 0",
                    }}
                  >
                    {addPopover.mode === "edit" ? "Edit Time Entry" : "Add Time Entry"}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <DdMmYyyyDateField
                        id="timeEntryDate"
                        name="timeEntryDate"
                        label="Date"
                        value={eventDate || (addPopover.start ? moment(addPopover.start).format("YYYY-MM-DD") : "")}
                        onChange={(newYmd) => setEventDate(newYmd)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        id="startTime"
                        label="Start-time"
                        variant="outlined"
                        type="time"
                        name="startTime"
                        size="small"
                        value={startTime || "07:30"}
                        onChange={(e) => setStartTime(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                          style: { fontWeight: 400 }
                        }}
                        InputProps={{ style: { fontWeight: 400 } }}
                        inputProps={{
                          step: 300,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        id="endTime"
                        label="End-time"
                        variant="outlined"
                        type="time"
                        name="endTime"
                        size="small"
                        value={endTime || "18:00"}
                        onChange={(e) => setEndTime(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                          style: { fontWeight: 400 }
                        }}
                        InputProps={{ style: { fontWeight: 400 } }}
                        inputProps={{
                          step: 300,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        id="timeEntryReason"
                        name="timeEntryReason"
                        label="Reason"
                        variant="outlined"
                        value={addEventDescription}
                        onChange={(e) => setAddEventDescription(e.target.value)}
                        InputLabelProps={{ style: { fontWeight: 400 } }}
                        InputProps={{ style: { fontWeight: 400 } }}
                      />
                    </Grid>
                  </Grid>
                  <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleSaveQuickEvent();
                      }}
                      style={{ textTransform: 'none', borderRadius: '8px', fontWeight: 700, padding: '6px 20px', background: '#036dda' }}
                    >
                      {addPopover.mode === "edit" ? "Update" : "Save"}
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleCloseAddPopover}
                      style={{ textTransform: 'none', borderRadius: '8px', fontWeight: 600, color: '#475569', borderColor: '#cbd5e1' }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <Typography
                    variant="h6"
                    style={{
                      color: "#036dda",
                      fontWeight: 700,
                      fontSize: "1.15rem",
                      margin: "0 0 12px 0",
                    }}
                  >
                    {addPopover.mode === "edit"
                      ? `Edit ${addTab === "meeting" ? "Meeting" : addTab === "event" ? "Upcoming Event" : addTab === "holiday" ? "Holiday" : "Todo's Reminder"}`
                      : `Add ${addTab === "meeting" ? "Upcoming Meeting" : addTab === "event" ? "Upcoming Event" : addTab === "holiday" ? "Holiday" : "Todo's Reminder"}`}
                  </Typography>
                  <Grid container spacing={2} style={{ marginBottom: "14px" }}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={addEventTitle}
                        onChange={(e) => setAddEventTitle(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSaveQuickEvent();
                          }
                        }}
                        label={
                          addTab === "meeting"
                            ? "Meeting Name *"
                            : addTab === "event"
                            ? "Event Name *"
                            : addTab === "holiday"
                            ? "Holiday Name *"
                            : "Title *"
                        }
                        InputLabelProps={{ style: { fontWeight: 400 } }}
                        InputProps={{ style: { fontWeight: 400 } }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        variant="outlined"
                        size="small"
                        value={addEventDescription}
                        onChange={(e) => setAddEventDescription(e.target.value)}
                        label={
                          addTab === "meeting"
                            ? "Meeting Details"
                            : addTab === "event"
                            ? "Event Details"
                            : "Description (Optional)"
                        }
                        InputLabelProps={{ style: { fontWeight: 400 } }}
                        InputProps={{ style: { fontWeight: 400 } }}
                      />
                    </Grid>
                  </Grid>
                  <div className="dashboard-calendar-add-popover-meta-card" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1 }}>
                      <div className="dashboard-calendar-add-popover-date-row">
                        <CalendarTodayIcon className="dashboard-calendar-add-popover-date-icon" />
                        <div className="dashboard-calendar-add-popover-date-copy">
                          <span className="dashboard-calendar-add-popover-date-text" style={{ fontSize: '15px' }}>
                            {addPopover.formattedDate}
                          </span>
                        </div>
                      </div>
                      <div className="dashboard-calendar-add-popover-allday-row" style={{ marginTop: '12px' }}>
                        <label className="dashboard-calendar-add-popover-checkbox-label">
                          <input
                            type="checkbox"
                            checked={allDay}
                            onChange={(e) => setAllDay(e.target.checked)}
                            className="dashboard-calendar-add-popover-checkbox"
                          />
                          <span>All Day</span>
                        </label>
                      </div>
                    </div>

                    {(isAdmin || addTab === "meeting") && (
                      <div className="dashboard-calendar-add-popover-users-row" style={{ marginLeft: "12px" }}>
                        <TextField
                          className="attendance-header-field"
                          style={{ width: '200px' }}
                          label="Select User"
                          variant="outlined"
                          value={
                            targetUsers.length === 0 
                              ? "" 
                              : (allUsers && allUsers.length > 1 && targetUsers.length === allUsers.length)
                                ? "All Users"
                                : targetUsers.length === 1
                                  ? (() => {
                                      const singleVal = targetUsers[0].value ?? targetUsers[0].id ?? targetUsers[0];
                                      const matched = findUserInList(singleVal, allUsers);
                                      return getUserDisplayName(matched || targetUsers[0], singleVal);
                                    })()
                                  : `${targetUsers.length} Users Selected`
                          }
                          onClick={(e) => setUserPopoverAnchorEl(e.currentTarget)}
                          InputProps={{
                            readOnly: true,
                            endAdornment: <ExpandMoreIcon style={{ color: '#036dda', cursor: 'pointer' }} />,
                            style: { cursor: 'pointer', fontWeight: 400 }
                          }}
                          InputLabelProps={{
                            shrink: targetUsers.length > 0 || Boolean(userPopoverAnchorEl),
                            style: { fontWeight: 400 }
                          }}
                        />
                      </div>
                    )}
                  </div>
                  {!allDay && (
                    <div className="dashboard-calendar-add-popover-time-row" style={{ display: 'flex', gap: '16px', marginTop: '16px' }}>
                      <div style={{ flex: 1 }}>
                        <TextField
                          fullWidth
                          id="popover-start-time"
                          label="Start Time"
                          variant="outlined"
                          type="time"
                          value={formatTimeInputValue(startTime, "09:00")}
                          onChange={(e) => setStartTime(e.target.value)}
                          InputLabelProps={{
                            shrink: true,
                            style: { color: '#036dda', fontWeight: 600 }
                          }}
                          inputProps={{
                            step: 300,
                          }}
                          size="small"
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <TextField
                          fullWidth
                          id="popover-end-time"
                          label="End Time"
                          variant="outlined"
                          type="time"
                          value={formatTimeInputValue(endTime, "18:00")}
                          onChange={(e) => setEndTime(e.target.value)}
                          InputLabelProps={{
                            shrink: true,
                            style: { color: '#036dda', fontWeight: 600 }
                          }}
                          inputProps={{
                            step: 300,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
            {addTab !== "event" && addTab !== "holiday" && addTab !== "leave" && addTab !== "timeEntry" && (
              <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSaveQuickEvent();
                  }}
                  style={{ textTransform: 'none', borderRadius: '8px', fontWeight: 700, padding: '6px 20px', background: '#036dda' }}
                >
                  {addPopover.mode === "edit" ? "Update" : "Save"}
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseAddPopover}
                  style={{ textTransform: 'none', borderRadius: '8px', fontWeight: 600, color: '#036dda', borderColor: '#036dda', background: '#f8fafc' }}
                >
                  Cancel
                </Button>
              </div>
            )}
          </div>
        </Popover>

        <Popover
          open={Boolean(userPopoverAnchorEl)}
          anchorEl={userPopoverAnchorEl}
          onClose={() => { setUserPopoverAnchorEl(null); setUserSearchQuery(""); }}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          disableScrollLock
          PaperProps={{ style: { borderRadius: '12px', overflow: 'hidden', minWidth: '240px', marginTop: '4px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)' } }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: '240px' }}>
            <div style={{ backgroundColor: '#036dda', padding: '12px 14px' }}>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: '0.95rem', marginBottom: '10px' }}>Select User</div>
              <div style={{ position: 'relative' }}>
                <SearchIcon style={{ position: 'absolute', left: '8px', top: '50%', transform: 'translateY(-50%)', color: '#036dda', fontSize: '18px' }} />
                <input 
                  type="text" 
                  placeholder="Search users..." 
                  value={userSearchQuery}
                  onChange={(e) => setUserSearchQuery(e.target.value)}
                  style={{ width: '100%', padding: '6px 8px 6px 32px', borderRadius: '20px', border: 'none', outline: 'none', fontSize: '14px', boxSizing: 'border-box' }}
                />
              </div>
            </div>
            <div style={{ maxHeight: '240px', overflowY: 'auto', padding: '8px 0', backgroundColor: '#fff' }}>
              <div 
                style={{ display: 'flex', alignItems: 'center', padding: '6px 14px', cursor: 'pointer' }}
                onClick={() => {
                  if (targetUsers.length === (allUsers || []).length && (allUsers || []).length > 0) {
                    setTargetUsers([]);
                  } else {
                    setTargetUsers((allUsers || []).map(u => ({ value: u.id, label: (u.firstName ? `${u.firstName} ${u.lastName || ''}` : (u.name || u.email || `User ${u.id}`)).trim() })));
                  }
                }}
              >
                <Checkbox 
                  checked={targetUsers.length === (allUsers || []).length && (allUsers || []).length > 0} 
                  size="small" 
                  style={{ padding: '0 8px 0 0', pointerEvents: 'none' }} 
                  color="primary"
                />
                <span style={{ fontSize: '14px', color: '#333', fontWeight: 600 }}>All Users</span>
              </div>
              
              {(allUsers && allUsers.length > 0 ? allUsers : targetUsers)
                .filter((u) => {
                  const uId = u.id ?? u.Id ?? u.userId ?? u.user_id ?? u.value;
                  const name = getUserDisplayName(u, uId);
                  return name.toLowerCase().includes(userSearchQuery.toLowerCase());
                })
                .map((u) => {
                  const uId = u.id ?? u.Id ?? u.userId ?? u.user_id ?? u.value;
                  const isChecked = targetUsers.some((t) => String(t.value ?? t.id ?? t) === String(uId));
                  const userName = getUserDisplayName(u, uId);
                  return (
                    <div 
                      key={uId}
                      style={{ display: 'flex', alignItems: 'center', padding: '6px 14px', cursor: 'pointer' }}
                      onClick={() => {
                        if (isChecked) {
                          setTargetUsers(targetUsers.filter((t) => String(t.value ?? t.id ?? t) !== String(uId)));
                        } else {
                          setTargetUsers([...targetUsers, { value: uId, label: userName }]);
                        }
                      }}
                    >
                      <Checkbox 
                        checked={isChecked} 
                        size="small" 
                        style={{ padding: '0 8px 0 0', pointerEvents: 'none' }} 
                        color="primary"
                      />
                      <span style={{ fontSize: '14px', color: '#333' }}>{userName}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        </Popover>

        <Dialog
          open={Boolean(viewInfoModal.open)}
          onClose={() => setViewInfoModal({ open: false, event: null })}
          disableScrollLock
          maxWidth="sm"
          fullWidth
          PaperProps={{
            className: "dashboard-calendar-info-dialog",
            style: {
              borderRadius: "16px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              width: "600px",
              minHeight: "360px",
              overflow: "hidden"
            }
          }}
        >
          {viewInfoModal.event && (() => {
            const evt = viewInfoModal.event;
            const resource = evt.resource || evt || {};
            const title = getFormattedTitleWithCategory(evt);
            let rawCat = String(evt.category || resource.Category || resource.category || "Meeting").toLowerCase();
            if (rawCat === "calendar") {
              rawCat = "meeting";
            }
            let categoryLabel = "Meeting";
            if (rawCat === "leave") {
              categoryLabel = "Leave";
            } else if (rawCat === "birthday" || rawCat === "bday") {
              categoryLabel = "Birthday";
            } else {
              categoryLabel = "Meeting";
            }

            const audit = getEventAuditMetadata(evt, allUsers);
            const targetUsersList = resolveTargetUsersForEdit(resource, allUsers);

            let rawDesc =
              resource.Description ||
              resource.description ||
              resource.details ||
              resource.eventDetails ||
              resource.event_details ||
              resource.reason ||
              resource.note ||
              resource.notes ||
              resource.comment ||
              resource.comments ||
              evt.description ||
              evt.details ||
              "";

            if (!rawDesc) {
              try {
                const storedStr = typeof localStorage !== "undefined" ? localStorage.getItem("hrms_updated_dashboard_calendar_items") : null;
                if (storedStr) {
                  const storedObj = JSON.parse(storedStr);
                  const eventId = resource.id || resource.calendar_event_id || viewInfoModal.event.id || resource.SourceId;
                  const rawTitleStr = String(resource.title || resource.Subject || viewInfoModal.event.title || "");
                  const titleKey = rawTitleStr.replace(/^(meeting|title|reminder|calendar|event|holiday|leave|birthday|bday)\s*[-:]\s*/i, "").trim().toLowerCase();

                  for (const key in storedObj) {
                    const item = storedObj[key];
                    if (item && (item.description || item.Description || item.details)) {
                      const storedTitle = String(item.title || item.Subject || item.name || "").replace(/^(meeting|title|reminder|calendar|event|holiday|leave|birthday|bday)\s*[-:]\s*/i, "").trim().toLowerCase();
                      if ((eventId && key.includes(String(eventId))) || (titleKey && titleKey.length > 2 && (key.toLowerCase().includes(titleKey) || storedTitle.includes(titleKey)))) {
                        rawDesc = item.description || item.Description || item.details;
                        break;
                      }
                    }
                  }
                }
              } catch (e) {
                // ignore
              }
            }

            if (!rawDesc && Array.isArray(events)) {
              const eventId = resource.id || resource.calendar_event_id || viewInfoModal.event.id || resource.SourceId;
              const rawTitleStr = String(resource.title || resource.Subject || viewInfoModal.event.title || "");
              const titleKey = rawTitleStr.replace(/^(meeting|title|reminder|calendar|event|holiday|leave|birthday|bday)\s*[-:]\s*/i, "").trim().toLowerCase();
              for (const item of events) {
                const r = item?.resource || item || {};
                const itemDesc = r.description || r.Description || r.details || item?.description || item?.Description;
                if (itemDesc) {
                  const rId = r.id || r.calendar_event_id || item.id || r.SourceId;
                  const rTitle = String(r.title || r.Subject || item.title || "").replace(/^(meeting|title|reminder|calendar|event|holiday|leave|birthday|bday)\s*[-:]\s*/i, "").trim().toLowerCase();
                  if ((eventId && String(rId) === String(eventId)) || (titleKey && titleKey.length > 2 && rTitle === titleKey)) {
                    rawDesc = itemDesc;
                    break;
                  }
                }
              }
            }

            const cleanDesc = (() => {
              if (!rawDesc) return "";
              let str = String(rawDesc).trim();
              // Strip internal metadata tags like [category:meeting], [targets:87,86,85,84]
              str = str.replace(/\[[^\]]*:[^\]]*\]/gi, "");
              // Strip HTML tags if any
              str = str.replace(/<[^>]*>?/gm, "");
              // Collapse multiple empty newlines
              str = str.replace(/\n\s*\n/g, "\n").trim();
              if (str === "N/A" || str === "null" || str === "undefined") return "";
              return str;
            })();

            const dateStr = formatEventTooltip(evt);
            const isLeave = rawCat === "leave";
            const noOfDays = isLeave ? getLeaveEventNoOfDays(evt) : null;
            const leaveStatus = resource.LeaveStatus || resource.leaveStatus || resource.Status || resource.status || null;
            const employeeName =
              resource.EmployeeName ||
              resource.employeeName ||
              resource.created_by_name ||
              resource.createdByName ||
              audit.createdBy ||
              "Employee";
            const leaveType =
              resource.LeaveType ||
              resource.leaveType ||
              resource.leave_type ||
              resource.type ||
              "Loss Of Pay";

            const leaveCreatedOnFormatted = (() => {
              const rawCreated = resource.created_at || resource.createdAt || resource.created_date;
              if (rawCreated) {
                const m = moment(rawCreated);
                if (m.isValid()) {
                  return m.format("DD-MM-YYYY hh:mm A");
                }
              }
              return audit.createdAt;
            })();

            const leaveDateRangeFormatted = (() => {
              const dr = resource.date_range || resource.dateRange;
              if (dr && typeof dr === "string" && (dr.includes(" to ") || dr.includes(" To "))) {
                let startDate = "", endDate = "";
                if (dr.includes(" to ")) {
                  [startDate, endDate] = dr.split(" to ");
                } else {
                  [startDate, endDate] = dr.split(" To ");
                }
                const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "");
                const firstType = resource.firstleavetype || resource.first_leave_type || "First-half";
                const secondType = resource.secondleavetype || resource.second_leave_type || "Second-half";
                return `${startDate} (${capitalize(firstType)}) To ${endDate} (${capitalize(secondType)})`;
              }
              const startRaw = resource.from_date || resource.start_date || resource.from || evt.start;
              const endRaw = resource.to_date || resource.end_date || resource.to || evt.end || startRaw;
              const sDate = startRaw ? moment(startRaw).format("DD-MM-YYYY") : "";
              const eDate = endRaw ? moment(endRaw).format("DD-MM-YYYY") : sDate;
              const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "");
              const firstType = resource.firstleavetype || resource.first_leave_type || "First-half";
              const secondType = resource.secondleavetype || resource.second_leave_type || "Second-half";
              if (sDate && eDate) {
                return `${sDate} (${capitalize(firstType)}) To ${eDate} (${capitalize(secondType)})`;
              }
              return dateStr;
            })();

            return (
              <>
                <DialogTitle
                  style={{
                    textAlign: "center",
                    padding: "12px 24px",
                    background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)",
                    color: "#fff",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    position: "relative"
                  }}
                >
                  {categoryLabel === "Meeting" ? "Meeting Details" : categoryLabel === "Leave" ? "Leave Details" : `${categoryLabel} Details`}
                  <CloseIcon
                    style={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      cursor: "pointer",
                      color: "#fff",
                    }}
                    onClick={() => setViewInfoModal({ open: false, event: null })}
                  />
                </DialogTitle>

                <DialogContent style={{ padding: isLeave ? "20px 24px" : "14px 18px" }}>
                  {isLeave ? (
                    /* Leave Details Table - Exact 1-to-1 Match with Ticket.js (Leaves Ticket Module) */
                    <>
                      <div>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <tbody>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Name</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{employeeName}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Leave Type</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{leaveType}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Created On</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{leaveCreatedOnFormatted}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Reason for Leave</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", wordBreak: "break-word" }}>{cleanDesc || "N/A"}</td>
                            </tr>
                            {resource.cancel_reason && (
                              <tr>
                                <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Reason for Declined</b></td>
                                <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                                <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{resource.cancel_reason}</td>
                              </tr>
                            )}
                            {resource.c_reason && (
                              <tr>
                                <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Reason for Cancelled</b></td>
                                <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                                <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{resource.c_reason}</td>
                              </tr>
                            )}
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Date Range</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", whiteSpace: "nowrap" }}>{leaveDateRangeFormatted}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>No Of Days</b></td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{noOfDays !== null && noOfDays !== undefined ? noOfDays : 1}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: "8px" }}><b>Status</b></td>
                              <td style={{ padding: "8px", textAlign: "center" }}>:</td>
                              <td style={{ padding: "8px" }}>{leaveStatus || "Pending"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {isAdmin && leaveStatus && (leaveStatus.toLowerCase().includes("pending") || (!leaveStatus.toLowerCase().includes("approved") && !leaveStatus.toLowerCase().includes("declin") && !leaveStatus.toLowerCase().includes("cancel"))) && (
                        <div
                          style={{
                            display: "flex",
                            justify: "flex-end",
                            marginTop: "16px",
                            width: "100%",
                            marginBottom: "10px"
                          }}
                        >
                          <Tooltip title="Approve">
                            <Button
                              onClick={() => {
                                const leaveId = getEventDeleteMeta(evt.resource, "leave")?.id || evt.resource?.id;
                                setViewInfoModal({ open: false, event: null });
                                if (typeof onUpdateLeaveStatus === "function" && leaveId) {
                                  onUpdateLeaveStatus(leaveId, "Approved");
                                }
                              }}
                              variant="contained"
                              className="common-action-button"
                              style={{
                                margin: "5px",
                                textTransform: "none",
                                background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)",
                                color: "white",
                                borderRadius: "8px",
                                fontWeight: 600,
                                fontStyle: "italic"
                              }}
                            >
                              Approve
                            </Button>
                          </Tooltip>
                          <Tooltip title="Declined">
                            <Button
                              onClick={() => {
                                const leaveId = getEventDeleteMeta(evt.resource, "leave")?.id || evt.resource?.id;
                                setViewInfoModal({ open: false, event: null });
                                if (typeof onUpdateLeaveStatus === "function" && leaveId) {
                                  onUpdateLeaveStatus(leaveId, "Declined");
                                }
                              }}
                              variant="contained"
                              style={{
                                margin: "5px",
                                textTransform: "none",
                                backgroundColor: "#dc3545",
                                color: "#ffffff",
                                borderRadius: "8px",
                                fontWeight: 600,
                                fontStyle: "italic"
                              }}
                            >
                              Declined
                            </Button>
                          </Tooltip>
                        </div>
                      )}
                    </>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                      {/* Top Header Card */}
                      <div className="dashboard-calendar-info-card-header" style={{ padding: "10px 14px" }}>
                        <div
                          className="dashboard-calendar-info-meeting-name"
                          style={{ background: "transparent", backgroundColor: "transparent", padding: 0, fontSize: "1.05rem", fontWeight: 700 }}
                        >
                          {title}
                        </div>
                        <div className="dashboard-calendar-info-date-row">
                          <ScheduleIcon style={{ fontSize: "15px", color: "#036dda" }} />
                          <span>{dateStr}</span>
                        </div>
                      </div>

                      {/* Creation & Update Info - Separate Lines */}
                      <div className="dashboard-calendar-info-section" style={{ padding: "10px 14px", display: "flex", flexDirection: "column", gap: "6px" }}>
                        <div className="dashboard-calendar-info-audit-bar" style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "0.82rem", color: "#475569" }}>
                          <AccountCircleIcon style={{ fontSize: "16px", color: "#036dda", flexShrink: 0 }} />
                          <span><b>Created:</b> {audit.createdBy} ({audit.createdAt})</span>
                        </div>
                        {audit.isUpdated && (
                          <div className="dashboard-calendar-info-audit-bar" style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "0.82rem", color: "#475569" }}>
                            <EditOutlinedIcon style={{ fontSize: "15px", color: "#036dda", flexShrink: 0 }} />
                            <span><b>Updated:</b> {audit.updatedBy || "Admin"}{audit.updatedAt && audit.updatedAt !== "N/A" ? ` (${audit.updatedAt})` : ""}</span>
                          </div>
                        )}
                      </div>

                      {/* Assigned Participants */}
                      {targetUsersList && targetUsersList.length > 0 && (
                        <div className="dashboard-calendar-info-section" style={{ padding: "8px 12px" }}>
                          <div className="dashboard-calendar-info-section-title">
                            <PeopleIcon style={{ fontSize: "16px", color: "#036dda" }} />
                            <span>Assigned Participants ({targetUsersList.length})</span>
                          </div>
                          <div
                            className="dashboard-calendar-info-select-dropdown-box"
                            onClick={(e) => setViewUserPopoverAnchorEl(e.currentTarget)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              border: "1px solid #cbd5e1",
                              borderRadius: "8px",
                              padding: "8px 12px",
                              backgroundColor: "#ffffff",
                              cursor: "pointer",
                              marginTop: "6px",
                              userSelect: "none"
                            }}
                          >
                            <span style={{ fontSize: "0.88rem", color: "#1e293b", fontWeight: 500 }}>
                              {targetUsersList.length === (allUsers || []).length && (allUsers || []).length > 0
                                ? "All Users"
                                : `${targetUsersList.length} User${targetUsersList.length > 1 ? "s" : ""} Selected`}
                            </span>
                            <ArrowDropDownIcon style={{ color: "#036dda", flexShrink: 0, fontSize: "24px" }} />
                          </div>
                        </div>
                      )}

                      {/* Description - View Only */}
                      {cleanDesc && (
                        <div className="dashboard-calendar-info-section" style={{ padding: "10px 12px" }}>
                          <div className="dashboard-calendar-info-section-title" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <InfoOutlinedIcon style={{ fontSize: "16px", color: "#036dda" }} />
                            <span style={{ fontWeight: 600, fontSize: "0.88rem" }}>Description</span>
                          </div>
                          <div
                            className="dashboard-calendar-info-desc-box"
                            style={{
                              marginTop: "6px",
                              padding: "10px 12px",
                              borderRadius: "8px",
                              border: "1px solid #cbd5e1",
                              backgroundColor: "#ffffff",
                              fontSize: "0.88rem",
                              color: "#334155",
                              wordBreak: "break-word",
                              whiteSpace: "pre-wrap",
                              userSelect: "text"
                            }}
                          >
                            {renderTextWithLinks(cleanDesc)}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </DialogContent>

                {!isLeave && (
                  <DialogActions className="dashboard-calendar-info-dialog-actions">
                    <Button
                      variant="contained"
                      onClick={() => setViewInfoModal({ open: false, event: null })}
                      style={{ background: "#036dda", color: "#fff", textTransform: "none", borderRadius: "8px", fontWeight: 600, padding: "6px 20px" }}
                    >
                      Close
                    </Button>
                  </DialogActions>
                )}
              </>
            );
          })()}
        </Dialog>

        <Popover
          open={Boolean(viewUserPopoverAnchorEl)}
          anchorEl={viewUserPopoverAnchorEl}
          onClose={() => { setViewUserPopoverAnchorEl(null); setViewUserSearchQuery(""); }}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          disableScrollLock
          PaperProps={{
            className: "dashboard-calendar-info-user-popover-paper",
            style: { borderRadius: '12px', overflow: 'hidden', minWidth: '250px', marginTop: '4px', boxShadow: '0 8px 24px rgba(0,0,0,0.18)' }
          }}
        >
          {(() => {
            if (!viewInfoModal.event) return null;
            const targetUsersList = resolveTargetUsersForEdit(viewInfoModal.event, allUsers, currentUserId);
            const isAllUsersSelected = targetUsersList.length === (allUsers || []).length && (allUsers || []).length > 0;

            return (
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: '250px' }}>
                <div style={{ backgroundColor: '#036dda', padding: '12px 14px' }}>
                  <div style={{ color: '#fff', fontWeight: 700, fontSize: '0.95rem', marginBottom: '10px' }}>Assigned Users</div>
                  <div style={{ position: 'relative' }}>
                    <SearchIcon style={{ position: 'absolute', left: '8px', top: '50%', transform: 'translateY(-50%)', color: '#036dda', fontSize: '18px' }} />
                    <input 
                      type="text" 
                      placeholder="Search users..." 
                      value={viewUserSearchQuery}
                      onChange={(e) => setViewUserSearchQuery(e.target.value)}
                      style={{ width: '100%', padding: '6px 8px 6px 32px', borderRadius: '20px', border: 'none', outline: 'none', fontSize: '14px', boxSizing: 'border-box' }}
                    />
                  </div>
                </div>
                <div className="dashboard-calendar-info-user-popover-list" style={{ maxHeight: '240px', overflowY: 'auto', padding: '6px 0' }}>
                  {isAllUsersSelected && !viewUserSearchQuery && (
                    <div 
                      style={{ display: 'flex', alignItems: 'center', padding: '6px 14px', cursor: 'default' }}
                    >
                      <Checkbox 
                        checked={true} 
                        size="small" 
                        disabled
                        style={{ padding: '0 8px 0 0' }} 
                        color="primary"
                      />
                      <span style={{ fontSize: '14px', fontWeight: 600 }}>All Users</span>
                    </div>
                  )}
                  
                  {targetUsersList
                    .filter(u => {
                      if (!viewUserSearchQuery) return true;
                      const name = (u.firstName ? `${u.firstName} ${u.lastName || ''}` : (u.label || u.name || u.email || `User ${u.id || u.value}`)).toLowerCase();
                      return name.includes(viewUserSearchQuery.toLowerCase());
                    })
                    .map((u, idx) => {
                      const uId = String(u.id || u.value || u);
                      const uName = (u.firstName ? `${u.firstName} ${u.lastName || ''}` : (u.label || u.name || u.email || `User ${uId}`)).trim();

                      return (
                        <div 
                          key={idx}
                          style={{ display: 'flex', alignItems: 'center', padding: '6px 14px', cursor: 'default' }}
                        >
                          <Checkbox 
                            checked={true} 
                            size="small" 
                            disabled
                            style={{ padding: '0 8px 0 0' }} 
                            color="primary"
                          />
                          <span style={{ fontSize: '14px', fontWeight: 600 }}>
                            {uName}
                          </span>
                        </div>
                      );
                    })
                  }
                  {targetUsersList.length === 0 && (
                    <div style={{ padding: '10px 14px', fontSize: '13px', color: '#64748b' }}>
                      No assigned users found.
                    </div>
                  )}
                </div>
              </div>
            );
          })()}
        </Popover>

        {/* Direct Checkbox Popover - Right below Filter button with Leave module aesthetics */}
        <Popover
          open={Boolean(categoryFilterAnchorPosition)}
          anchorReference="anchorPosition"
          anchorPosition={categoryFilterAnchorPosition || { top: 0, left: 0 }}
          onClose={handleCloseFilterMenu}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          disableScrollLock
          PaperProps={{
            className: "dashboard-calendar-filter-popover-paper",
            style: {
              borderRadius: "14px",
              padding: 0,
              minWidth: "270px",
              maxWidth: "320px",
              boxShadow: "0 10px 30px rgba(3, 109, 218, 0.2)",
              overflow: "hidden",
            },
          }}
        >
          <div className="dashboard-calendar-filter-menu" style={{ display: "flex", flexDirection: "column" }}>
            {/* Header matching Leave Tickets gradient */}
            <div
              style={{
                background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ color: "#ffffff", fontWeight: 700, fontSize: "0.95rem" }}>
                Filter Calendar Items
              </span>
              <button
                type="button"
                onClick={() => {
                  const isAll =
                    categoryFilters.leave &&
                    categoryFilters.meeting &&
                    categoryFilters.reminder &&
                    categoryFilters.upcoming &&
                    categoryFilters.holiday &&
                    categoryFilters.timeentry &&
                    categoryFilters.birthday;

                  if (isAll) {
                    setCategoryFilters({
                      reminder: false,
                      meeting: false,
                      upcoming: false,
                      holiday: false,
                      leave: false,
                      leaveStatuses: { pending: false, approved: false, unapproved: false, declined: false, cancelled: false },
                      timeentry: false,
                      birthday: false,
                    });
                  } else {
                    setCategoryFilters({
                      reminder: true,
                      meeting: true,
                      upcoming: true,
                      holiday: true,
                      leave: true,
                      leaveStatuses: { pending: true, approved: true, unapproved: true, declined: true, cancelled: true },
                      timeentry: true,
                      birthday: true,
                    });
                  }
                }}
                style={{
                  background: "none",
                  border: "none",
                  color: "#ffffff",
                  fontWeight: 600,
                  fontSize: "0.82rem",
                  cursor: "pointer",
                  padding: 0,
                  textDecoration: "none",
                  outline: "none",
                }}
              >
                {categoryFilters.leave && categoryFilters.meeting && categoryFilters.reminder && categoryFilters.upcoming && categoryFilters.holiday && categoryFilters.timeentry && categoryFilters.birthday ? "Clear All" : "Select All"}
              </button>
            </div>

            {/* Checkboxes List styled like MenuItem / Leave Module */}
            <div className="dashboard-calendar-filter-list" style={{ display: "flex", flexDirection: "column", gap: "2px", padding: "10px 14px 20px 14px", maxHeight: "430px", overflowY: "auto" }}>
              {/* Leave Category */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label className="dashboard-calendar-filter-label" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.88rem", fontWeight: 600, padding: "4px 0" }}>
                  <Checkbox
                    size="small"
                    checked={Boolean(categoryFilters.leave)}
                    onChange={(e) => {
                      const val = e.target.checked;
                      setCategoryFilters((prev) => ({
                        ...prev,
                        leave: val,
                        leaveStatuses: {
                          pending: val,
                          approved: val,
                          unapproved: val,
                          declined: val,
                          cancelled: val,
                        },
                      }));
                    }}
                    color="primary"
                    style={{ padding: "4px" }}
                  />
                  Leave
                </label>
                <div style={{ marginLeft: "28px", display: "flex", flexDirection: "column", gap: "1px" }}>
                  <label className="dashboard-calendar-filter-sublabel" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.83rem", fontWeight: 500 }}>
                    <Checkbox
                      size="small"
                      checked={Boolean(categoryFilters.leaveStatuses?.approved)}
                      onChange={(e) => {
                        const val = e.target.checked;
                        setCategoryFilters((prev) => {
                          const updated = { ...(prev.leaveStatuses || {}), approved: val };
                          return { ...prev, leave: Object.values(updated).some(Boolean), leaveStatuses: updated };
                        });
                      }}
                      color="primary"
                      style={{ padding: "2px 6px" }}
                    />
                    Approved
                  </label>
                  <label className="dashboard-calendar-filter-sublabel" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.83rem", fontWeight: 500 }}>
                    <Checkbox
                      size="small"
                      checked={Boolean(categoryFilters.leaveStatuses?.pending)}
                      onChange={(e) => {
                        const val = e.target.checked;
                        setCategoryFilters((prev) => {
                          const updated = { ...(prev.leaveStatuses || {}), pending: val };
                          return { ...prev, leave: Object.values(updated).some(Boolean), leaveStatuses: updated };
                        });
                      }}
                      color="primary"
                      style={{ padding: "2px 6px" }}
                    />
                    Pending
                  </label>
                  <label className="dashboard-calendar-filter-sublabel" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.83rem", fontWeight: 500 }}>
                    <Checkbox
                      size="small"
                      checked={Boolean(categoryFilters.leaveStatuses?.unapproved)}
                      onChange={(e) => {
                        const val = e.target.checked;
                        setCategoryFilters((prev) => {
                          const updated = { ...(prev.leaveStatuses || {}), unapproved: val };
                          return { ...prev, leave: Object.values(updated).some(Boolean), leaveStatuses: updated };
                        });
                      }}
                      color="primary"
                      style={{ padding: "2px 6px" }}
                    />
                    Unapproved
                  </label>
                  <label className="dashboard-calendar-filter-sublabel" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.83rem", fontWeight: 500 }}>
                    <Checkbox
                      size="small"
                      checked={Boolean(categoryFilters.leaveStatuses?.declined)}
                      onChange={(e) => {
                        const val = e.target.checked;
                        setCategoryFilters((prev) => {
                          const updated = { ...(prev.leaveStatuses || {}), declined: val };
                          return { ...prev, leave: Object.values(updated).some(Boolean), leaveStatuses: updated };
                        });
                      }}
                      color="primary"
                      style={{ padding: "2px 6px" }}
                    />
                    Declined
                  </label>
                  <label className="dashboard-calendar-filter-sublabel" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.83rem", fontWeight: 500 }}>
                    <Checkbox
                      size="small"
                      checked={Boolean(categoryFilters.leaveStatuses?.cancelled)}
                      onChange={(e) => {
                        const val = e.target.checked;
                        setCategoryFilters((prev) => {
                          const updated = { ...(prev.leaveStatuses || {}), cancelled: val };
                          return { ...prev, leave: Object.values(updated).some(Boolean), leaveStatuses: updated };
                        });
                      }}
                      color="primary"
                      style={{ padding: "2px 6px" }}
                    />
                    Cancelled
                  </label>
                </div>
              </div>

              {/* Meeting */}
              <label className="dashboard-calendar-filter-label" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.88rem", fontWeight: 600, padding: "4px 0" }}>
                <Checkbox
                  size="small"
                  checked={Boolean(categoryFilters.meeting)}
                  onChange={(e) => {
                    const val = e.target.checked;
                    setCategoryFilters((prev) => ({ ...prev, meeting: val }));
                  }}
                  color="primary"
                  style={{ padding: "4px" }}
                />
                Meeting
              </label>

              {/* Todo Reminder */}
              <label className="dashboard-calendar-filter-label" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.88rem", fontWeight: 600, padding: "4px 0" }}>
                <Checkbox
                  size="small"
                  checked={Boolean(categoryFilters.reminder)}
                  onChange={(e) => {
                    const val = e.target.checked;
                    setCategoryFilters((prev) => ({ ...prev, reminder: val }));
                  }}
                  color="primary"
                  style={{ padding: "4px" }}
                />
                Todo Reminder
              </label>

              {/* Upcoming Event */}
              <label className="dashboard-calendar-filter-label" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.88rem", fontWeight: 600, padding: "4px 0" }}>
                <Checkbox
                  size="small"
                  checked={Boolean(categoryFilters.upcoming)}
                  onChange={(e) => {
                    const val = e.target.checked;
                    setCategoryFilters((prev) => ({ ...prev, upcoming: val }));
                  }}
                  color="primary"
                  style={{ padding: "4px" }}
                />
                Upcoming Event
              </label>

              {/* Holiday */}
              <label className="dashboard-calendar-filter-label" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.88rem", fontWeight: 600, padding: "4px 0" }}>
                <Checkbox
                  size="small"
                  checked={Boolean(categoryFilters.holiday)}
                  onChange={(e) => {
                    const val = e.target.checked;
                    setCategoryFilters((prev) => ({ ...prev, holiday: val }));
                  }}
                  color="primary"
                  style={{ padding: "4px" }}
                />
                Holiday
              </label>

              {/* Time Entry */}
              <label className="dashboard-calendar-filter-label" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.88rem", fontWeight: 600, padding: "4px 0" }}>
                <Checkbox
                  size="small"
                  checked={Boolean(categoryFilters.timeentry)}
                  onChange={(e) => {
                    const val = e.target.checked;
                    setCategoryFilters((prev) => ({ ...prev, timeentry: val }));
                  }}
                  color="primary"
                  style={{ padding: "4px" }}
                />
                Time Entry
              </label>

              {/* Birthday */}
              <label className="dashboard-calendar-filter-label" style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "0.88rem", fontWeight: 600, padding: "4px 0" }}>
                <Checkbox
                  size="small"
                  checked={Boolean(categoryFilters.birthday)}
                  onChange={(e) => {
                    const val = e.target.checked;
                    setCategoryFilters((prev) => ({ ...prev, birthday: val }));
                  }}
                  color="primary"
                  style={{ padding: "4px" }}
                />
                Birthday
              </label>
            </div>
          </div>
        </Popover>
        {/* Time Entry Details Modal - Matching Check.js (Screenshot 3) */}
        {timeEntryDetailsModal.open && timeEntryDetailsModal.data && (() => {
          const data = timeEntryDetailsModal.data;
          const empId = data.name || data.emp_id || data.employee_id || data.name_id || "N/A";
          const empName = data.Name || data.userName || data.user_name || data.employee_name || getEventTitleValue(data) || "N/A";
          const itemDate = data.date || data.date_display || (data.start ? moment(data.start).format("DD-MM-YYYY") : "N/A");
          const inTime = data.in_time || (data.StartTime ? moment(data.StartTime, ["YYYY-MM-DD HH:mm:ss", "HH:mm:ss"]).format("HH:mm:ss") : "09:00:00");
          const outTime = data.out_time || (data.EndTime ? moment(data.EndTime, ["YYYY-MM-DD HH:mm:ss", "HH:mm:ss"]).format("HH:mm:ss") : "18:00:00");
          const duration = data.duration || data.hours || "09:00:00";
          const reasonText = data.reason || data.entry_reason || data.description || data.Description || data.details || "";
          const rejectRemark = data.remark || data.rejection_remark || data.reject_remark || "";

          const popCat = getEventCategoryKey(data);
          const rawStatus = String(data.is_approved ?? data.isApproved ?? data.Status ?? data.status ?? "").toLowerCase().trim();
          const isPending = popCat === "Time Entry - Pending" || (rawStatus !== "0" && rawStatus !== "2" && !rawStatus.includes("approved") && !rawStatus.includes("reject") && !rawStatus.includes("declin"));
          const timeEntryId = data.id || data.calendar_event_id || data.eventId || data.SourceId;

          const handleApproveAction = () => {
            const user = ls("user");
            const userName = `${user?.firstName || 'Admin'} ${user?.lastName || ''}`.trim();

            swal({
              title: "Are you sure?",
              text: "Do you want to approve this entry?",
              icon: "warning",
              buttons: ["Cancel", "Yes"],
            }).then(async (confirm) => {
              if (confirm) {
                setTimeEntryDetailsModal({ open: false, data: null });

                swal({
                  title: "Approving Time Entry...",
                  content: createSwalLoaderNode ? createSwalLoaderNode() : null,
                  buttons: false,
                  closeOnClickOutside: false,
                  closeOnEsc: false,
                });

                let res = await AuthApi.approveTime({ is_approved: "0", userName }, timeEntryId);
                if (res && res.status === true) {
                  window.dispatchEvent(
                    new CustomEvent("cherrypik_new_notification", {
                      detail: {
                        title: "Time-Entry Status",
                        message: `Your time entry was approved by ${userName}.`,
                        type: "Time-Entry Status",
                        actorId: user?.id || user?.Id,
                      },
                    })
                  );
                  window.dispatchEvent(new Event("cherrypik_refresh_notifications"));
                  if (typeof onRangeChange === "function") {
                    onRangeChange();
                  }
                  if (typeof onUpdateLeaveStatus === "function") {
                    onUpdateLeaveStatus(timeEntryId, "Approved");
                  }
                  swal("Done!", "You have approved the entry!", "success");
                } else {
                  swal("Error!", "There was an error approving the entry.", "error");
                }
              }
            });
          };

          const handleRejectAction = async () => {
            const user = ls("user");
            const userName = `${user?.firstName || 'Admin'} ${user?.lastName || ''}`.trim();
            handleCloseEventDetailsPopover();
            setTimeEntryDetailsModal({ open: false, data: null });
            const rejectionRemark = await promptRejectionRemark("Reject Time Entry");

            if (rejectionRemark) {

              swal({
                title: "Rejecting Time Entry...",
                content: createSwalLoaderNode ? createSwalLoaderNode() : null,
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false,
              });

              let res = await AuthApi.approveTime({ is_approved: "2", userName, remark: rejectionRemark }, timeEntryId);
              if (res && res.status === true) {
                window.dispatchEvent(
                  new CustomEvent("cherrypik_new_notification", {
                    detail: {
                      title: "Time-Entry Status",
                      message: `Your time entry was rejected by ${userName}.`,
                      type: "Time-Entry Status",
                      actorId: user?.id || user?.Id,
                    },
                  })
                );
                window.dispatchEvent(new Event("cherrypik_refresh_notifications"));
                if (typeof onRangeChange === "function") {
                  onRangeChange();
                }
                if (typeof onUpdateLeaveStatus === "function") {
                  onUpdateLeaveStatus(timeEntryId, "Declined");
                }
                swal("Done!", "You have rejected the entry!", "success");
              } else {
                swal("Error!", "There was an error rejecting the entry.", "error");
              }
            }
          };

          return (
            <Dialog
              open={timeEntryDetailsModal.open}
              onClose={() => setTimeEntryDetailsModal({ open: false, data: null })}
              disableScrollLock={true}
              maxWidth="xs"
              fullWidth
              PaperProps={{
                style: {
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                },
              }}
            >
              <DialogTitle
                style={{
                  textAlign: "center",
                  background: "linear-gradient(180deg, var(--hrms-primary-blue-start, #036dda) 0%, var(--hrms-primary-blue-end, #036dda) 100%)",
                  color: "#fff",
                  padding: "10px",
                  fontWeight: 700,
                  fontSize: "1.05rem",
                  borderTopLeftRadius: "8px",
                  borderTopRightRadius: "8px",
                  position: "relative",
                }}
              >
                Time Entry Details
                <CloseIcon
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    cursor: "pointer",
                    color: "#fff",
                    width: 24,
                    height: 24,
                  }}
                  onClick={() => setTimeEntryDetailsModal({ open: false, data: null })}
                />
              </DialogTitle>
              <DialogContent style={{ paddingTop: "14px", paddingBottom: "16px" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.88rem" }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd", width: "35%" }}><b>Employee ID</b></td>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center", width: "5%" }}>:</td>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{empId}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Name</b></td>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{empName}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Date</b></td>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{itemDate}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>In Time</b></td>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{inTime}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}><b>Out Time</b></td>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>:</td>
                      <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{outTime}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: "8px", borderBottom: reasonText || rejectRemark ? "1px solid #ddd" : "none" }}><b>Duration</b></td>
                      <td style={{ padding: "8px", borderBottom: reasonText || rejectRemark ? "1px solid #ddd" : "none", textAlign: "center" }}>:</td>
                      <td style={{ padding: "8px", borderBottom: reasonText || rejectRemark ? "1px solid #ddd" : "none" }}>{duration}</td>
                    </tr>
                    {reasonText ? (
                      <tr>
                        <td style={{ padding: "8px", borderBottom: rejectRemark ? "1px solid #ddd" : "none" }}><b>Reason</b></td>
                        <td style={{ padding: "8px", borderBottom: rejectRemark ? "1px solid #ddd" : "none", textAlign: "center" }}>:</td>
                        <td style={{ padding: "8px", borderBottom: rejectRemark ? "1px solid #ddd" : "none" }}>{reasonText}</td>
                      </tr>
                    ) : null}
                    {rejectRemark ? (
                      <tr>
                        <td style={{ padding: "8px" }}><b>Reject Remark</b></td>
                        <td style={{ padding: "8px", textAlign: "center" }}>:</td>
                        <td style={{ padding: "8px" }}>{rejectRemark}</td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>

                {isAdmin && isPending && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px', gap: '8px' }}>
                    <Button
                      variant="contained"
                      size="small"
                      style={{ backgroundColor: "#036dda", color: "#ffffff", fontWeight: 600, textTransform: "none" }}
                      onClick={handleApproveAction}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      style={{ backgroundColor: "#db3535", color: "#ffffff", fontWeight: 600, textTransform: "none" }}
                      onClick={handleRejectAction}
                    >
                      Reject
                    </Button>
                  </div>
                )}
              </DialogContent>
            </Dialog>
          );
        })()}
      </CardContent>
    </Card>
  );
};

export default DashboardCalendar;




